(function () {
    "use strict";
    angular
        .module("BlurAdmin.pages", [
            "ui.router",
            "BlurAdmin.pages.dashboard",
            "BlurAdmin.pages.Document",
            "BlurAdmin.pages.Branch",
            "BlurAdmin.pages.Unit",
            "BlurAdmin.pages.Enumeration",
            "BlurAdmin.pages.Role",
            "BlurAdmin.pages.Menu",
            "BlurAdmin.pages.Privilege",
            "BlurAdmin.pages.User",
            "BlurAdmin.pages.Application",
            "BlurAdmin.pages.HistoryTracking",
        ])
        .service('baseConfig', function () {
            this.application_name = "Tracking Document";
            this.application_id = "7f2c27cf-8f9c-4018-9604-19c4b79c93b1";
            this.fe = "http://localhost:3002/";
            // this.fe = "https://backoffice.circle-pihc.com";
        })
        .config(routeConfig);
    /** @ngInject */
    function routeConfig(
        $urlRouterProvider,
        baSidebarServiceProvider,
        $localStorageProvider
    ) {
        // $urlRouterProvider.otherwise("/dashboard");
        $localStorageProvider.setKeyPrefix('TrackingDocument_');
    }
})();
/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme', [
      'toastr',
      'chart.js',
      'angular-chartist',
      'angular.morris-chart',
      'textAngular',
      'BlurAdmin.theme.components',
      'BlurAdmin.theme.inputs'
  ]);

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
 (function () {
    'use strict';
    angular.module('BlurAdmin.pages.Document', [])
        .factory('DocumentSvc', function ($http, config) {
            return {
                export: function (period, param1, param2) {
                    var url = config.api + "document?mode=export";
                    if (period == "Ranged Date") {
                        url = url + "&period=ranged&start-period=" + param1 + "&end-period=" + param2;
                    } else if (period == "Monthly") {
                        url = url + "&period=monthly&month=" + param1 + "&year=" + param2;
                    }
                    return $http({
                        url: url,
                        method: "GET",
                        headers: {
                            'Content-type': 'application/json'
                        },
                        responseType: 'arraybuffer'
                    });
                },
                //service
                getList: function (limit, offset, params) {
                    var url = config.api + "document";
                    var criteria = params.search.predicateObject == undefined ? "?criteria=" : '?criteria=' + config.paramsSearch(params);
                    var limit = '&limit=' + limit;
                    // var offset = '&page=' + parseInt(offset + 1);
                    var offset = '&page=' + offset;
                    var sort = params.sort.predicate == undefined ? "&sortBy=created_at:desc" : '&sortBy=created_at:desc,' + config.paramsSort(params);
                    var final = url + criteria + limit + offset + sort;
                    // console.log(final);
                    return $http.get(final);
                },
                create: function (data) {
                    var url = config.api + 'document';
                    if (typeof data.tmp_image_file == "object") {
                        var formData = new FormData();
                        data.image_file_url = undefined;
                        var filePhoto = data.tmp_image_file;
                        formData.append("file_image", filePhoto);
                        data = angular.toJson(data);
                        formData.append("model", data);
                        var head = {
                            transformRequest: angular.identity,
                            headers: {
                                'Content-Type': undefined
                            }
                        };
                        return $http.post(url, formData, head)
                    } else {
                        return $http.post(url, data)
                    }
                },
                delete: function (id) {
                    var url = config.api + 'document/?id=' + id;
                    return $http.delete(url);
                },
                update: function (data) {
                    var url = config.api + 'document/?_method=put';
                    if (typeof data.tmp_image_file == "object") {
                        var formData = new FormData();
                        data.image_file_url = undefined;
                        var filePhoto = data.tmp_image_file;
                        formData.append("file_image", filePhoto);
                        data = angular.toJson(data);
                        formData.append("model", data);
                        var head = {
                            transformRequest: angular.identity,
                            headers: {
                                'Content-Type': undefined
                            }
                        };
                        return $http.post(url, formData, head)
                    } else {
                        return $http.put(url, data)
                    }
                },
                getById: function (id) {
                    var url = config.api + 'document/?id=' + id
                    return $http.get(url)
                },
                getUnit: function (all) {
                    var url = config.api + 'unit'
                    if (all != undefined) {
                        url += "?mode=all";
                    }
                    return $http.get(url);
                },
                getBranch: function (unitId, all) {
                    var url = config.api + 'branch?criteria=unit_id:' + unitId
                    if (all != undefined) {
                        url += "&mode=all";
                    }
                    return $http.get(url);
                },
                getDocumentType: function () {
                    var url = config.api + 'enumeration?criteria=key:DocumentType&exactmatch=true';
                    return $http.get(url);
                },

            };
        })
        .config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('Document', {
                url: '/document',
                title: 'Document - List',
                templateUrl: 'app/pages/document/index.html',
                controller: 'DocumentCtrl',
            })
    }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.HistoryTracking', [])
        .factory('HistoryTrackingSvc', function ($http, config) {
            return {

                //service
                getList: function (limit, offset, params) {
                    var url = config.api + "tracking";
                    var criteria = params.search.predicateObject == undefined ? "?criteria=" : '?criteria=' + config.paramsSearch(params);
                    var limit = '&limit=' + limit;
                    // var offset = '&page=' + parseInt(offset + 1);
                    var offset = '&page=' + offset;
                    var sort = params.sort.predicate == undefined ? "&sortBy=created_at:desc" : '&sortBy=created_at:desc,' + config.paramsSort(params);
                    var final = url + criteria + limit + offset + sort;
                    // console.log(final);
                    return $http.get(final);
                },
            };
        })
        .config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('HistoryTracking', {
                url: '/history-tracking',
                title: 'History Tracking - List',
                templateUrl: 'app/pages/history-tracking/index.html',
                controller: 'HistoryTrackingCtrl',
            })
    }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('dashboard', {
          url: '/dashboard',
          templateUrl: 'app/pages/dashboard/dashboard.html',
          title: 'Dashboard'
        });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs', []);

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    'use strict';
    angular.module('BlurAdmin.pages.Enumeration', [])
        .factory('EnumerationSvc', function($http, config) {
            return {
                //service
                getList: function(limit, offset, params) {
                    var url = config.api + "enumeration";
                    var criteria = params.search.predicateObject == undefined ? "?criteria=" : '?criteria=' + config.paramsSearch(params);
                    var limit = '&limit=' + limit;
                    // var offset = '&page=' + parseInt(offset + 1);
                    var offset = '&page=' + offset;
                    var sort = params.sort.predicate == undefined ? "&sortBy=" : '&sortBy=' + config.paramsSort(params);
                    var final = url + criteria + limit + offset + sort;
                    // console.log(final);
                    return $http.get(final);
                },
                create: function(data) {
                    var url = config.api + 'enumeration';
                    return $http.post(url, data)
                },
                delete: function(id) {
                    var url = config.api + 'enumeration/?id=' + id;
                    return $http.delete(url);
                },
                update: function(data) {
                    var url = config.api + 'enumeration/';
                    return $http.put(url, data)
                },
                getById: function(id) {
                    var url = config.api + 'enumeration/?id=' + id
                    return $http.get(url)
                }
            };
        })
        .config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('Enumeration', {
                url: '/enumeration',
                title: 'Enumeration - List',
                templateUrl: 'app/pages/generalData/enumeration/index.html',
                controller: 'EnumerationCtrl',
            })
    }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    'use strict';
    angular.module('BlurAdmin.pages.Branch', [])
        .factory('BranchSvc', function($http, config) {
            return {
                //service
                getList: function(limit, offset, params) {
                    var url = config.api + "branch";
                    var criteria = params.search.predicateObject == undefined ? "?criteria=" : '?criteria=' + config.paramsSearch(params);
                    var limit = '&limit=' + limit;
                    // var offset = '&page=' + parseInt(offset + 1);
                    var offset = '&page=' + offset;
                    var sort = params.sort.predicate == undefined ? "&sortBy=" : '&sortBy=' + config.paramsSort(params);
                    var final = url + criteria + limit + offset + sort;
                    // console.log(final);
                    return $http.get(final);
                },
                create: function(data) {
                    var url = config.api + 'branch';
                    return $http.post(url, data)
                },
                delete: function(id) {
                    var url = config.api + 'branch/?id=' + id;
                    return $http.delete(url);
                },
                update: function(data) {
                    var url = config.api + 'branch/';
                    return $http.put(url, data)
                },
                getById: function(id) {
                    var url = config.api + 'branch/?id=' + id
                    return $http.get(url)
                },
                getUnit: function(){
                    var url = config.api + 'unit'
                    return $http.get(url);
                }
            };
        })
        .config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('Branch', {
                url: '/branch',
                title: 'Branch - List',
                templateUrl: 'app/pages/generalData/branch/index.html',
                controller: 'BranchCtrl',
            })
    }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    'use strict';
    angular.module('BlurAdmin.pages.Unit', [])
        .factory('UnitSvc', function($http, config) {
            return {
                //service
                getList: function(limit, offset, params) {
                    var url = config.api + "unit";
                    var criteria = params.search.predicateObject == undefined ? "?criteria=" : '?criteria=' + config.paramsSearch(params);
                    var limit = '&limit=' + limit;
                    // var offset = '&page=' + parseInt(offset + 1);
                    var offset = '&page=' + offset;
                    var sort = params.sort.predicate == undefined ? "&sortBy=" : '&sortBy=' + config.paramsSort(params);
                    var final = url + criteria + limit + offset + sort;
                    // console.log(final);
                    return $http.get(final);
                },
                create: function(data) {
                    var url = config.api + 'unit';
                    return $http.post(url, data)
                },
                delete: function(id) {
                    var url = config.api + 'unit/?id=' + id;
                    return $http.delete(url);
                },
                update: function(data) {
                    var url = config.api + 'unit/';
                    return $http.put(url, data)
                },
                getById: function(id) {
                    var url = config.api + 'unit/?id=' + id
                    return $http.get(url)
                }
            };
        })
        .config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('Unit', {
                url: '/unit',
                title: 'Unit - List',
                templateUrl: 'app/pages/generalData/unit/index.html',
                controller: 'UnitCtrl',
            })
    }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    'use strict';
    angular.module('BlurAdmin.pages.Application', [])
        .factory('ApplicationSvc', function($http, config) {
            return {
                //service
                getList: function(limit, offset, params) {
                    var url = config.api + "application";
                    var criteria = params.search.predicateObject == undefined ? "?criteria=" : '?criteria=' + config.paramsSearch(params);
                    var limit = '&limit=' + limit;
                    // var offset = '&page=' + parseInt(offset + 1);
                    var offset = '&page=' + offset;
                    var sort = params.sort.predicate == undefined ? "&sortBy=" : '&sortBy=' + config.paramsSort(params);
                    var final = url + criteria + limit + offset + sort;
                    // console.log(final);
                    return $http.get(final);
                },
                create: function(data) {
                    var url = config.api + 'application';
                    return $http.post(url, data)
                },
                delete: function(id) {
                    var url = config.api + 'application/?id=' + id;
                    return $http.delete(url);
                },
                update: function(data) {
                    var url = config.api + 'application/';
                    return $http.put(url, data)
                },
                getById: function(id) {
                    var url = config.api + 'application/?id=' + id
                    return $http.get(url)
                }
            };
        })
        .config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('Application', {
                url: '/application',
                title: 'Application - List',
                templateUrl: 'app/pages/userManagement/application/index.html',
                controller: 'ApplicationCtrl',
            })
    }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    'use strict';
    angular.module('BlurAdmin.pages.Menu', [])
        .factory('MenuSvc', function($http, config) {
            return {
                //service
                getList: function(limit, offset, params) {
                    var url = config.api + "menu";
                    var criteria = params.search.predicateObject == undefined ? "?criteria=" : '?criteria=' + config.paramsSearch(params);
                    var limit = '&limit=' + limit;
                    // var offset = '&page=' + parseInt(offset + 1);
                    var offset = '&page=' + offset;
                    var sort = params.sort.predicate == undefined ? "&sortBy=" : '&sortBy=' + config.paramsSort(params);
                    var final = url + criteria + limit + offset + sort;
                    // console.log(final);
                    return $http.get(final);
                },
                create: function(data) {
                    var url = config.api + 'menu';
                    return $http.post(url, data)
                },
                delete: function(id) {
                    var url = config.api + 'menu/?id=' + id;
                    return $http.delete(url);
                },
                update: function(data) {
                    var url = config.api + 'menu/';
                    return $http.put(url, data)
                },
                getById: function(id) {
                    var url = config.api + 'menu/?id=' + id
                    return $http.get(url)
                },
                getParent: function (applicationId) {
                    var url = config.api + 'menu?criteria=application_id:'+applicationId
                    return $http.get(url)
                },
                 getApplication: function () {
                     var url = config.api + 'application'
                     return $http.get(url)
                 },
            };
        })
        .config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('Menu', {
                url: '/menu',
                title: 'Menu - List',
                templateUrl: 'app/pages/userManagement/menu/index.html',
                controller: 'MenuCtrl',
            })
    }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    'use strict';
    angular.module('BlurAdmin.pages.Role', [])
        .factory('RoleSvc', function($http, config) {
            return {
                //service
                getList: function(limit, offset, params) {
                    var url = config.api + "role";
                    var criteria = params.search.predicateObject == undefined ? "?criteria=" : '?criteria=' + config.paramsSearch(params);
                    var limit = '&limit=' + limit;
                    // var offset = '&page=' + parseInt(offset + 1);
                    var offset = '&page=' + offset;
                    var sort = params.sort.predicate == undefined ? "&sortBy=" : '&sortBy=' + config.paramsSort(params);
                    var final = url + criteria + limit + offset + sort;
                    // console.log(final);
                    return $http.get(final);
                },
                create: function(data) {
                    var url = config.api + 'role';
                    return $http.post(url, data)
                },
                delete: function(id) {
                    var url = config.api + 'role/?id=' + id;
                    return $http.delete(url);
                },
                update: function(data) {
                    var url = config.api + 'role/';
                    return $http.put(url, data)
                },
                getById: function(id) {
                    var url = config.api + 'role/?id=' + id
                    return $http.get(url)
                },
                getUnit: function(){
                    var url = config.api + 'unit'
                    return $http.get(url);
                },
                getParent: function (unitId) {
                    var url = config.api + 'role?criteria=unit_id:' + unitId
                    return $http.get(url)
                },
            };
        })
        .config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('Role', {
                url: '/role',
                title: 'Role - List',
                templateUrl: 'app/pages/userManagement/role/index.html',
                controller: 'RoleCtrl',
            })
    }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    'use strict';
    angular.module('BlurAdmin.pages.Privilege', [])
        .factory('PrivilegeSvc', function($http, config) {
            return {
                //service
                getList: function(limit, offset, params) {
                    var url = config.api + "role";
                    var criteria = params.search.predicateObject == undefined ? "?criteria=" : '?criteria=' + config.paramsSearch(params);
                    var limit = '&limit=' + limit;
                    // var offset = '&page=' + parseInt(offset + 1);
                    var offset = '&page=' + offset;
                    var sort = params.sort.predicate == undefined ? "&sortBy=" : '&sortBy=' + config.paramsSort(params);
                    var final = url + criteria + limit + offset + sort;
                    // console.log(final);
                    return $http.get(final);
                },
                update: function(data) {
                    var url = config.api + 'privilege?mode=update-bulk';
                    return $http.post(url, data)
                },
                getById: function(id) {
                    var url = config.api + 'role?id=' + id
                    return $http.get(url)
                },
                getApplication: function () {
                    var url = config.api + 'application'
                    return $http.get(url)
                },
                getAllMenues: function (roleId,applicationId) {
                    var url = config.api + 'privilege?mode=all-menu-by-role-id&role-id=' + roleId +'&application-id='+applicationId
                    return $http.get(url)
                }
            };
        })
        .config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('Privilege', {
                url: '/privilege',
                title: 'Privilege - List',
                templateUrl: 'app/pages/userManagement/privilege/index.html',
                controller: 'PrivilegeCtrl',
            })
    }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    'use strict';
    angular.module('BlurAdmin.pages.User', [])
        .factory('UserSvc', function($http, config) {
            return {
                //service
                getList: function(limit, offset, params) {
                    var url = config.api + "user";
                    var criteria = params.search.predicateObject == undefined ? "?criteria=" : '?criteria=' + config.paramsSearch(params);
                    var limit = '&limit=' + limit;
                    // var offset = '&page=' + parseInt(offset + 1);
                    var offset = '&page=' + offset;
                    var sort = params.sort.predicate == undefined ? "&sortBy=" : '&sortBy=' + config.paramsSort(params);
                    var final = url + criteria + limit + offset + sort;
                    // console.log(final);
                    return $http.get(final);
                },
                create: function(data) {
                    var url = config.api + 'user';
                    return $http.post(url, data)
                },
                delete: function(id) {
                    var url = config.api + 'user/?id=' + id;
                    return $http.delete(url);
                },
                update: function(data) {
                    var url = config.api + 'user/';
                    return $http.put(url, data)
                },
                getById: function(id) {
                    var url = config.api + 'user/?id=' + id
                    return $http.get(url)
                },
                getUnit: function(){
                    var url = config.api + 'unit'
                    return $http.get(url);
                },
                getBranch: function (unitId) {
                    var url = config.api + 'branch?criteria=unit_id:'+unitId;
                    return $http.get(url);
                },
                getRole: function (unitId) {
                    var url = config.api + 'role?criteria=unit_id:' + unitId;
                    return $http.get(url);
                },
                getTracking: function (userId) {
                    var url = config.api + 'tracking?criteria=created_by:' + userId;
                    return $http.get(url);
                }
            };
        })
        .config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('User', {
                url: '/user',
                title: 'User - List',
                templateUrl: 'app/pages/userManagement/user/index.html',
                controller: 'UserCtrl',
            })
    }
})();
(function () {
'use strict';

angular.module('BlurAdmin', [
        'timer',
        'ngAnimate',
        'darthwade.dwLoading',
        'isteven-multi-select',
        'ngStorage',
        'dndLists',
        'ui.bootstrap',
        'ui.sortable',
        'ui.router',
        'ngTouch',
        'toastr',
        'smart-table',
        "xeditable",
        'ui.slimscroll',
        'ngJsTree',
        'angular-progress-button-styles',
        'BlurAdmin.theme',
        'BlurAdmin.pages',
        'ui.select',
        'chart.js',
        'bootstrap.angular.validation',
        'ui.bootstrap.datetimepicker',
        'angular.filter',
    ])
    .config(['bsValidationConfigProvider', function(bsValidationConfigProvider) {
        bsValidationConfigProvider.global.setValidateFieldsOn('submit');
        bsValidationConfigProvider.global.successClass = false;
        bsValidationConfigProvider.global.errorMessagePrefix = '<span class="glyphicon glyphicon-warning-sign"></span> &nbsp;';
    }]);
})();

(function () {
    "use strict";
    angular
        .module("BlurAdmin.pages")
        .controller("BaseController", function BaseController($rootScope, $timeout, $state, $uibModalStack, $uibModal, $scope, $loading, toastr) {
            $scope.selected = [];
            $scope.form = {};
            $scope.ui_select = {};
            $scope.dataList = {};
            $scope.smartState = null;
            $scope.Limits = [10, 20, 50, 100, 200];
            $scope.limit = 10;
            $scope.callServer = function callServer(tableState) {
                $scope.smartState = tableState;
                $scope.isLoading = true;
                var pagination = tableState.pagination;
                if ($scope.isFilter) {
                    pagination.selectPage = 1;
                    $scope.isFilter = false
                }
                var start = pagination.selectPage; // This is NOT the page number, but the index of item in the list that you want to use to display the table.
                return $scope.service.getList($scope.limit, start, tableState).then(function (res) {
                    if (res.data.error_code == 0) {
                        $scope.dataList = res.data;
                        $scope.dataList.page = start;
                        tableState.pagination.numberOfPages = Math.ceil(res.data.total_data / $scope.limit); //set the number of pages so the pagination can update
                        $scope.isLoading = false;
                    } else {
                        toastr.error(res.data.message)
                        $scope.dataList.data = [];
                        $scope.dataList.total = 0;
                        $scope.isLoading = false;
                    }
                });
            };
            $scope.changeFilter = function () {
                $scope.isFilter = true
            };
            $scope.refreshTable = async function (limit) {
                if (limit != undefined) $scope.limit = limit;
                $scope.spinReload = true;
                await $scope.callServer($scope.smartState);
                $timeout(function () {
                    $scope.spinReload = false;
                })
            };



            //Behavior
            $scope.saveId = function (newId) {
                $scope.getId = newId.toString();
            };
            $scope.showAddMsg = function () {
                toastr.success("Data Berhasil Di Save");
            };
            $scope.showEditMsg = function () {
                toastr.success("Data Berhasil Di Edit");
            };
            $scope.showDeleteMsg = function () {
                toastr.success("Data Berhasil Di Hapus");
            };
            $scope.doSubmit = function () {
                if ($scope.action.add) {
                    $scope.doSave();
                } else {
                    $scope.doUpdate();
                }
            }
            $scope.beforeSave = function () {

            }
            $scope.afterSave = function () {

            }
            $scope.afterView = function () {

            }
            $scope.doSave = async function () {
                await $scope.beforeSave();
                $loading.start('save');
                return $scope.service.create($scope.form).then(async res => {
                    if (res.data.error_code == 0) {
                        $scope.form = res.data.data;
                        await $scope.afterSave();
                        $scope.refreshTable();
                        $scope.behavior_view();
                        $scope.setResponse(res, res.data.message);
                    } else {
                        $scope.setResponse(res);
                    }
                });
            }
            $scope.doUpdate = async function () {
                await $scope.beforeSave();
                $loading.start('save');
                return $scope.service.update($scope.form).then(async res => {
                    if (res.data.error_code == 0) {
                        $scope.form = res.data.data;
                        await $scope.afterSave();
                        $scope.refreshTable();
                        $scope.behavior_view();
                        $scope.setResponse(res, res.data.message);
                    } else {
                        $scope.setResponse(res);
                    }
                });
            }
            $scope.viewById = function (id) {
                $loading.start('save')
                if (id == undefined) id = $scope.getId;
                return $scope.service.getById(id).then(async res => {
                    if (res.data.error_code == 0) {
                        $scope.form = res.data.data;
                        await $scope.afterView();
                        $scope.behavior_view();
                        $loading.finish('save');
                    } else {
                        $scope.setResponse(res);
                    }
                });
            }
            $scope.doDelete = function () {
                var i = $scope.selected;
                if ($scope.selected.length > 0) {
                    $scope.isLoading = true;
                    return $scope.service.delete($scope.selected.join(',')).then(function (res) {
                        if (res.data.error_code == 0) {
                            toastr.success(res.data.message);
                            $scope.selected = [];
                            $scope.refreshTable();
                        } else {
                            $scope.setResponse(res);
                            $scope.isLoading = false;
                        }
                    });
                }
            }
            $scope.setResponse = function (res, messageSuccess) {
                $loading.finish('save');
                if (res.data.error_code == 1) {
                    for (var property in res.data.message) {
                        toastr.error(res.data.message[property][0]);
                    }
                } else if (res.data.error_code == 0) {
                    toastr.success(messageSuccess);
                } else {
                    toastr.error(res.data.message);
                }
            }
            var full_control = function () {
                $scope.action = {};
                $scope.action.control = true;
                $scope.action.add = false;
                $scope.action.edit = false;
                $scope.action.view = false;
            }
            $scope.behavior_add = function () {
                full_control();
                $scope.action.add = true;
            }
            $scope.behavior_view = function () {
                $scope.selected = [];
                full_control();
                $scope.action.control = false;
                $scope.action.view = true;
            }
            $scope.behavior_edit = function () {
                full_control();
                $scope.action.edit = true;
            }

            //Context Menu
            $scope.contextMenu = function (custom = []) {
                var privileges = $rootScope.privileges
                var induk = "";
                induk += '<ul id="menuOptions" class="dropdown-menu context-menu" style="min-width:130px !important;border-radius:0;cursor:pointer !important;"></ul>';
                $("#context").html(induk);
                $scope.$watchCollection('selected', function (newVal, oldVal) {
                    var html = "";
                    if (custom.length > 0) {
                        // if (custom.indexOf('setuju') != -1) html += '<li><a ng-click="doSetuju()"><i class="fa fa-check text-success"></i>  Approve</a></li>';
                        // if (custom.indexOf('tolak') != -1) html += '<li><a ng-click="doTolak()"><i class="fa fa-close text-warning"></i>  Reject</a></li>';
                        if ($scope.selected.length == 1 && (privileges != undefined && privileges.can_update)) {
                            if (custom.indexOf('edit') != -1) html += '<li><a ng-click="showForm();behavior_edit();viewById();"><i class="fa fa-edit text-primary"></i>  Edit</a></li>';
                        }
                        if (custom.indexOf('hapus') != -1 && (privileges != undefined && privileges.can_delete)) html += '<li><a ng-click="openDelete()"><i class="fa fa-trash text-danger"></i>  Delete</a></li>';
                    } else {
                        // html += '<li><a ng-click="test()"><i class="fa fa-check text-success"></i>  Approve</a></li>';
                        // html += '<li><a ng-click="test()"><i class="fa fa-close text-warning"></i>  Reject</a></li>';
                        if ($scope.selected.length == 1 && (privileges != undefined && privileges.can_update)) {
                            html += '<li><a ng-click="showForm();behavior_edit();viewById();"><i class="fa fa-edit text-primary"></i>  Edit</a></li>';
                        }
                        if (privileges != undefined && privileges.can_delete) {
                            html += '<li><a ng-click="openDelete()"><i class="fa fa-trash text-danger"></i>  Delete</a></li>';
                        }
                    }
                    $("#menuOptions").html(html);
                    angular.element(document).injector().invoke(function ($compile) {
                        $compile($("#context").contents())($scope);
                    });
                });
            };
            $scope.selectAll = function (collection, attr = "id") {
                if ($scope.selected.length === 0) {
                    angular.forEach(collection, function (val) {
                        $scope.selected.push(val[attr]);
                    });
                } else if (
                    $scope.selected.length > 0 &&
                    $scope.selected.length != collection.length
                ) {
                    angular.forEach(collection, function (val) {
                        var found = $scope.selected.indexOf(val[attr]);
                        if (found == -1) $scope.selected.push(val[attr]);
                    });
                } else {
                    $scope.selected = [];
                }
            };
            $scope.select = function (id) {
                var found = $scope.selected.indexOf(id);
                if (found == -1) $scope.selected.push(id);
                else $scope.selected.splice(found, 1);
            };
            //Modals
            $scope.alert = function (page, size) {
                var modal = $uibModal.open({
                    animation: true,
                    templateUrl: page,
                    size: size,
                    scope: $scope,
                    controller: function ($scope, $uibModalInstance, $rootScope) {
                        $rootScope.closeAlert = function () {
                            $uibModalInstance.dismiss('cancel');
                        }
                    },
                    resolve: {
                        items: function () {
                            return $scope.items;
                        }
                    }
                })
            };
            $scope.open = function (page, size, id) {
                $scope.openedPage = page;
                $scope.openedSize = size;
                if (id) {
                    $state.transitionTo($state.$current, {
                        id: id
                    }, {
                        location: true,
                        inherit: true,
                        relative: $state.$current,
                        notify: false
                    })
                }
                var modal = $uibModal.open({
                    animation: true,
                    templateUrl: page,
                    size: size,
                    scope: $scope,
                    controller: function ($scope, $uibModalInstance, $rootScope) {
                        $rootScope.closemodal = function () {
                            $uibModalInstance.dismiss("cancel");
                        };
                    },
                    resolve: {
                        items: function () {
                            return $scope.items;
                        }
                    }
                }).closed.then(function () {
                    $scope.selected = [];
                    if ($scope.add || ($scope.control == true)) {
                        $scope.openDiscard();
                    }
                    angular.element('.dw-loading').removeClass('dw-loading-active');
                    angular.element('.st-selected').removeClass("st-selected");
                    angular.element('.s-row-select').prop("checked", false);
                    if ($scope.results) {
                        $scope.results.forEach(function (val) {
                            val.isSelected = false;
                        });
                    }
                    // let urlhash=window.location.hash.split('/')[1];
                    // console.log($state.$current,'iNI state dari factory');

                    $state.transitionTo($state.$current, {
                        id: undefined
                    }, {
                        location: true,
                        inherit: true,
                        relative: $state.$current,
                        notify: false
                    })
                    // window.location.hash="#/"+urlhash+'/';
                });
            };
            $scope.openDiscard = function () {
                var modal = $uibModal.open({
                    animation: true,
                    template: '<div class="modal-content modal-delete"> <div class="modal-body"> <p>Are you sure want to Discard unsaved changes?</p> </div> <div class="modal-footer" style="border-radius: 0px;"><button class="btn btn-default" autofocus ng-click="$close();open(openedPage,openedSize,form.Id)">Cancel</button> <button ng-click="$close();closemodal()" class="btn btn-danger">Discard</button></div> </div>',
                    size: "sm",
                    scope: $scope
                });
            };
            $scope.openDelete = function (page, size) {
                var modal = $uibModal.open({
                    animation: true,
                    template: '<div class="modal-content modal-delete"> <div class="modal-body"> <p>Are you sure want to delete selected data?</p> </div> <div class="modal-footer" style="border-radius: 0px;"><button class="btn btn-default" ng-click="$close()">No</button> <button ng-click="doDelete();$close();" class="btn btn-danger">Yes</button></div> </div>',
                    size: "sm",
                    scope: $scope
                });
            };
            $scope.openNonDismiss = function (page, size, id) {
                var modal = $uibModal
                    .open({
                        animation: true,
                        templateUrl: page,
                        size: size,
                        scope: $scope,
                        backdrop: "static",
                        controller: function ($scope, $uibModalInstance, $rootScope) {
                            $rootScope.closemodal = function () {
                                $uibModalInstance.dismiss("cancel");
                            };
                        }
                    })
                    .rendered.then(function () {
                        $uibModalStack.getTop().value.modalDomEl.attr("id", id);
                    });
            };


        })
        .service("helper", function ($window, $location) {
            this.array_move = function (arr, old_index, new_index) {
                if (new_index >= arr.length) {
                    var k = new_index - arr.length + 1;
                    while (k--) {
                        arr.push(undefined);
                    }
                }
                arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
                return arr; // for testing
            };
            this.GetURLParameter = function (parameter) {
                var url;
                var search;
                var parsed;
                var count;
                var loop;
                var searchPhrase;
                url = window.location.href;
                search = url.indexOf("?");
                if (search < 0) {
                    return "";
                }
                searchPhrase = parameter + "=";
                parsed = url.substr(search + 1).split("&");
                count = parsed.length;
                for (loop = 0; loop < count; loop++) {
                    if (parsed[loop].substr(0, searchPhrase.length) == searchPhrase) {
                        return decodeURI(parsed[loop].substr(searchPhrase.length));
                    }
                }
                return "";
            };
        })
        .service("config", function ($window, $location) {
            // this.sso = "https://api.circle-pihc.com/sso/index.html#!/index";
            // this.api = "https://api.circle-pihc.com/api/";
             this.sso = "http://127.0.0.1:8000/sso/index.html#!/index";
            this.api = "http://127.0.0.1:8000/api/";
            this.url = "/";
            this.paramsSearch = function (params) {
                var obj = [];
                $.each(params.search.predicateObject, function (name, value) {
                    if (typeof value == "object") {
                        $.each(value, function (name2, value2) {
                            obj.push(String(name + "." + name2 + ":" + value2));
                        });
                    } else {
                        obj.push(String(name + ":" + value));
                    }
                });
                return obj.join(",");
            }
            this.paramsSort = function (params) {
                if (params.sort.reverse) var sort = "asc";
                else var sort = "desc";
                return params.sort.predicate + ":" + sort;
            }
        })
        .factory("AuthTokenSvc", function ($http, config) {
            return {
                //service
                authToken: function (data) {
                    var url = config.api + "authtoken";
                    return $http.post(url, data);
                }
            };
        })
        .config(routeConfig)
        .run(run);

    async function run(
        baSidebarService,
        $rootScope,
        $location,
        $localStorage,
        config,
        baseConfig,
        $window,
        AuthTokenSvc,
        $loading,
        toastr,
        $sce,
        $state,
        lia,
        $interval,
        $uibModalStack,
        $timeout,
        helper
    ) {
        $rootScope.storage = $localStorage;
        var setPageTopRoles = function () {
            $rootScope.listUnit = [];
            for (var i = 0; i < $localStorage.roles.length; i++) {
                if (i == 0) {
                    if ($localStorage.roles[i].role_unit_id == 0) {
                        $rootScope.listUnit.push({
                            unit_code: $localStorage.roles[i].role_unit_name,
                            unit_id: $localStorage.roles[i].role_unit_id,
                            templateUrl: "myPopoverTemplate.html"
                        });
                    } else {
                        $rootScope.listUnit.push({
                            unit_code: $localStorage.roles[i].role_unit_code,
                            unit_id: $localStorage.roles[i].role_unit_id,
                            templateUrl: "myPopoverTemplate.html"
                        });
                    }
                } else {
                    for (var x = 0; x < $rootScope.listUnit.length; x++) {
                        if (
                            $rootScope.listUnit[x].role_unit_id != $localStorage.roles[i].role_unit_id
                        ) {
                            if ($localStorage.roles[i].role_unit_id == 0) {
                                $rootScope.listUnit.push({
                                    unit_code: $localStorage.roles[i].role_unit_name,
                                    unit_id: $localStorage.roles[i].role_unit_id,
                                    templateUrl: "myPopoverTemplate.html"
                                });
                            } else {
                                $rootScope.listUnit.push({
                                    unit_code: $localStorage.roles[i].role_unit_code,
                                    unit_id: $localStorage.roles[i].role_unit_id,
                                    templateUrl: "myPopoverTemplate.html"
                                });
                            }
                            helper.array_move($rootScope.listUnit, $rootScope.listUnit.length - 1, 0);
                            break;
                        } else {
                            break;
                        }
                    }
                }
            }
            $rootScope.generateRoles = function (id) {
                $rootScope.isOpen = true;
                // console.log(id.unit_id,'Id Unit');
                $rootScope.role = [];
                for (var i = 0; i < $localStorage.roles.length; i++) {
                    if (id.unit_id == $localStorage.roles[i].role_unit_id) {
                        $rootScope.role.push({
                            unit_name: $localStorage.roles[i].role_unit_name,
                            role_name: $localStorage.roles[i].role_name,
                            user_role_branches: $localStorage.roles[i].user_role_branches
                        });
                    }
                }
                var html =
                    '<div class="table-responsive">' +
                    '<table class="table table-bordered table-popover">' +
                    "<thead>" +
                    "<tr>" +
                    '<th class="sm-head">Role Name</th>' +
                    '<th class="sm-head">Branch</th>' +
                    "</tr>" +
                    "</thead>" +
                    "<tbody>";
                for (var i = 0; i < $rootScope.role.length; i++) {
                    html =
                        html +
                        '<tr> <td class="sm-body">' +
                        $rootScope.role[i].role_name +
                        '</td><td class="sm-body">';
                    for (var x = 0; x < $rootScope.role[i].user_role_branches.length; x++) {
                        html =
                            html +
                            ($rootScope.role[i].user_role_branches.length - 1 == x ?
                                $rootScope.role[i].user_role_branches[x].branch_name :
                                $rootScope.role[i].user_role_branches[x].branch_name + ", ");
                    }
                    html = html + "</tr>";
                }
                html = html + "</tbody></table></div>";

                // if(id !=undefined) angular.element('#preview').html(html);
                return $sce.trustAsHtml(html);
            };
        }
        var authorizationAuthKey = function () {
            return AuthTokenSvc.authToken({
                application_id: baseConfig.application_id
            }).then(function (res) {
                return res.data;
            })
        }
        var setCurrentPrivilege = function (menuName) {
            var currentPrivilege = _.findWhere($localStorage.privileges, {
                menu_menu_name: menuName
            });
            if (currentPrivilege != null) {
                $rootScope.privileges = currentPrivilege;
                setTimeout(() => {
                    document.title = $rootScope.privileges.title + " - " + baseConfig.application_name;
                })
            } else {
                $rootScope.privileges = {};
                setTimeout(() => {
                    document.title = "404 - " + baseConfig.application_name;
                })
            }
        }
        var setPrivilege = function () {
            var allMenues = _.findWhere($localStorage.privileges, {
                all_menues: 1,
                can_read: 1
            });
            $localStorage.privileges.sort((a, b) => parseFloat(a.menu_sequence) - parseFloat(b.menu_sequence));
            for (let i = 0; i < $localStorage.privileges.length; i++) {
                $localStorage.privileges[i].title = $localStorage.privileges[i].menu_label;
                $localStorage.privileges[i].icon = $localStorage.privileges[i].menu_icon_url;
                $localStorage.privileges[i].stateRef = $localStorage.privileges[i].menu_menu_name;
                if (allMenues != undefined) {
                    $localStorage.privileges[i].can_delete = true;
                    $localStorage.privileges[i].can_update = true;
                    $localStorage.privileges[i].can_create = true;
                    $localStorage.privileges[i].can_read = true;
                } else {
                    $localStorage.privileges[i].can_delete = $localStorage.privileges[i].can_delete == 1 ? true : false;
                    $localStorage.privileges[i].can_update = $localStorage.privileges[i].can_update == 1 ? true : false;
                    $localStorage.privileges[i].can_create = $localStorage.privileges[i].can_create == 1 ? true : false;
                    $localStorage.privileges[i].can_read = $localStorage.privileges[i].can_read == 1 ? true : false;
                }
            }
            $localStorage.privileges = _.where($localStorage.privileges, {
                hidden: 0,
                can_read: true
            });
        }
        var setSubMenu = function (row, menuId) {
            var menuData = _.findWhere($localStorage.privileges, {
                menu_id: menuId
            });
            var subMenues = _.where($localStorage.privileges, {
                parent_id: menuId
            });
            if (subMenues.length == 0) return null;
            var newSubMenu = [];
            for (let x = 0; x < subMenues.length; x++) {
                setSubMenu(undefined, subMenues[x].menu_id)
                newSubMenu.push(subMenues[x]);
            }
            menuData.subMenu = newSubMenu;
            if (row != undefined) row = menuData;
        }
        var setMenu = function (setDefaultMenu = false) {
            var listMenuCanRead = [];
            $localStorage.privileges.map(function (item, index) {
                // baSidebarService.addStaticItem(item)
                if (item.parent_id == null) {
                    listMenuCanRead.push(item);
                    setSubMenu(listMenuCanRead[listMenuCanRead.length - 1], item.menu_id);
                }
            });
            listMenuCanRead.map(function (item, index) {
                baSidebarService.addStaticItem(item)
            });
            if (setDefaultMenu) {
                console.log($state);
                if ($state.current.url == "^") {
                    var checkMinSequence = _.min(listMenuCanRead, function (item) {
                        return item.menu_sequence;
                    })
                    if (checkMinSequence) {
                        setCurrentPrivilege(checkMinSequence.stateRef);
                        $state.go(checkMinSequence.stateRef);
                    }
                } else {
                    setCurrentPrivilege($state.current.name);
                }
            }
        }
        $rootScope.loadingAuthToken = false;
        var validate = async function () {
            var parameterAuthKey = helper.GetURLParameter("AuthKey");
            if (parameterAuthKey != "") {
                $localStorage.auth_key = parameterAuthKey;
                $window.location.href = baseConfig.fe;
            }
            if ($localStorage.auth_key == undefined) {
                $window.location.href = config.sso + "?origin_url=" + baseConfig.fe + "&app_id=" + baseConfig.application_id;
            } else {
                $rootScope.loadingAuthToken = true;
                var response = await authorizationAuthKey();
                if (response.error_code != 0) {
                    toastr.error(response.message);
                    $timeout(function () {
                        $window.location.href = config.sso + "?origin_url=" + baseConfig.fe + "&app_id=" + baseConfig.application_id + "&sessionexpired=true";
                    }, 1000);
                } else {
                    $localStorage = angular.extend($localStorage, response.data);
                    setPrivilege();
                    setMenu(true);
                    setPageTopRoles();
                }
                $rootScope.loadingAuthToken = false;
            }
        };
        await validate();
        $rootScope.$on("$stateChangeStart", async function (event, toState, toParams, fromState, fromParams, options, $state) {
            baSidebarService.setMenuCollapsed(false);
            angular.element('#backTop').triggerHandler('click');
            setCurrentPrivilege(toState.name);
        });
        $rootScope.logout = function () {
            $localStorage.$reset();
            $window.location.href = config.sso + "?origin_url=" + baseConfig.fe + "&app_id=" + baseConfig.application_id + "&sessionexpired=true";
        };
    }

    /** @ngInject */
    function routeConfig(
        $urlRouterProvider,
        baSidebarServiceProvider,
        $stateProvider,
        $httpProvider,
        $locationProvider
    ) {
        // $locationProvider.html5Mode({
        //     enabled: true,
        //     requireBase: false
        // });
        $httpProvider.interceptors.push(function ($q, $location, $localStorage, $loading) {
            return {
                request: function (config) {
                    config.headers = config.headers || {};
                    if ($localStorage.auth_key) {
                        config.headers.AuthKey = $localStorage.auth_key;
                    }
                    return config;
                },
                'requestError': function (rejection) {
                    $loading.finish('save');
                    alert('Silahkan Coba Lagi');
                    console.log(rejection)
                    return $q.reject(rejection);
                },
                'responseError': function (rejection) {
                    $loading.finish('save');
                    alert('Silahkan Coba Lagi');
                    console.log(rejection)
                    return $q.reject(rejection);
                }
            };
        });
    }
})();
function rowSelect() {
    return {
        require: "^stTable",
        template: '<input type="checkbox" class="s-row-select">',
        scope: {
            row: "=rowSelect"
        },
        link: function (scope, element, attr, ctrl, prop) {
            element.bind("click", function (evt) {
                scope.$apply(function () {
                    ctrl.select(scope.row, "multiple");
                });
            });
            // console.log(element);
            scope.$watch("row.isSelected", function (newValue) {
                if (newValue === true) {
                    element.parent().addClass("st-selected");
                    element.find("input").prop("checked", true);
                } else {
                    element.parent().removeClass("st-selected");
                    element.find("input").prop("checked", false);
                }
            });
        }
    };
}

function rowSelectAll($rootScope) {
    return {
        require: "^stTable",
        template: '<input type="checkbox" class="top-min-11">',
        scope: {
            all: "=rowSelectAll",
            selected: "="
        },
        link: function (scope, element, attr, prop) {
            scope.isAllSelected = false;
            element.bind("click", function (evt) {
                scope.$apply(function () {
                    scope.all.forEach(function (val) {
                        val.isSelected = scope.isAllSelected;
                    });
                });
            });
            $rootScope.selectReset = function () {
                element.find("input").prop("checked", false);
                scope.isAllSelected = true;
                scope.all.forEach(function (val) {
                    val.isSelected = false;
                });
                scope.selected = [];
            };
            scope.$watchCollection("selected", function (newVal) {
                var s = newVal.length;
                if (scope.all != undefined) {
                    var a = scope.all.length;
                    if (s == a && s > 0 && a > 0) {
                        element.find("input").prop("checked", true);
                        scope.isAllSelected = false;
                    } else {
                        element.find("input").prop("checked", false);
                        scope.isAllSelected = true;
                    }
                }
            });
        }
    };
}

(function () {
    "use strict";
    angular
        .module("BlurAdmin.pages")
        .directive('context', [
            function () {
                return {
                    restrict: 'A',
                    scope: '@&',
                    compile: function compile(tElement, tAttrs, transclude) {
                        return {
                            post: function postLink(scope, iElement, iAttrs, controller) {
                                var ul = $('#' + iAttrs.context),
                                    last = null;

                                ul.css({
                                    'display': 'none'
                                });
                                $(iElement).bind('contextmenu', function (event) {
                                    event.preventDefault();
                                    ul.css({
                                        position: "fixed",
                                        display: "block",
                                        left: event.clientX + 'px',
                                        top: event.clientY + 'px'
                                    });
                                    last = event.timeStamp;
                                });
                                //$(iElement).click(function(event) {
                                //  ul.css({
                                //    position: "fixed",
                                //    display: "block",
                                //    left: event.clientX + 'px',
                                //    top: event.clientY + 'px'
                                //  });
                                //  last = event.timeStamp;
                                //});

                                $(document).click(function (event) {
                                    var target = $(event.target);
                                    if (!target.is(".popover") && !target.parents().is(".popover")) {
                                        if (last === event.timeStamp)
                                            return;
                                        ul.css({
                                            'display': 'none'
                                        });
                                    }
                                });
                            }
                        };
                    }
                };
            }
        ])

        .directive('compileTemplate', function ($compile, $parse) {
            return {
                link: function (scope, element, attrs) {
                    var parsed = $parse(attrs.ngBindHtml);

                    function getStringValue() {
                        return (parsed(scope) || '').toString();
                    }

                    // Recompile if the template changes
                    var compileScope = scope;
                    if (attrs.bindHtmlScope) {
                        compileScope = scope.$eval(attrs.bindHtmlScope);
                    }
                    $compile(element.contents())(compileScope);
                    scope.$watch(getStringValue, function () {
                        $compile(element, null, -9999)(scope); // The -9999 makes it skip directives so that we do not recompile ourselves
                    });
                }
            }
        })
        .directive("fileSelect", [
            "$window",
            function ($window) {
                return {
                    restrict: "A",
                    require: "ngModel",
                    link: function (scope, el, attr, ctrl) {
                        var fileReader = new $window.FileReader();

                        fileReader.onload = function () {
                            ctrl.$setViewValue(fileReader.result);

                            if ("fileLoaded" in attr) {
                                scope.$eval(attr["fileLoaded"]);
                            }
                        };

                        fileReader.onprogress = function (event) {
                            if ("fileProgress" in attr) {
                                scope.$eval(attr["fileProgress"], {
                                    $total: event.total,
                                    $loaded: event.loaded
                                });
                            }
                        };

                        fileReader.onerror = function () {
                            if ("fileError" in attr) {
                                scope.$eval(attr["fileError"], {
                                    $error: fileReader.error
                                });
                            }
                        };

                        var fileType = attr["fileSelect"];

                        el.bind("change", function (e) {
                            var fileName = e.target.files[0];

                            if (fileType === "" || fileType === "text") {
                                fileReader.readAsText(fileName);
                            } else if (fileType === "data") {
                                fileReader.readAsDataURL(fileName);
                            }
                        });
                    }
                };
            }
        ])
        .directive("sglclick", [
            "$parse",
            function ($parse) {
                return {
                    restrict: "A",
                    link: function (scope, element, attr) {
                        var fn = $parse(attr["sglclick"]);
                        var delay = 300,
                            clicks = 0,
                            timer = null;
                        element.on("click", function (event) {
                            clicks++; //count clicks
                            if (clicks === 1) {
                                timer = setTimeout(function () {
                                    scope.$apply(function () {
                                        fn(scope, {
                                            $event: event
                                        });
                                    });
                                    clicks = 0; //after action performed, reset counter
                                }, delay);
                            } else {
                                clearTimeout(timer); //prevent single-click action
                                clicks = 0; //after action performed, reset counter
                            }
                        });
                    }
                };
            }
        ])
        .directive("checkList", function () {
            return {
                scope: {
                    list: "=checkList",
                    value: "@"
                },
                link: function (scope, elem, attrs) {
                    var handler = function (setup) {
                        var checked = elem.prop("checked");
                        var index = scope.list.indexOf(scope.value);
                        if (checked && index == -1) {
                            if (setup) elem.prop("checked", false);
                            else scope.list.push(scope.value);
                        } else if (!checked && index != -1) {
                            if (setup) elem.prop("checked", true);
                            else scope.list.splice(index, 1);
                        }
                    };

                    var setupHandler = handler.bind(null, true);
                    var changeHandler = handler.bind(null, false);

                    elem.on("change", function () {
                        scope.$apply(changeHandler);
                    });
                    scope.$watch("list", setupHandler, true);
                }
            };
        })
        .filter('dateAgo', ["$sce", function ($sce) {
            return function (val) {
                return moment(val).fromNow();
            };
        }])
        .filter("range", function () {
            return function (input, total) {
                total = parseInt(total);
                for (var i = 0; i < total; i++) input.push(i);
                return input;
            };
        })
        .directive('currencyInput', function ($filter, $browser) {
            return {
                require: 'ngModel',
                link: function ($scope, $element, $attrs, ngModelCtrl) {
                    var listener = function () {
                        // setTimeout(() => {
                        var value = $element.val().replace(/[^0-9.-]/g, '')
                        $element.val($filter('number')(value, 2))

                        // }, 3500);
                    }
                    // This runs when we update the text field
                    ngModelCtrl.$parsers.push(function (viewValue) {
                        return viewValue.replace(/[^0-9.-]/g, '');
                    })

                    // This runs when the model gets updated on the scope directly and keeps our view in sync
                    ngModelCtrl.$render = function () {
                        $element.val($filter('number')(ngModelCtrl.$viewValue, 2))
                    }

                    $element.bind('blur', listener)
                    // $element.bind('keydown', function (event) {
                    // 	var key = event.keyCode
                    // If the keys include the CTRL, SHIFT, ALT, or META keys, or the arrow keys, do nothing.
                    // This lets us support copy and paste too
                    // if (key == 91 || (15 < key && key < 19) || (37 <= key && key <= 40))
                    // 	setTimeout(function(){
                    // 		return $browser.defer(listener) // Have to do this or changes don't get picked up properly
                    // 	},1000)
                    // })

                    $element.bind('paste cut', function () {
                        $browser.defer(listener)
                    })
                }

            }
        })
        .directive("numericOnly", function ($filter) {
            return {
                require: "ngModel",
                link: function (scope, element, attrs, modelCtrl) {
                    function numberLoad() {
                        var strinput = modelCtrl.$$rawModelValue;
                        //filter user input
                        var transformedInput = strinput ?
                            strinput.replace(/[^,\d,-]/g, "") :
                            null;
                        //remove trailing 0
                        if (transformedInput.charAt(0) <= "0") {
                            transformedInput = null;
                            modelCtrl.$setViewValue(transformedInput);
                            modelCtrl.$render();
                        } else {
                            var decimalSplit = transformedInput.split(",");
                            var intPart = decimalSplit[0];
                            var decPart = decimalSplit[1];
                            //remove previously formated number
                            intPart = intPart.replace(/,/g, "");
                            //split whole number into array of 3 digits
                            if (intPart.length > 3) {
                                var intDiv = Math.floor(intPart.length / 3);
                                var strfraction = [];
                                var i = intDiv,
                                    j = 3;

                                while (intDiv > 0) {
                                    strfraction[intDiv] = intPart.slice(
                                        intPart.length - j,
                                        intPart.length - (j - 3)
                                    );
                                    j = j + 3;
                                    intDiv--;
                                }
                                var k = j - 3;
                                if (intPart.length - k > 0) {
                                    strfraction[0] = intPart.slice(0, intPart.length - k);
                                }
                            }
                            //join arrays
                            if (strfraction == undefined) {
                                return;
                            }
                            var currencyformat = strfraction.join(".");
                            //check for leading comma
                            if (currencyformat.charAt(0) == ".") {
                                currencyformat = currencyformat.slice(1);
                            }

                            if (decPart == undefined) {
                                modelCtrl.$setViewValue(currencyformat);
                                modelCtrl.$render();
                                return;
                            } else {
                                currencyformat = currencyformat + "," + decPart.slice(0, 2);
                                modelCtrl.$setViewValue(currencyformat);
                                modelCtrl.$render();
                            }
                        }
                    }
                    element.bind("keyup", function (inputValue, e) {
                        numberLoad();
                    });
                    element.ready(function (inputValue, e) {
                        numberLoad();
                    });
                }
            };
        })
        .filter("formatPrice", function () {
            return function (
                price,
                digits,
                thoSeperator,
                decSeperator,
                bdisplayprice
            ) {
                var i;
                digits = typeof digits === "undefined" ? 2 : digits;
                bdisplayprice =
                    typeof bdisplayprice === "undefined" ? true : bdisplayprice;
                thoSeperator = typeof thoSeperator === "undefined" ? "." : thoSeperator;
                decSeperator = typeof decSeperator === "undefined" ? "," : decSeperator;
                price = price.toString();
                var _temp = price.split(".");
                var dig = typeof _temp[1] === "undefined" ? "00" : _temp[1];
                if (bdisplayprice && parseInt(dig, 10) === 0) {
                    dig = "-";
                } else {
                    dig = dig.toString();
                    if (dig.length > digits) {
                        dig = Math.round(
                            parseFloat("0." + dig) * Math.pow(10, digits)
                        ).toString();
                    }
                    for (i = dig.length; i < digits; i++) {
                        dig += "0";
                    }
                }
                var num = _temp[0];
                var s = "",
                    ii = 0;
                for (i = num.length - 1; i > -1; i--) {
                    s =
                        (ii++ % 3 === 2 ? (i > 0 ? thoSeperator : "") : "") +
                        num.substr(i, 1) +
                        s;
                }
                return s;
                // return s + decSeperator + dig;
            };
        })

        .directive("rowSelect", rowSelect)
        .directive("rowSelectAll", rowSelectAll)
        .directive("contextMenu", function ($timeout) {
            return {
                restrict: "A",
                scope: "@&",
                compile: function compile(tElement, tAttrs, transclude) {
                    return {
                        post: function postLink(scope, iElement, iAttrs, controller) {
                            var ul;
                            var last = null;
                            // ul.css({ 'display': 'none' });
                            $(iElement).on("contextmenu", function (event) {
                                event.preventDefault();
                                // $("a.jstree-anchor").removeClass('jstree-clicked');
                                var newId = $(iElement).data("id");
                                scope.saveId(newId);

                                if (typeof iAttrs.custom === "undefined" || typeof iAttrs.contexcustom === "customContext") {
                                    var newValue = $(iElement)
                                        .find("input")
                                        .prop("checked");
                                    var selected = scope.selected.length;

                                    if (newValue == false) {
                                        if (selected == 1) {
                                            $timeout(function () {
                                                $(".custom-table")
                                                    .find(".s-row-select")
                                                    .each(function () {
                                                        var prop = $(this).prop("checked");
                                                        if (prop == true) {
                                                            $(this)
                                                                .parent()
                                                                .triggerHandler("click");
                                                        }
                                                    });
                                            });
                                        }
                                    }
                                    if (newValue === false) {
                                        $timeout(function () {
                                            $(iElement)
                                                .find(".row-select")
                                                .triggerHandler("click");
                                        });
                                    }
                                    if (typeof iAttrs.contexcustom === "undefined") {
                                        ul = $("#" + iAttrs.contextMenu);
                                    } else {
                                        $timeout(function () {
                                            scope.contextmenu(iAttrs.custom, setShow);
                                            ul = $("#" + iAttrs.contextMenu);
                                        });
                                    }
                                } else {
                                    if ($(this).is(".jstree-clicked")) {
                                        var setShow = true;
                                    } else {
                                        var setShow = false;
                                    }
                                    $timeout(function () {
                                        scope.contextmenu(iAttrs.custom, setShow);
                                        ul = $("#" + iAttrs.contextMenu);
                                    });
                                    $(this).addClass("jstree-clicked2");
                                }
                                $timeout(function () {
                                    var X = event.clientX;
                                    var Y = event.clientY;
                                    ul.css({
                                        display: "block",
                                        position: "fixed",
                                        top: Y + "px",
                                        left: X + "px"
                                    });
                                    last = event.timeStamp;
                                });
                            });
                            $(document).on("click", function (event) {
                                ul = $("#" + iAttrs.contextMenu);
                                var target = $(event.target);
                                if (!target.is(".popover") &&
                                    !target.parents().is(".popover")
                                ) {
                                    if (last === event.timeStamp) return;
                                    ul.css({
                                        display: "none"
                                    });
                                    $(iElement).removeClass("jstree-clicked2");
                                }
                            });
                        }
                    };
                }
            };
        })
        .factory("lia", function (
            $uibModalStack,
            $timeout,
            $uibModal,
            toastr,
            $rootScope,
            baSidebarService,
            $window,
            $sce,
            $state,
            $localStorage
        ) {
            var self = {};
            self.jstree = function ($scope) {
                var refreshJs = function () {
                    angular
                        .element(document)
                        .injector()
                        .invoke(function ($compile) {
                            $compile($("#js-tree").contents())($scope);
                        });
                };
                $scope.$watch(
                    function () {
                        return {
                            w: $("#js-tree").width(),
                            h: $("#js-tree").height()
                        };
                    },
                    function (newValue, oldValue) {
                        if (newValue.w != oldValue.w || newValue.h != oldValue.h) {
                            // Do something ...
                            $timeout(function () {
                                refreshJs();
                            });
                        }
                    },
                    true
                );
            };
            self.collapsed = function () {
                var str = $window.location.href;
                var checkwebview = str.match(/webview=true/);
                if (checkwebview != undefined && checkwebview[0] == "webview=true") {
                    $localStorage.webview = true;
                    baSidebarService.setMenuCollapsed(true);
                } else if ($localStorage.webview != undefined) {
                    baSidebarService.setMenuCollapsed(true);
                }
            };
            self.check_id = async function ($scope, $loading, toastr, id) {
                if (angular.element(".modal-open").length != 0) {
                    setTimeout(() => {
                        self.check_id($scope, $loading, toastr, id);
                    }, 1000)
                } else {
                    if (id) {
                        try {
                            $scope.form = {};
                            $scope.showForm();
                            await $scope.view_object(id);
                            await setTimeout(() => {
                                console.log($scope.form, 'ini form pages');
                                let check = $scope.form ? Object.keys($scope.form) : [];
                                if (check.length == 0) {
                                    $rootScope.closemodal();
                                    $loading.finish('save');
                                    toastr.error('Data not found');
                                    console.log($scope.form, "mAsuk sini 12");
                                }
                            })
                        } catch (error) {
                            console.log("mAsuk sini");
                            if (angular.element(".modal-open").length != 0)
                                $rootScope.closemodal();

                            $loading.finish('save');
                            toastr.error(error);
                        }
                    }
                }
            };
            self.init = function ($scope, data) {
                $scope.form = {};
                $scope.view_object = function (id = null) {
                    $scope.form = {};
                    if (id == null) var selected = $scope.getId;
                    else var selected = id;
                    if (typeof $scope.getParams == "undefined") {
                        var obj = self.viewByAttr(data, "id", selected);
                        $scope.form.id = selected;
                    } else {
                        var obj = self.viewByAttr(data, $scope.getParams, selected);
                    }
                    $scope.form = obj;
                    // console.log($scope.form);
                };
                $scope.doEdit = function () {
                    if (typeof $scope.getParams == "undefined") {
                        var id = $scope.form.id;
                    } else {
                        var id = $scope.form[$scope.getParams];
                    }
                    var index = data.findIndex(x => x.id === id);
                    data[index] = $scope.form;
                    // console.log(id);
                    $scope.showEditMsg();
                };
                $scope.doDelete = function () {
                    var id = $scope.selected.length;
                    if (typeof $scope.getParams == "undefined") {
                        while (id--) {
                            self.removeByAttr(data, "id", $scope.selected[id]);
                        }
                    } else {
                        while (id--) {
                            self.removeByAttr(data, $scope.getParams, $scope.selected[id]);
                        }
                    }
                    $scope.selected = [];
                    $scope.showDeleteMsg();
                    // console.log(id);
                };
            };
            self.select_control = function ($scope) {
                $scope.selected = [];
                $scope.selectedByAttr = [];
                $scope.selectAll = function (collection, attr = "Id") {
                    self.selectAll($scope, collection, attr);
                };
                $scope.select = function (id) {
                    self.select($scope, id);
                };
            };
            self.behaviour = function ($scope) {
                $scope.saveId = function (newId) {
                    $scope.getId = newId.toString();
                };
                $scope.showSuccessMsg = function () {
                    toastr.success("Data Berhasil Di Save");
                };
                $scope.showEditMsg = function () {
                    toastr.success("Data Berhasil Di Edit");
                };
                $scope.showDeleteMsg = function () {
                    toastr.success("Data Berhasil Di Hapus");
                };
                var full_control = function () {
                    $scope.action = {};
                    $scope.action.control = true;
                    $scope.action.add = false;
                    $scope.action.edit = false;
                    $scope.action.view = false;
                }
                $scope.behaviour_add = function () {
                    full_control();
                    $scope.action.add = true;
                }
                $scope.behaviour_view = function () {
                    $scope.selected = [];
                    full_control();
                    $scope.control = false;
                    $scope.view = true;
                }
                $scope.behaviour_edit = function () {
                    full_control();
                    $scope.edit = true;
                    $scope.edits = true;
                }
            };
            self.modal = function ($scope, $rootScope) {
                $scope.alert = function (page, size) {
                    var modal = $uibModal.open({
                        animation: true,
                        templateUrl: page,
                        size: size,
                        scope: $scope,
                        controller: function ($scope, $uibModalInstance, $rootScope) {
                            $rootScope.closeAlert = function () {
                                $uibModalInstance.dismiss('cancel');
                            }
                        },
                        resolve: {
                            items: function () {
                                return $scope.items;
                            }
                        }
                    })
                };
                $scope.open = function (page, size, id) {
                    $scope.openedPage = page;
                    $scope.openedSize = size;
                    if (id) {
                        $state.transitionTo($state.$current, {
                            id: id
                        }, {
                            location: true,
                            inherit: true,
                            relative: $state.$current,
                            notify: false
                        })
                    }
                    var modal = $uibModal.open({
                        animation: true,
                        templateUrl: page,
                        size: size,
                        scope: $scope,
                        controller: function ($scope, $uibModalInstance, $rootScope) {
                            $rootScope.closemodal = function () {
                                $uibModalInstance.dismiss("cancel");
                            };
                        },
                        resolve: {
                            items: function () {
                                return $scope.items;
                            }
                        }
                    }).closed.then(function () {
                        $scope.selected = [];
                        if ($scope.add || ($scope.control == true)) {
                            $scope.openDiscard();
                        }
                        angular.element('.dw-loading').removeClass('dw-loading-active');
                        angular.element('.st-selected').removeClass("st-selected");
                        angular.element('.s-row-select').prop("checked", false);
                        if ($scope.results) {
                            $scope.results.forEach(function (val) {
                                val.isSelected = false;
                            });
                        }
                        // let urlhash=window.location.hash.split('/')[1];
                        // console.log($state.$current,'iNI state dari factory');

                        $state.transitionTo($state.$current, {
                            id: undefined
                        }, {
                            location: true,
                            inherit: true,
                            relative: $state.$current,
                            notify: false
                        })
                        // window.location.hash="#/"+urlhash+'/';
                    });
                };
                $scope.openDiscard = function () {
                    var modal = $uibModal.open({
                        animation: true,
                        template: '<div class="modal-content modal-delete"> <div class="modal-body"> <p>Are you sure want to Discard unsaved changes?</p> </div> <div class="modal-footer" style="border-radius: 0px;"><button class="btn btn-default" autofocus ng-click="$close();open(openedPage,openedSize,form.Id)">Cancel</button> <button ng-click="$close();closemodal()" class="btn btn-danger">Discard</button></div> </div>',
                        size: "sm",
                        scope: $scope
                    });
                };
                $scope.openDelete = function (page, size) {
                    var modal = $uibModal.open({
                        animation: true,
                        template: '<div class="modal-content modal-delete"> <div class="modal-body"> <p>Are you sure want to delete selected data?</p> </div> <div class="modal-footer" style="border-radius: 0px;"><button class="btn btn-default" ng-click="$close()">No</button> <button ng-click="doDelete();$close();" class="btn btn-danger">Yes</button></div> </div>',
                        size: "sm",
                        scope: $scope
                    });
                };
                $scope.openNonDismiss = function (page, size, id) {
                    var modal = $uibModal
                        .open({
                            animation: true,
                            templateUrl: page,
                            size: size,
                            scope: $scope,
                            backdrop: "static",
                            controller: function ($scope, $uibModalInstance, $rootScope) {
                                $rootScope.closemodal = function () {
                                    $uibModalInstance.dismiss("cancel");
                                };
                            }
                        })
                        .rendered.then(function () {
                            $uibModalStack.getTop().value.modalDomEl.attr("id", id);
                        });
                };
            };
            self.selectAll = function (scope, collection, attr = "Id") {
                if (scope.selected.length === 0) {
                    angular.forEach(collection, function (val) {
                        scope.selected.push(val[attr]);
                    });
                } else if (
                    scope.selected.length > 0 &&
                    scope.selected.length != collection.length
                ) {
                    angular.forEach(collection, function (val) {
                        var found = scope.selected.indexOf(val[attr]);
                        if (found == -1) scope.selected.push(val[attr]);
                    });
                } else {
                    scope.selected = [];
                }
            };
            self.select = function (scope, id) {
                var found = scope.selected.indexOf(id);
                if (found == -1) scope.selected.push(id);
                else scope.selected.splice(found, 1);
            };
            self.removeByAttr = function (arr, attr, value) {
                var i = arr.length;
                while (i--) {
                    if (
                        arr[i] &&
                        arr[i].hasOwnProperty(attr) &&
                        (arguments.length > 2 && arr[i][attr] === value)
                    ) {
                        arr.splice(i, 1);
                    }
                }
                return arr;
            };
            self.viewByAttr = function (arr, attr, value) {
                var i = arr.length;
                while (i--) {
                    if (
                        arr[i] &&
                        arr[i].hasOwnProperty(attr) &&
                        (arguments.length > 2 && arr[i][attr] === value)
                    ) {
                        // arr.splice(i, 1);
                        return angular.copy(arr[i]);
                    }
                }
            };

            self.contextmenu = function ($scope, custom = [], privileges) {
                var induk = "";
                induk += '<ul id="menuOptions" class="dropdown-menu context-menu" style="min-width:130px !important;border-radius:0;cursor:pointer !important;"></ul>';
                $("#context").html(induk);
                $scope.$watchCollection('selected', function (newVal, oldVal) {
                    var html = "";
                    if (custom.length > 0) {
                        if (custom.indexOf('setuju') != -1) html += '<li><a ng-click="doSetuju()"><i class="fa fa-check text-success"></i>  Approve</a></li>';
                        if (custom.indexOf('tolak') != -1) html += '<li><a ng-click="doTolak()"><i class="fa fa-close text-warning"></i>  Reject</a></li>';
                        if ($scope.selected.length == 1 && (privileges != undefined && privileges.CanUpdate)) {
                            if (custom.indexOf('edit') != -1) html += '<li><a ng-click="showForm();behaviour_edit();view_object();"><i class="fa fa-edit text-primary"></i>  Edit</a></li>';
                        }
                        if (custom.indexOf('hapus') != -1 && (privileges != undefined && privileges.CanDelete)) html += '<li><a ng-click="openDelete()"><i class="fa fa-trash text-danger"></i>  Delete</a></li>';
                    } else {
                        html += '<li><a ng-click="test()"><i class="fa fa-check text-success"></i>  Approve</a></li>';
                        html += '<li><a ng-click="test()"><i class="fa fa-close text-warning"></i>  Reject</a></li>';
                        if ($scope.selected.length == 1 && (privileges != undefined && privileges.CanUpdate)) {
                            html += '<li><a ng-click="showForm();behaviour_edit();view_object();"><i class="fa fa-edit text-primary"></i>  Edit</a></li>';
                        }
                        if (privileges != undefined && privileges.CanDelete) {
                            html += '<li><a ng-click="openDelete()"><i class="fa fa-trash text-danger"></i>  Delete</a></li>';
                        }
                    }
                    $("#menuOptions").html(html);
                    angular.element(document).injector().invoke(function ($compile) {
                        $compile($("#context").contents())($scope);
                    });
                });
            };
            self.generateTableReport = ($scope) => {
                $scope.getTable = (data, IsPrint) => {
                    var titles = "",
                        header = "",
                        content = "";
                    if (data != undefined) {
                        if (IsPrint) {
                            titles = titles + "<div class='wrapper'>";
                            for (let i = 0; i < data.Titles.length; i++) {
                                if (data.Titles[i].Size == 3) {
                                    titles = titles + "<div class='d-subject'>" + data.Titles[i].Label + "</div>";
                                } else if (data.Titles[i].Size == 2) {
                                    titles = titles + "<div class='d-title'>" + data.Titles[i].Label + "</div>";
                                } else {
                                    titles = titles + "<div class='d-period'>" + data.Titles[i].Label + "</div>";
                                }
                            }
                            titles = titles + "</div>";
                        }
                        header = "<table class='table table-bordered custom-table'><thead>";
                        for (let x = 0; x < data.Header.length; x++) {
                            header = header + "<tr>";
                            for (let i = 0; i < data.Header[x].length; i++) {
                                header = header + "<th ";
                                if (data.Header[x][i].RowSpan != 0) {
                                    header = header + "rowspan='" + data.Header[x][i].RowSpan + "' class='v-align'>" + data.Header[x][i].Label + "</th>";
                                } else if (data.Header[x][i].ColSpan != 0) {
                                    header = header + "colspan='" + data.Header[x][i].ColSpan + "'>" + data.Header[x][i].Label + "</th>";
                                } else {
                                    header = header + ">" + data.Header[x][i].Label + "</th>";
                                }
                            }
                            header = header + "</tr>";
                        }
                        header = header + "</thead>";
                        content = "<tbody>";
                        for (let y = 0; y < data.Body.length; y++) {
                            content = content + "<tr>";
                            for (let n = 0; n < data.Body[y].length; n++) {
                                content = content + "<td><span class='text-" + data.Body[y][n].Align.toLowerCase() + "'>" + data.Body[y][n].Label + "</span></td>"

                            }
                            content = content + "</tr>";
                        }
                        if (data.Body.length == 0) {
                            content = content + "<tr><td colspan='12'>Data Not Found</td></tr>"
                        }
                        content = content + "</tbody></table>"
                        $scope.Tables = true;
                        return $sce.trustAsHtml(titles + header + content);
                    }
                };
                $scope.print = (data, IsPrint) => {
                    var innerContents = $scope.getTable(data, IsPrint);
                    var popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no, resizable=no');
                    popupWinindow.document.open();
                    popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="app/customNewTab-48e7fceb41.css" /></head><body onload="window.print();window.close()">' + innerContents + '</html>');
                    popupWinindow.document.close();
                }
            }
            return self;
        })
        .filter("groupSelectpickerOptions", GroupSelectpickerOptions);

    function GroupSelectpickerOptions() {
        return function (items, props) {
            var out = [];

            if (angular.isArray(items)) {
                var keys = Object.keys(props);

                items.forEach(function (item) {
                    var itemMatches = false;

                    for (var i = 0; i < keys.length; i++) {
                        var prop = keys[i];
                        var text = props[prop].toLowerCase();
                        if (
                            item[prop]
                            .toString()
                            .toLowerCase()
                            .indexOf(text) !== -1
                        ) {
                            itemMatches = true;
                            break;
                        }
                    }

                    if (itemMatches) {
                        out.push(item);
                    }
                });
            } else {
                // Let the output be the input untouched
                out = items;
            }

            return out;
        };
    }
})();
/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    //baConfigProvider.changeTheme({blur: true});
    //
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('BlurAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(3000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 7000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.Document')
        .directive('uploadProfile', function () {
            return {
                scope: true, //create a new scope  
                link: function (scope, el, attrs) {
                    el.bind('change', function (event) {
                        var files = event.target.files;
                        var event = event.target;
                        //iterate files since 'multiple' may be specified on the element  
                        for (var i = 0; i < files.length; i++) {
                            //emit event upward  
                            scope.$emit("selectedFileProfile", {
                                file: files[i],
                                event: event
                            });
                        }
                    });
                }
            };
        })
        .controller('DocumentCtrl', Controller);

    function Controller($scope, $controller, $loading, $timeout, DocumentSvc, $filter) {
        // Inherit from Base Controller
        angular.extend(this, $controller('BaseController', {
            $scope: $scope
        }));
        $scope.service = DocumentSvc;
        $scope.contextMenu([]);
        $scope.showForm = function () {
            $scope.form = {};
            $scope.form.trackings = [];
            $scope.ui_select = {};
            $scope.other = {};
            $scope.open('app/pages/document/form.html', 'xlg');
        }

        $scope.beforeSave = function () {
            $scope.form.document_type_id = $scope.ui_select.document_type.id;
            $scope.form.document_type_value = $scope.ui_select.document_type.value;
            $scope.form.branch_id = $scope.ui_select.branch.id;
        }
        $scope.afterSave = function () {
            $scope.ui_select.unit = $filter('filter')($scope.listUnit, {
                'id': $scope.form.unit_id
            }, true)[0] || undefined;
            $scope.ui_select.branch = $filter('filter')($scope.listBranch, {
                'id': $scope.form.branch_id
            }, true)[0] || undefined;
            $scope.ui_select.document_type = $filter('filter')($scope.listDocumentType, {
                'id': $scope.form.document_type_id
            }, true)[0] || undefined;
            if ($scope.form.image_file_url != null) {
                $scope.other.disableFileInputPhoto = true;
            } else {
                $scope.other.disableFileInputPhoto = false;
            }
        }

        $scope.getUnit = function () {
            $scope.spinUnit = true;
            $scope.listUnit = [];
            $scope.ui_select.unit = undefined;
            $scope.ui_select.branch = undefined;
            $scope.ui_select.employee = undefined;
            return $scope.service.getUnit().then(res => {
                if (res.data.error_code == 0) {
                    $scope.listUnit = res.data.data;
                } else {
                    $scope.setResponse(res);
                }
                $scope.spinUnit = false;
            });
        }
        $scope.getUnit();
        $scope.getBranch = function (unitId) {
            $scope.spinBranch = true;
            $scope.listBranch = [];
            $scope.ui_select.branch = undefined;
            $scope.ui_select.employee = undefined;
            return $scope.service.getBranch(unitId).then(res => {
                if (res.data.error_code == 0) {
                    $scope.listBranch = res.data.data;
                } else {
                    $scope.setResponse(res);
                }
                $scope.spinBranch = false;
            });
        }
        $scope.getDocumentType = function () {
            $scope.spinDocumentType = true;
            $scope.listDocumentType = [];
            $scope.ui_select.document_type = undefined;
            return $scope.service.getDocumentType().then(res => {
                if (res.data.error_code == 0) {
                    $scope.listDocumentType = res.data.data;
                } else {
                    $scope.setResponse(res)
                }
                $scope.spinDocumentType = false;
            });
        }
        $scope.getDocumentType();
        $scope.afterView = async function () {
            await Promise.all([
                $scope.getUnit(),
                $scope.getDocumentType(),
                $scope.getBranch($scope.form.unit_id),
            ])
            $scope.afterSave();
        }

        $scope.deleteRow = function (index) {
            $scope.form.trackings.splice(index, 1);
        }
        $scope.addRow = function () {
            if ($scope.form.trackings == undefined) {
                $scope.form.trackings = [];
            }
            var data = {
            }
            $scope.form.trackings.push(data);
        }

        $scope.$on("selectedFileProfile", function (event, args) {
            $scope.$apply(function () {
                var p = args.file;
                $scope.form.tmp_image_file = p
                var oFReader = new FileReader();
                oFReader.readAsDataURL(p);
                oFReader.onload = function (oFREvent) {
                    $scope.$apply(function () {
                        $scope.form.image_file_url = oFREvent.target.result;
                    });
                };
            });
        });

        //Export
        $scope.export_ui_select = {};
        $scope.export_form = {};
        $scope.openExport = function () {
            $scope.export_ui_select = {};
            $scope.export_form = {};
            $scope.open('app/pages/document/export.html');
        }
        $scope.format = 'dd-MMM-yyyy';
        $scope.listPeriod = ["Ranged Date", "Monthly"];
        var convertDate = function (date) {
            return $filter("date")(new Date(date), "y-MM-dd");
        }
        $scope.getPeriod = (param) => {
            if (param == "month") {
                $scope.spinMonth = true;
                $scope.listMonth = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
                $scope.spinMonth = false;
            } else {
                $scope.spinYear = true;
                $scope.listYear = [];
                let year = new Date().getFullYear() + 1;
                for (let i = 0; i < 10; i++) {
                    year = year - 1;
                    $scope.listYear.push(year);
                }
                $scope.spinYear = false;
            }
        }
        $scope.getPeriod('month');
        $scope.getPeriod('year');

        $scope.doExport = () => {
            $loading.start('save');
            let param1, param2;
            if ($scope.export_ui_select.period == "Monthly") {
                param1 = ($scope.listMonth.findIndex(x => x == $scope.export_ui_select.month)) + 1;
                param2 = $scope.export_ui_select.year;
            } else if ($scope.export_ui_select.period == "Ranged Date") {
                param1 = convertDate($scope.export_form.PeriodStart);
                param2 = convertDate($scope.export_form.PeriodEnd);
            }
            return $scope.service.export($scope.export_ui_select.period, param1, param2).success(function (data, status, headers, config) {
                $loading.finish('save');
                $timeout(function () {
                    var blob = new Blob([data], {
                        type: "application/vnd.ms-excel"
                    });
                    var objectUrl = URL.createObjectURL(blob);
                    window.open(objectUrl);
                });
            }).error(function (data, status, headers, config) {
                console.log('Failed to download Excel')
                $loading.finish('save');
            });
        };
    };
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.HistoryTracking')
        
        .controller('HistoryTrackingCtrl', Controller);

    function Controller($scope, $controller, $loading, $timeout, HistoryTrackingSvc, $filter) {
        // Inherit from Base Controller
        angular.extend(this, $controller('BaseController', {
            $scope: $scope
        }));
        $scope.service = HistoryTrackingSvc;
    };
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      // timeOut: 9000000000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-center',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.Enumeration')
        .controller('EnumerationCtrl', Controller);

    function Controller($scope, $controller, EnumerationSvc) {
        // Inherit from Base Controller
        angular.extend(this, $controller('BaseController', {
            $scope: $scope
        }));
        $scope.service = EnumerationSvc;
        $scope.contextMenu([]);
        $scope.showForm = function () {
            $scope.form = {};
            $scope.ui_select = {};
            $scope.open('app/pages/generalData/enumeration/form.html', 'lg');
        }
    };
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.Branch')
        .controller('BranchCtrl', Controller);

    function Controller($scope,$controller,BranchSvc, toastr, $filter) {
        // Inherit from Base Controller
        angular.extend(this, $controller('BaseController', {
            $scope: $scope
        }));
        $scope.service = BranchSvc;
        $scope.contextMenu([]);
        $scope.showForm = function () {
            $scope.form = {};
            $scope.form.head_office = false;
            $scope.ui_select = {};
            $scope.open('app/pages/generalData/branch/form.html', 'lg');
        }
        $scope.beforeSave = function(){
            $scope.form.unit_id = $scope.ui_select.unit.id;
        }
        $scope.afterSave = function () {
            $scope.ui_select.unit = $filter('filter')($scope.listUnit, {
                'id': $scope.form.unit_id
            }, true)[0] || undefined;
        }
        $scope.afterView = async function () {
            await $scope.getUnit();
            $scope.afterSave();
        }

        //Get Data Kebutuhan
        $scope.getUnit = function(){
            $scope.spinUnit = true;
            $scope.listUnit = [];
            $scope.ui_select.unit = undefined;
            return $scope.service.getUnit().then(res =>{
                if(res.data.error_code == 0){
                    $scope.listUnit = res.data.data;
                }else{
                    $scope.setResponse(res)
                }
                $scope.spinUnit = false;
            });
        }
        $scope.getUnit();
    };
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .service('dashboardCalendar', dashboardCalendar);

  /** @ngInject */
  function dashboardCalendar() {

  }
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.Unit')
        .controller('UnitCtrl', Controller);

    function Controller($scope, $controller, UnitSvc) {
        // Inherit from Base Controller
        angular.extend(this, $controller('BaseController', {
            $scope: $scope
        }));
        $scope.service = UnitSvc;
        $scope.contextMenu([]);
        $scope.showForm = function () {
            $scope.form = {};
            $scope.ui_select = {};
            $scope.open('app/pages/generalData/unit/form.html', 'lg');
        }
    };
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('blurFeed', blurFeed);

  /** @ngInject */
  function blurFeed() {
    return {
      restrict: 'E',
      controller: 'BlurFeedCtrl',
      templateUrl: 'app/pages/dashboard/blurFeed/blurFeed.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('BlurFeedCtrl', BlurFeedCtrl);

  /** @ngInject */
  function BlurFeedCtrl($scope) {
    $scope.feed = [
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
        time: 'Today 11:55 pm',
        ago: '25 minutes ago',
        expanded: false,
      }, {
        type: 'video-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Added new video',
        text: '"Vader and Me"',
        preview: 'app/feed/vader-and-me-preview.png',
        link: 'https://www.youtube.com/watch?v=IfcpzBbbamk',
        time: 'Today 9:30 pm',
        ago: '3 hrs ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Added new image',
        text: '"My little kitten"',
        preview: 'app/feed/my-little-kitten.png',
        link: 'http://api.ning.com/files/DtcI2O2Ry7A7VhVxeiWfGU9WkHcMy4WSTWZ79oxJq*h0iXvVGndfD7CIYy-Ax-UAFCBCdqXI4GCBw3FOLKTTjQc*2cmpdOXJ/1082127884.jpeg',
        time: 'Today 2:20 pm',
        ago: '10 hrs ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'Haha lol',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'geo-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted location',
        text: '"New York, USA"',
        preview: 'app/feed/new-york-location.png',
        link: 'https://www.google.by/maps/place/New+York,+NY,+USA/@40.7201111,-73.9893872,14z',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Posted new message',
        text: "First snake: I hope I'm not poisonous. Second snake: Why? First snake: Because I bit my lip!",
        time: '12.11.2015',
        ago: '3 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Posted new message',
        text: 'How do you smuggle an elephant across the border? Put a slice of bread on each side, and call him "lunch".',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'When your hammer is C++, everything begins to look like a thumb.',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Alexander',
        surname: 'Demeshko',
        header: 'Posted new message',
        text: '“I mean, they say you die twice. One time when you stop breathing and a second time, a bit later on, when somebody says your name for the last time." ©',
        time: '15.11.2015',
        ago: '6 days ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted photo',
        text: '"Protein Heroes"',
        preview: 'app/feed/genom.png',
        link: 'https://dribbble.com/shots/2504810-Protein-Heroes',
        time: '16.11.2015',
        ago: '7 days ago',
        expanded: false,
      },
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Why did the CoffeeScript developer keep getting lost? Because he couldn\'t find his source without a map',
        time: '18.11.2015',
        ago: '9 days ago',
        expanded: false,
      }
    ];

    $scope.expandMessage = function(message){
      message.expanded = !message.expanded;
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardCalendar', dashboardCalendar);

  /** @ngInject */
  function dashboardCalendar() {
    return {
      restrict: 'E',
      controller: 'DashboardCalendarCtrl',
      templateUrl: 'app/pages/dashboard/dashboardCalendar/dashboardCalendar.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardCalendarCtrl', DashboardCalendarCtrl);

  /** @ngInject */
  function DashboardCalendarCtrl(baConfig) {
    var dashboardColors = baConfig.colors.dashboard;
    var $element = $('#calendar').fullCalendar({
      //height: 335,
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'month,agendaWeek,agendaDay'
      },
      defaultDate: '2016-03-08',
      selectable: true,
      selectHelper: true,
      select: function (start, end) {
        var title = prompt('Event Title:');
        var eventData;
        if (title) {
          eventData = {
            title: title,
            start: start,
            end: end
          };
          $element.fullCalendar('renderEvent', eventData, true); // stick? = true
        }
        $element.fullCalendar('unselect');
      },
      editable: true,
      eventLimit: true, // allow "more" link when too many events
      events: [
        {
          title: 'All Day Event',
          start: '2016-03-01',
          color: dashboardColors.silverTree
        },
        {
          title: 'Long Event',
          start: '2016-03-07',
          end: '2016-03-10',
          color: dashboardColors.blueStone
        },
        {
          title: 'Dinner',
          start: '2016-03-14T20:00:00',
          color: dashboardColors.surfieGreen
        },
        {
          title: 'Birthday Party',
          start: '2016-04-01T07:00:00',
          color: dashboardColors.gossipDark
        }
      ]
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardLineChart', dashboardLineChart);

  /** @ngInject */
  function dashboardLineChart() {
    return {
      restrict: 'E',
      controller: 'DashboardLineChartCtrl',
      templateUrl: 'app/pages/dashboard/dashboardLineChart/dashboardLineChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardLineChartCtrl', DashboardLineChartCtrl);

  /** @ngInject */
  function DashboardLineChartCtrl(baConfig, layoutPaths, baUtil) {
    var layoutColors = baConfig.colors;
    var graphColor = baConfig.theme.blur ? '#000000' : layoutColors.primary;
    var chartData = [
      { date: new Date(2012, 11), value: 0, value0: 0 },
      { date: new Date(2013, 0), value: 15000, value0: 19000},
      { date: new Date(2013, 1), value: 30000, value0: 20000},

      { date: new Date(2013, 2), value: 25000, value0: 22000},
      { date: new Date(2013, 3), value: 21000, value0: 25000},
      { date: new Date(2013, 4), value: 24000, value0: 29000},
      { date: new Date(2013, 5), value: 31000, value0: 26000},
      { date: new Date(2013, 6), value: 40000, value0: 25000},
      { date: new Date(2013, 7), value: 37000, value0: 20000},
      { date: new Date(2013, 8), value: 18000, value0: 22000},
      { date: new Date(2013, 9), value: 5000, value0: 26000},
      { date: new Date(2013, 10), value: 40000, value0: 30000},
      { date: new Date(2013, 11), value: 20000, value0: 25000},
      { date: new Date(2014, 0), value: 5000, value0: 13000},

      { date: new Date(2014, 1), value: 3000, value0: 13000},
      { date: new Date(2014, 2), value: 1800, value0: 13000},
      { date: new Date(2014, 3), value: 10400, value0: 13000},
      { date: new Date(2014, 4), value: 25500, value0: 13000},
      { date: new Date(2014, 5), value: 2100, value0: 13000},
      { date: new Date(2014, 6), value: 6500, value0: 13000},
      { date: new Date(2014, 7), value: 1100, value0: 13000},
      { date: new Date(2014, 8), value: 17200, value0: 13000},
      { date: new Date(2014, 9), value: 26900, value0: 13000},
      { date: new Date(2014, 10), value: 14100, value0: 13000},
      { date: new Date(2014, 11), value: 35300, value0: 13000},
      { date: new Date(2015, 0), value: 54800, value0: 13000},
      { date: new Date(2015, 1), value: 49800, value0: 13000}
    ];

    var chart = AmCharts.makeChart('amchart', {
      type: 'serial',
      theme: 'blur',
      marginTop: 15,
      marginRight: 15,
      dataProvider: chartData,
      categoryField: 'date',
      categoryAxis: {
        parseDates: true,
        gridAlpha: 0,
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText
      },
      valueAxes: [
        {
          minVerticalGap: 50,
          gridAlpha: 0,
          color: layoutColors.defaultText,
          axisColor: layoutColors.defaultText
        }
      ],
      graphs: [
        {
          id: 'g0',
          bullet: 'none',
          useLineColorForBulletBorder: true,
          lineColor: baUtil.hexToRGB(graphColor, 0.3),
          lineThickness: 1,
          negativeLineColor: layoutColors.danger,
          type: 'smoothedLine',
          valueField: 'value0',
          fillAlphas: 1,
          fillColorsField: 'lineColor'
        },
        {
          id: 'g1',
          bullet: 'none',
          useLineColorForBulletBorder: true,
          lineColor: baUtil.hexToRGB(graphColor, 0.5),
          lineThickness: 1,
          negativeLineColor: layoutColors.danger,
          type: 'smoothedLine',
          valueField: 'value',
          fillAlphas: 1,
          fillColorsField: 'lineColor'
        }
      ],
      chartCursor: {
        categoryBalloonDateFormat: 'MM YYYY',
        categoryBalloonColor: '#4285F4',
        categoryBalloonAlpha: 0.7,
        cursorAlpha: 0,
        valueLineEnabled: true,
        valueLineBalloonEnabled: true,
        valueLineAlpha: 0.5
      },
      dataDateFormat: 'MM YYYY',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      zoomOutButton: {
        backgroundColor: '#fff',
        backgroundAlpha: 0
      },
      zoomOutText: '',
      pathToImages: layoutPaths.images.amChart
    });

    function zoomChart() {
      chart.zoomToDates(new Date(2013, 3), new Date(2014, 0));
    }

    chart.addListener('rendered', zoomChart);
    zoomChart();
    if (chart.zoomChart) {
      chart.zoomChart();
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {
    return {
      restrict: 'E',
      controller: 'DashboardPieChartCtrl',
      templateUrl: 'app/pages/dashboard/dashboardPieChart/dashboardPieChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardPieChartCtrl', DashboardPieChartCtrl);

  /** @ngInject */
  function DashboardPieChartCtrl($scope, $timeout, baConfig, baUtil) {
    var pieColor = baUtil.hexToRGB(baConfig.colors.defaultText, 0.2);
    $scope.charts = [{
      color: pieColor,
      description: 'New Visits',
      stats: '57,820',
      icon: 'person',
    }, {
      color: pieColor,
      description: 'Purchases',
      stats: '$ 89,745',
      icon: 'money',
    }, {
      color: pieColor,
      description: 'Active Users',
      stats: '178,391',
      icon: 'face',
    }, {
      color: pieColor,
      description: 'Returned',
      stats: '32,592',
      icon: 'refresh',
    }
    ];

    function getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    }

    function loadPieCharts() {
      $('.chart').each(function () {
        var chart = $(this);
        chart.easyPieChart({
          easing: 'easeOutBounce',
          onStep: function (from, to, percent) {
            $(this.el).find('.percent').text(Math.round(percent));
          },
          barColor: chart.attr('rel'),
          trackColor: 'rgba(0,0,0,0)',
          size: 84,
          scaleLength: 0,
          animation: 2000,
          lineWidth: 9,
          lineCap: 'round',
        });
      });

      $('.refresh-data').on('click', function () {
        updatePieCharts();
      });
    }

    function updatePieCharts() {
      $('.pie-charts .chart').each(function(index, chart) {
        $(chart).data('easyPieChart').update(getRandomArbitrary(55, 90));
      });
    }

    $timeout(function () {
      loadPieCharts();
      updatePieCharts();
    }, 1000);
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardMap', dashboardMap);

  /** @ngInject */
  function dashboardMap() {
    return {
      restrict: 'E',
      controller: 'DashboardMapCtrl',
      templateUrl: 'app/pages/dashboard/dashboardMap/dashboardMap.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardMapCtrl', DashboardMapCtrl);

  /** @ngInject */
  function DashboardMapCtrl(baConfig, layoutPaths) {
    var layoutColors = baConfig.colors;
    var map = AmCharts.makeChart('amChartMap', {
      type: 'map',
      theme: 'blur',
      zoomControl: { zoomControlEnabled: false, panControlEnabled: false },

      dataProvider: {
        map: 'worldLow',
        zoomLevel: 3.5,
        zoomLongitude: 10,
        zoomLatitude: 52,
        areas: [
          { title: 'Austria', id: 'AT', color: layoutColors.primary, customData: '1 244', groupId: '1'},
          { title: 'Ireland', id: 'IE', color: layoutColors.primary, customData: '1 342', groupId: '1'},
          { title: 'Denmark', id: 'DK', color: layoutColors.primary, customData: '1 973', groupId: '1'},
          { title: 'Finland', id: 'FI', color: layoutColors.primary, customData: '1 573', groupId: '1'},
          { title: 'Sweden', id: 'SE', color: layoutColors.primary, customData: '1 084', groupId: '1'},
          { title: 'Great Britain', id: 'GB', color: layoutColors.primary, customData: '1 452', groupId: '1'},
          { title: 'Italy', id: 'IT', color: layoutColors.primary, customData: '1 321', groupId: '1'},
          { title: 'France', id: 'FR', color: layoutColors.primary, customData: '1 112', groupId: '1'},
          { title: 'Spain', id: 'ES', color: layoutColors.primary, customData: '1 865', groupId: '1'},
          { title: 'Greece', id: 'GR', color: layoutColors.primary, customData: '1 453', groupId: '1'},
          { title: 'Germany', id: 'DE', color: layoutColors.primary, customData: '1 957', groupId: '1'},
          { title: 'Belgium', id: 'BE', color: layoutColors.primary, customData: '1 011', groupId: '1'},
          { title: 'Luxembourg', id: 'LU', color: layoutColors.primary, customData: '1 011', groupId: '1'},
          { title: 'Netherlands', id: 'NL', color: layoutColors.primary, customData: '1 213', groupId: '1'},
          { title: 'Portugal', id: 'PT', color: layoutColors.primary, customData: '1 291', groupId: '1'},
          { title: 'Lithuania', id: 'LT', color: layoutColors.successLight, customData: '567', groupId: '2'},
          { title: 'Latvia', id: 'LV', color: layoutColors.successLight, customData: '589', groupId: '2'},
          { title: 'Czech Republic ', id: 'CZ', color: layoutColors.successLight, customData: '785', groupId: '2'},
          { title: 'Slovakia', id: 'SK', color: layoutColors.successLight, customData: '965', groupId: '2'},
          { title: 'Estonia', id: 'EE', color: layoutColors.successLight, customData: '685', groupId: '2'},
          { title: 'Hungary', id: 'HU', color: layoutColors.successLight, customData: '854', groupId: '2'},
          { title: 'Cyprus', id: 'CY', color: layoutColors.successLight, customData: '754', groupId: '2'},
          { title: 'Malta', id: 'MT', color: layoutColors.successLight, customData: '867', groupId: '2'},
          { title: 'Poland', id: 'PL', color: layoutColors.successLight, customData: '759', groupId: '2'},
          { title: 'Romania', id: 'RO', color: layoutColors.success, customData: '302', groupId: '3'},
          { title: 'Bulgaria', id: 'BG', color: layoutColors.success, customData: '102', groupId: '3'},
          { title: 'Slovenia', id: 'SI', color: layoutColors.danger, customData: '23', groupId: '4'},
          { title: 'Croatia', id: 'HR', color: layoutColors.danger, customData: '96', groupId: '4'}
        ]
      },

      areasSettings: {
        rollOverOutlineColor: layoutColors.border,
        rollOverColor: layoutColors.primaryDark,
        alpha: 0.8,
        unlistedAreasAlpha: 0.2,
        unlistedAreasColor: layoutColors.defaultText,
        balloonText: '[[title]]: [[customData]] users'
      },


      legend: {
        width: '100%',
        marginRight: 27,
        marginLeft: 27,
        equalWidths: false,
        backgroundAlpha: 0.3,
        backgroundColor: layoutColors.border,
        borderColor: layoutColors.border,
        borderAlpha: 1,
        top: 362,
        left: 0,
        horizontalGap: 10,
        data: [
          {
            title: 'over 1 000 users',
            color: layoutColors.primary
          },
          {
            title: '500 - 1 000 users',
            color: layoutColors.successLight
          },
          {
            title: '100 - 500 users',
            color: layoutColors.success
          },
          {
            title: '0 - 100 users',
            color: layoutColors.danger
          }
        ]
      },
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      pathToImages: layoutPaths.images.amChart
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardTodo', dashboardTodo);

  /** @ngInject */
  function dashboardTodo() {
    return {
      restrict: 'EA',
      controller: 'DashboardTodoCtrl',
      templateUrl: 'app/pages/dashboard/dashboardTodo/dashboardTodo.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardTodoCtrl', DashboardTodoCtrl);

  /** @ngInject */
  function DashboardTodoCtrl($scope, baConfig) {

    $scope.transparent = baConfig.theme.blur;
    var dashboardColors = baConfig.colors.dashboard;
    var colors = [];
    for (var key in dashboardColors) {
      colors.push(dashboardColors[key]);
    }

    function getRandomColor() {
      var i = Math.floor(Math.random() * (colors.length - 1));
      return colors[i];
    }

    $scope.todoList = [
      { text: 'Check me out' },
      { text: 'Lorem ipsum dolor sit amet, possit denique oportere at his, etiam corpora deseruisse te pro' },
      { text: 'Ex has semper alterum, expetenda dignissim' },
      { text: 'Vim an eius ocurreret abhorreant, id nam aeque persius ornatus.' },
      { text: 'Simul erroribus ad usu' },
      { text: 'Ei cum solet appareat, ex est graeci mediocritatem' },
      { text: 'Get in touch with akveo team' },
      { text: 'Write email to business cat' },
      { text: 'Have fun with blur admin' },
      { text: 'What do you think?' },
    ];

    $scope.todoList.forEach(function(item) {
      item.color = getRandomColor();
    });

    $scope.newTodoText = '';

    $scope.addToDoItem = function (event, clickPlus) {
      if (clickPlus || event.which === 13) {
        $scope.todoList.unshift({
          text: $scope.newTodoText,
          color: getRandomColor(),
        });
        $scope.newTodoText = '';
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .service('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {

  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('popularApp', popularApp);

  /** @ngInject */
  function popularApp() {
    return {
      restrict: 'E',
      templateUrl: 'app/pages/dashboard/popularApp/popularApp.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('trafficChart', trafficChart);

  /** @ngInject */
  function trafficChart() {
    return {
      restrict: 'E',
      controller: 'TrafficChartCtrl',
      templateUrl: 'app/pages/dashboard/trafficChart/trafficChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('TrafficChartCtrl', TrafficChartCtrl);

  /** @ngInject */
  function TrafficChartCtrl($scope, baConfig, colorHelper) {

      $scope.transparent = baConfig.theme.blur;
      var dashboardColors = baConfig.colors.dashboard;
      $scope.doughnutData = {
          labels: [
              'Other',
              'Search engines',
              'Referral Traffic',
              'Direct Traffic',
              'Ad Campaigns'
          ],
          datasets: [
              {
                  data: [2000, 1500, 1000, 1200, 400],
                  backgroundColor: [
                      dashboardColors.white,
                      dashboardColors.blueStone,
                      dashboardColors.surfieGreen,
                      dashboardColors.silverTree,
                      dashboardColors.gossip

                  ],
                  hoverBackgroundColor: [
                      colorHelper.shade(dashboardColors.white, 15),
                      colorHelper.shade(dashboardColors.blueStone, 15),
                      colorHelper.shade(dashboardColors.surfieGreen, 15),
                      colorHelper.shade(dashboardColors.silverTree, 15),
                      colorHelper.shade(dashboardColors.gossip, 15)
                  ],
                  percentage: [87, 22, 70, 38, 17]
              }]
      };

      var ctx = document.getElementById('chart-area').getContext('2d');
      window.myDoughnut = new Chart(ctx, {
          type: 'doughnut',
          data: $scope.doughnutData,
          options: {
              cutoutPercentage: 64,
              responsive: true,
              elements: {
                  arc: {
                      borderWidth: 0
                  }
              }
          }
      });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('weather', weather);

  /** @ngInject */
  function weather() {
    return {
      restrict: 'EA',
      controller: 'WeatherCtrl',
      templateUrl: 'app/pages/dashboard/weather/weather.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('WeatherCtrl', WeatherCtrl);

  /** @ngInject */
  function WeatherCtrl($scope, $http, $timeout, $element) {
    var url = 'http://api.openweathermap.org/data/2.5/forecast';
    var method = 'GET';
    var key = '2de143494c0b295cca9337e1e96b00e0';
    var middleOfTheDay = 15;
    $scope.units = 'metric';
    $scope.weatherIcons = {
      '01d': 'ion-ios-sunny-outline',
      '02d': 'ion-ios-partlysunny-outline',
      '03d': 'ion-ios-cloud-outline',
      '04d': 'ion-ios-cloud',
      '09d': 'ion-ios-rainy',
      '10d': 'ion-ios-rainy-outline',
      '11d': 'ion-ios-thunderstorm-outline',
      '13d': 'ion-ios-snowy',
      '50d': 'ion-ios-cloudy-outline',
      '01n': 'ion-ios-cloudy-night-outline',
      '02n': 'ion-ios-cloudy-night',
      '03n': 'ion-ios-cloud-outline',
      '04n': 'ion-ios-cloud',
      '09n': 'ion-ios-rainy',
      '10n': 'ion-ios-rainy-outline',
      '11n': 'ion-ios-thunderstorm',
      '13n': 'ion-ios-snowy',
      '50n': 'ion-ios-cloudy-outline'
    };
    $scope.weather = {};

    $scope.switchUnits = function (name) {
      $scope.units = name;
      $scope.updateWeather();
    };

    $scope.switchDay = function (day) {
      $scope.weather.current = day;
      makeChart($scope.weather.days[$scope.weather.current].timeTemp)
    };

    $scope.updateWeather = function () {
      $http({
        method: method, url: url, params: {
          appid: key,
          lat: $scope.geoData.geoplugin_latitude,
          lon: $scope.geoData.geoplugin_longitude,
          units: $scope.units
        }
      }).then(function success(response) {
        saveWeatherData(response.data);
        makeChart($scope.weather.days[$scope.weather.current].timeTemp)
      }, function error() {
        console.log("WEATHER FAILED")
      });
    };

    function updateGeoData() {
      $http.jsonp('http://www.geoplugin.net/json.gp?jsoncallback=JSON_CALLBACK').then(function success(response) {
        $scope.geoData = response.data;
        $scope.updateWeather();
      }, function error() {
        console.log("GEO FAILED")
      });
    }

    function makeChart(data) {
      AmCharts.makeChart('tempChart', {
        type: 'serial',
        theme: 'blur',
        handDrawn: true,
        categoryField: 'time',
        dataProvider: data,
        valueAxes: [
          {
            axisAlpha: 0.3,
            gridAlpha: 0
          }
        ],
        graphs: [
          {
            bullet: 'square',
            fillAlphas: 0.3,
            fillColorsField: 'lineColor',
            legendValueText: '[[value]]',
            lineColorField: 'lineColor',
            title: 'Temp',
            valueField: 'temp'
          }
        ],
        categoryAxis: {
          gridAlpha: 0,
          axisAlpha: 0.3
        }
      }).write('tempChart');
    }

    function saveWeatherData(data) {
      var firstItem = data.list[0];
      var weather = {
        days: [{
          date: new Date(),
          timeTemp: [],
          main: firstItem.weather[0].main,
          description: firstItem.weather[0].description,
          icon: firstItem.weather[0].icon,
          temp: firstItem.main.temp
        }], current: 0
      };
      data.list.forEach(function (item, i) {
        var itemDate = new Date(item.dt_txt);
        if (itemDate.getDate() !== weather.days[weather.days.length - 1].date.getDate()) {
          weather.days.push({date: itemDate, timeTemp: []});
        }
        var lastItem = weather.days[weather.days.length - 1];
        lastItem.timeTemp.push({
          time: itemDate.getHours(),
          temp: item.main.temp
        });
        if ((weather.days.length > 1 && itemDate.getHours() == middleOfTheDay) || i == data.list.length - 1) {
          lastItem.main = item.weather[0].main;
          lastItem.description = item.weather[0].description;
          lastItem.icon = item.weather[0].icon;
          lastItem.temp = item.main.temp;
          lastItem.date.setHours(i == data.list.length - 1 ? 0 : middleOfTheDay);
          lastItem.date.setMinutes(0);
        }
      });
      console.log(weather.days[weather.current].date);
      weather.days = weather.days.slice(0, $element.attr('forecast') || 5);
      $scope.weather = weather;
    }

    updateGeoData();
  }
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.Application')
        .controller('ApplicationCtrl', Controller);

    function Controller($scope,$controller,ApplicationSvc, toastr, $filter) {
        // Inherit from Base Controller
        angular.extend(this, $controller('BaseController', {
            $scope: $scope
        }));
        $scope.service = ApplicationSvc;
        $scope.contextMenu([]);
        $scope.showForm = function () {
            $scope.form = {};
            $scope.ui_select = {};
            $scope.open('app/pages/userManagement/application/form.html', 'lg');
        }
    };
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.Menu')
        .controller('MenuCtrl', Controller);

    function Controller($scope,$controller,MenuSvc, toastr, $filter) {
        // Inherit from Base Controller
        angular.extend(this, $controller('BaseController', {
            $scope: $scope
        }));
        $scope.service = MenuSvc;
        $scope.contextMenu([]);
        $scope.showForm = function () {
            $scope.form = {};
            $scope.form.active = true;
            $scope.form.all_menues = false;
            $scope.form.unit_filter = false;
            $scope.form.branch_filter = false;
            $scope.form.hidden = false;
            $scope.ui_select = {};
            $scope.open('app/pages/userManagement/menu/form.html', 'lg');
        }
        $scope.beforeSave = function(){
            $scope.form.application_id = $scope.ui_select.application.id;
            if(typeof $scope.ui_select.parent == "object"){
                $scope.form.parent_id = $scope.ui_select.parent.id;
            }
        }
        $scope.afterSave = function () {
            $scope.ui_select.parent = $filter('filter')($scope.listParent, {
                'id': $scope.form.parent_id
            }, true)[0] || undefined;
            $scope.ui_select.application = $filter('filter')($scope.listApplication, {
                'id': $scope.form.application_id
            }, true)[0] || undefined;
        }
        $scope.afterView = async function () {
            await Promise.all([
                $scope.getParent($scope.form.application_id),
                $scope.getApplication()
            ])
            $scope.listParent = _.filter($scope.listParent,function(item){return item.id != $scope.form.id}); 
            $scope.afterSave();
        }

        //Get Data Kebutuhan
        $scope.getParent = function (applicationId) {
            $scope.spinParent = true;
            $scope.listParent = [];
            $scope.ui_select.parent = undefined;
            return $scope.service.getParent(applicationId).then(res => {
                if (res.data.error_code == 0) {
                    $scope.listParent = res.data.data;
                } else {
                    $scope.setResponse(res);
                }
                $scope.spinParent = false;
            });
        }
        $scope.getApplication = function () {
            $scope.spinApplication = true;
            $scope.listApplication = [];
            $scope.ui_select.application = undefined;
            return $scope.service.getApplication().then(res => {
                if (res.data.error_code == 0) {
                    $scope.listApplication = res.data.data;
                } else {
                    $scope.setResponse(res);
                }
                $scope.spinApplication = false;
            });
        }
        $scope.getApplication();
    };
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.Role')
        .controller('RoleCtrl', Controller);

    function Controller($scope,helper,$controller,RoleSvc, toastr, $filter) {
        // Inherit from Base Controller
        angular.extend(this, $controller('BaseController', {
            $scope: $scope
        }));
        $scope.service = RoleSvc;
        $scope.contextMenu([]);
        $scope.showForm = function () {
            $scope.form = {};
            $scope.ui_select = {};
            $scope.open('app/pages/userManagement/role/form.html', 'lg');
        }
        $scope.beforeSave = function(){
            $scope.form.unit_id = $scope.ui_select.unit.id;
            if(typeof $scope.ui_select.parent == "object"){
                $scope.form.parent_id = $scope.ui_select.parent.id;
            }else{
                $scope.form.parent_id = null;
            }
        }
        $scope.afterSave = function () {
            $scope.ui_select.unit = $filter('filter')($scope.listUnit, {
                'id': $scope.form.unit_id
            }, true)[0] || undefined;
            $scope.ui_select.parent = $filter('filter')($scope.listParent, {
                'id': $scope.form.parent_id
            }, true)[0] || undefined;
        }
        $scope.afterView = async function () {
            await Promise.all([
                $scope.getUnit(),
                $scope.getParent($scope.form.unit_id)
            ])
            $scope.listParent = _.filter($scope.listParent,function(item){return item.id != $scope.form.id}); 
            $scope.afterSave();
        }

        //Get Data Kebutuhan
        $scope.getUnit = function(){
            $scope.spinUnit = true;
            $scope.listUnit = [];
            $scope.ui_select.unit = undefined;
            return $scope.service.getUnit().then(res =>{
                if (res.data.error_code == 0) {
                    $scope.listUnit = res.data.data;
                    $scope.listUnit.push({
                        id : 0,
                        name : 'All Unit',
                        code : 'All Unit'
                    })
                    helper.array_move($scope.listUnit,$scope.listUnit.length-1,0);
                } else {
                    $scope.setResponse(res);
                }
                $scope.spinUnit = false;
            });
        }
        $scope.getUnit();
        $scope.getParent = function (unitId) {
            $scope.spinParent = true;
            $scope.listParent = [];
            $scope.ui_select.parent = undefined;
            return $scope.service.getParent(unitId).then(res => {
                if (res.data.error_code == 0) {
                    $scope.listParent = res.data.data;
                } else {
                    $scope.setResponse(res);
                }
                $scope.spinParent = false;
            });
        }
    };
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.Privilege')
        .controller('PrivilegeCtrl', Controller);

    function Controller($scope, $controller, PrivilegeSvc, toastr, $filter, $sce) {
        // Inherit from Base Controller
        angular.extend(this, $controller('BaseController', {
            $scope: $scope
        }));
        $scope.service = PrivilegeSvc;
        $scope.contextMenu(["edit"]);
        $scope.showForm = function () {
            $scope.form = {};
            $scope.ui_select = {};
            $scope.open('app/pages/userManagement/privilege/form.html', 'lg');
        }
        var converToHtml = function (level, index, no) {
            var space = '';
            if (level > 1) {
                for (var i = 0; i < level; i++) {
                    space += '&nbsp;&nbsp;';
                }
            }
            var html = '<tr >';
            html += '<td style="text-align:left;">' + space + no + ' ' + $scope.form.privileges[index].menu_label + '</td>';
            html += '<td style="text-align:center;"><input type="checkbox" ng-model="form.privileges[' + index + '].can_read" ng-disabled="!action.control"></td>';
            html += '<td style="text-align:center;"><input type="checkbox" ng-model="form.privileges[' + index + '].can_create" ng-disabled="!action.control"></td>';
            html += '<td style="text-align:center;"><input type="checkbox" ng-model="form.privileges[' + index + '].can_update" ng-disabled="!action.control"></td>';
            html += '<td style="text-align:center;"><input type="checkbox" ng-model="form.privileges[' + index + '].can_delete" ng-disabled="!action.control"></td>';
            html += '</tr>';
            return html;
        }
        $scope.getMenues = function (menues) {
            var data = [];
            var subMenu = function (menuId, row) {
                var menuData = _.findWhere(menues, {
                    menu_id: menuId
                });
                var subMenues = _.filter(menues, function (item) {
                    return item.menu_parent_id == menuId;
                });
                if (subMenues.length == 0) return null;
                var newSubMenu = [];
                var no = 1;
                for (let x = 0; x < subMenues.length; x++) {
                    subMenues[x].no = menuData.no + no + ".";
                    subMenu(subMenues[x].menu_id)
                    newSubMenu.push(subMenues[x]);
                    no++;
                }
                menuData.subMenu = newSubMenu;
                if (row != undefined) row = menuData;
            }
            let no = 1;
            for (let i = 0; i < menues.length; i++) {
                if (menues[i].menu_parent_id == null) {
                    menues[i].no = no++ + ".";
                    data.push(menues[i]);
                    subMenu(menues[i].menu_id, data[data.length - 1]);
                }
            }
            console.log(data, "ini")
            return data;
        }

        $scope.toHtml = function (data, menues, level) {
            var html = '';
            if (level == undefined) level = 1;
            var no = 1;
            for (let i = 0; i < menues.length; i++) {
                var index = data.findIndex(x => x.menu_id == menues[i].menu_id);
                html += converToHtml(level, index, menues[i].no);
                if (menues[i].subMenu != undefined) {
                    html += $scope.toHtml(data, menues[i].subMenu, level + 1)
                }
                no++;
            }
            return html;
        }
        $scope.generateHtml = function (data) {
            if (data == undefined) return '';
            var html = $scope.toHtml(data, $scope.getMenues(data));
            return $sce.trustAsHtml(html);
        }
        
        //get Data Kebutuhan
        $scope.getAllMenues = function(roleId,applicationId){
            $scope.spinMenu = true;
            return $scope.service.getAllMenues(roleId,applicationId).then(function(res){
                    if(res.data.error_code == 0){
                        $scope.form = res.data.data;
                    }else{
                        $scope.setResponse(res);
                    }
                    $scope.spinMenu = false;
            })
        }
        $scope.getApplication = function () {
            $scope.spinApplication = true;
            $scope.listApplication = [];
            $scope.ui_select.application = undefined;
            return $scope.service.getApplication().then(res => {
                if (res.data.error_code == 0) {
                    $scope.listApplication = res.data.data;
                } else {
                    $scope.setResponse(res);
                }
                $scope.spinApplication = false;
            });
        }
        $scope.getApplication();
    };
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.User')
        .controller('UserCtrl', Controller);

    function Controller($scope, $controller, UserSvc, toastr, $filter,helper) {
        // Inherit from Base Controller
        angular.extend(this, $controller('BaseController', {
            $scope: $scope
        }));
        $scope.service = UserSvc;
        $scope.contextMenu([]);
        $scope.showForm = function () {
            $scope.form = {};
            $scope.units = [];
            $scope.ui_select = {};
            $scope.open('app/pages/userManagement/user/form.html', 'lg');
        }
        $scope.beforeSave = function () {
            $scope.form.user_roles = [];
            if (Array.isArray($scope.units)) {
                $scope.units.map((item,index) =>{
                    item.user_roles.map((role,index2)=>{
                        role.role_id = role.ui_select.role.id;
                        role.user_role_branches = [];
                        if (Array.isArray(role.ui_select.branches)) {
                            role.ui_select.branches.map(branch =>{
                                var newBranch = {
                                    branch_id: branch.id,
                                    branch_name: branch.name,
                                    branch_code: branch.code,
                                    branch_head_office: branch.head_office
                                };
                                if(!$scope.action.add){
                                    newBranch.id = branch.user_role_branch_id;
                                }
                                role.user_role_branches.push(newBranch);
                            })
                        }
                        $scope.form.user_roles.push(role);
                    })
                });
            }
        }
        $scope.afterSave = function () {
            $scope.units.map(function(unit,indexUnit){
                unit.user_roles.map(function(role,indexRole){
                    var userRole = _.find($scope.form.user_roles,function(row){return row.role_id == role.role_id});
                    role.id = userRole.id;
                    if (Array.isArray(role.ui_select.branches)) {
                        role.ui_select.branches.map(branch => {
                            var userRoleBranch = _.find(userRole.user_role_branches, function (row) { return row.branch_id == branch.id });
                            branch.user_role_branch_id = userRoleBranch.id;
                        })
                    }
                });
            });
        }
        $scope.afterView = async function () {
            await $scope.getUnit();
            $scope.spinUnit = true;
            $scope.units = [];
            for(let i=0;i<$scope.form.user_roles.length;i++){
                var item = $scope.form.user_roles[i];
                var checkExist = _.find($scope.units,function(row){return row.ui_select.unit.id == item.role_unit_id});
                if(checkExist == undefined){
                    var unit = {
                        user_roles: [],
                        ui_select: {
                            unit: _.find($scope.listUnit, function (row) { return row.id == item.role_unit_id })
                        },
                        listRole: [],
                        listBranch: []
                    }
                    $scope.units.push(unit);
                    await Promise.all([$scope.getRole(item.role_unit_id, $scope.units.length - 1), $scope.getBranch(item.role_unit_id, $scope.units.length - 1)]);
                }
                var unitIndex = _.findIndex($scope.units, function (row) { return row.ui_select.unit.id == item.role_unit_id });
                if (unitIndex != -1) {
                    var userRole = {
                        id: item.id,
                        ui_select: {
                            role: _.find($scope.units[unitIndex].listRole, function (row) { return row.id == item.role_id }),
                            branches: []
                        }
                    }
                    item.user_role_branches.map(function (user_role_branch) {
                        var checkBranch = _.find($scope.units[unitIndex].listBranch, function (row) { return row.id == user_role_branch.branch_id });
                        if (checkBranch != undefined) {
                            checkBranch.user_role_branch_id = user_role_branch.id;
                            userRole.ui_select.branches.push(checkBranch);
                        }
                    });
                    $scope.units[unitIndex].user_roles.push(userRole);
                }
            }
            $scope.spinUnit = false;
            // $scope.afterSave();
        }

        $scope.addUnit = function () {
            var unit = {
                user_roles: [],
                ui_select: {
                    unit: undefined
                },
                listRole: [],
                listBranch: []
            }
            var user_roles = {
                ui_select: {
                    role: undefined,
                    branches: []
                }
            }
            unit.user_roles.push(user_roles);
            $scope.units.push(unit);
            console.log($scope.units)
        }
        $scope.deleteRole = function(parentIndex,index){
            $scope.units[parentIndex].user_roles.splice(index,1);
        }
        $scope.deleteUnit = function (index) {
            $scope.units.splice(index, 1);
        }
        $scope.addRole = function(index){
            var user_roles = {
                ui_select: {
                    role: undefined,
                    branches: undefined
                }
            }
            $scope.units[index].user_roles.push(user_roles);
        }
        //Get Data Kebutuhan
        $scope.getUnit = function () {
            $scope.spinUnit = true;
            $scope.listUnit = [];
            $scope.ui_select.unit = undefined;
            return $scope.service.getUnit().then(res => {
                if(res.data.error_code == 0){
                    $scope.listUnit = res.data.data;
                     $scope.listUnit.push({
                         id: 0,
                         name: 'All Unit',
                         code: 'All Unit'
                     })
                     helper.array_move($scope.listUnit, $scope.listUnit.length - 1, 0);
                }else{
                    $scope.setResponse(res);
                }
                $scope.spinUnit = false;
            });
        }
        $scope.getUnit();
        $scope.getBranch = function (unitId, index) {
            $scope.units[index].listBranch = [];
            $scope.units[index].user_roles.map(item=>{
                item.ui_select.branches = undefined;
            })
            console.log(index);
            return $scope.service.getBranch(unitId).then(res => {
                if (res.data.error_code == 0) {
                    $scope.units[index].listBranch = res.data.data;
                } else {
                    $scope.setResponse(res);
                }
            });
        }
        $scope.getRole = function (unitId, index) {
            $scope.units[index].listRole = [];
            $scope.units[index].user_roles.map(item => {
                item.ui_select.role = undefined;
            })
            console.log(index);
            return $scope.service.getRole(unitId).then(res => {
                if (res.data.error_code == 0) {
                    $scope.units[index].listRole = res.data.data;
                } else {
                    $scope.setResponse(res);
                }
            });
        }
        $scope.getTracking = function () {
            $scope.listTracking = [];
            return $scope.service.getTracking($scope.form.id).then(res => {
                if (res.data.error_code == 0) {
                    $scope.listTracking = res.data.data;
                } else {
                    $scope.setResponse(res);
                }
            });
        }
        $scope.comparePassword = function (password, confirm) {
            if (confirm != undefined) {
                if (password != confirm) {
                    $scope.notequal = true;
                } else {
                    $scope.notequal = false;
                }
            } else {
                $scope.notequal = false;
            }
        }
    };
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];
    var test = "ini oce";
    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes) {
      return new _factory();

      function _factory() {
          var isMenuCollapsed = shouldMenuBeCollapsed();
          
        this.addStaticItem = function() {
          staticMenuItems.push.apply(staticMenuItems, arguments);
        };
        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0;
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };
        this.getAllStateViewsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateView && result.push(subItem.stateView);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
              .filter(function(s) {
                return s.sidebarMeta;
              })
              .map(function(s) {
                var meta = s.sidebarMeta;
                return {
                  name: s.name,
                  title: s.title,
                  level: (s.name.match(/\./g) || []).length,
                  order: meta.order,
                  icon: meta.icon,
                  stateRef: s.name,
                };
              })
              .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
              });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, $state, baSidebarService, $localStorage, $window, config, baseConfig) {

    $scope.menuItems = baSidebarService.getMenuItems();
    if ($scope.menuItems.length == 0) {
      $localStorage.$reset();
      $window.location.href = config.sso + "?origin_url=" + baseConfig.fe + "&app_id=" + baseConfig.application_id + "&sessionexpired=true";
    }
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;
    $scope.$state = $state;
    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight = $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);
      var subItemsStateViews = baSidebarService.getAllStateViewsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && !_isStateView(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
    function _isStateView(state) {
      return state && subItemsStateViews.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
      $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);
    };

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };
    $scope.isFirstTab = function () {
      vm.selectTab(0);
    };
    $scope.wizarSetTab = function (num) {
      vm.tabNum = num;
    };
    $scope.wizardNumbs = vm.tabNum;

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1);
      $scope.cari(vm.tabNum);
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1);
      $scope.cari(vm.tabNum);
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();
(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .factory('MsgCenterSvc', function ($http, config) {
      return {
        getBranch: function () {
          var url = config.apiGeneral + 'branch?criteria=UnitId:1&sortBy=Name:asc';
          return $http.get(url)
        },
        getBranchProgram: function (id) {
          var url = config.api + 'branchprogram?criteria=IsLeaf:true,BranchId:' + id;
          return $http.get(url)
        },
        getBranchClass: function (id) {
          var url = config.apiLRN + 'branchclass?criteria=BranchProgramId:' + id;
          return $http.get(url)
        },
        getBranchClassAcademicCalendar: function (id) {
          var url = config.apiLRN + 'BranchClassAcademicCalendar?BranchClassId=' + id;
          return $http.get(url)
        },
      };
    })
    .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce, baConfig, lia, MsgCenterSvc, toastr,$filter,$loading) {
    $scope.form = {};
    lia.modal($scope);
    lia.behaviour($scope);
    $scope.getBranch = () => {
      $scope.spinBranch = true;
      return MsgCenterSvc.getBranch().then((res) => {
        if (res.data.ErrorCode == 0) {
          $scope.branch = res.data.Data;
          if ($scope.branch.length == 1) {
            $scope.form.listBranch = $scope.branch[0];
            $scope.getProgram($scope.form.listBranch.Id);
          }
          $scope.spinBranch = false;
        } else {
          $scope.branch = [];
          $scope.spinBranch = false;
        }
      })
    }
    $scope.getProgram = async function (Id) {
      $scope.spinProgram = true;
      $scope.form.listProgram = undefined;
      return MsgCenterSvc.getBranchProgram(Id).then(function (res) {
        if (res.data.ErrorCode == 0) {
          $scope.Program = res.data.Data
        } else {
          toastr.error(res.data.Message);
          $scope.Program = [];
        }
        $scope.spinProgram = false;
      });
    };
    $scope.getBranchClass = async function (Id) {
      $scope.spinClass = true;
      $scope.form.listClass = undefined;
      return MsgCenterSvc.getBranchClass(Id).then(function (res) {
        if (res.data.ErrorCode == 0) {
          $scope.Class = res.data.Data
        } else {
          toastr.error(res.data.Message);
          $scope.Class = [];
        }
        $scope.spinClass = false;
      });
    };
    var convertDate = function (date) {
      return $filter("date")(new Date(date), "y-MM-dd");
    }
    var dashboardColors = baConfig.colors.dashboard;
    $scope.events=[];
    var getRandomColor=()=>{
      var letters = '0123456789ABCDEF';
      var color = '#';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    }
    $scope.getBranchClassAcademicCalendar = async function (Id) {
      $loading.start('save');
      $scope.BranchClassAcademicCalendar=[];$scope.events=[];
      $scope.spinBranchClassAcademicCalendar = true;
      return MsgCenterSvc.getBranchClassAcademicCalendar(Id).then(function (res) {
        if (res.data.ErrorCode == 0) {
          $scope.BranchClassAcademicCalendar = res.data.Data
          for (let i = 0; i < $scope.BranchClassAcademicCalendar.length; i++) {
            let resp=$scope.BranchClassAcademicCalendar[i];
            let check=_.findWhere($scope.events,{BranchProgramAcademicCalendarComponentName:resp.BranchProgramAcademicCalendarComponentName});
            let color;
            if(check){
              color=check.color
            }else{
              color=getRandomColor();
            }
              $scope.events.push({
                title: resp.BranchProgramAcademicCalendarComponentName,
                detail:resp.BranchProgramAcademicCalendarComponentDetailName,
                start: convertDate(resp.StartDateTime),
                // end: convertDate(new moment(resp.EndDateTime).add(1,'days')),
                end: convertDate(new moment(resp.EndDateTime).add(1, 'days')),
                endDate: convertDate(resp.EndDateTime),
                color: color,
                rendering:'background'
              });
          }
          let config={
            header: {
              left: 'prev,next today',
              center: 'title',
              right: 'month,agendaWeek,agendaDay'
            },
            defaultDate: $scope.events[0].start,
            eventLimit: true, // allow "more" link when too many events
            events: $scope.events
          }
          setTimeout(()=>{
            var $element = $('#calendar').fullCalendar(config);
          },500);
          let detailEvent=_.groupBy($scope.events,'title');
          var keys = Object.keys(detailEvent);
          $scope.detailEvent=[];
          for (let x = 0; x < keys.length; x++) {
            $scope.detailEvent.push({title:keys[x],detail:detailEvent[keys[x]]});
          }
        } else {
          toastr.error(res.data.Message);
          $scope.BranchClassAcademicCalendar = [];
        }
        $loading.finish('save');
        $scope.spinBranchClassAcademicCalendar = false;
      });
    };
    $scope.OpenCalendar = () => {
      $scope.form = {};
      $scope.open('app/theme/components/msgCenter/PopupCalendar.html', 'md');
      $scope.getBranch();
      $scope.BranchClassAcademicCalendar=[];
    }
    // Old
    $scope.users = {
      0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };

    $scope.notifications = [
      {
        image: 'assets/img/information.svg',
        template: 'Anda belum mengikuti Ujian Written Test dan Oral yang seharusnya dilaksanakan tanggal 20 April 2018. Silakan Klik untuk mengajukan permohonan makeup test.',
        time: '5 hrs ago'
      },
      {
        image: 'assets/img/information.svg',
        template: 'Anda belum melakukan pembayaran Cicilan IV.',
        time: '5 hrs ago'
      }
    ];

    $scope.messages = [
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      }
    ];

    $scope.getMessage = function (msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('pageTop', pageTop)
    .directive('listMenu', listMenu)
    .controller('pageTopCtrl', pageTopCtrl)
    .directive('passwordVerify', function () {
      return {
        restrict: 'A',
        require: '?ngModel',
        link: function (scope, elem, attrs, ngModel) {
          ngModel.$validators.myPwdInvalid = function (modelValue, viewValue) {
            return viewValue === scope.$eval(attrs.passwordVerify);
          };
        }
      };
    })
    .factory('PageTopSvc', function ($http, config) {
      return {
        //service
         reset: function (data) {
          var url = config.api + "reset-password";
          return $http.post(url, data);
        },
        changePassword: function (data) {
          var url = config.api + "change-password"
          return $http.post(url, data);
        },
        editProfile: function (data) {
          var url = config.api + "change-profile"
          return $http.post(url, data);
        }
      }
    })
  function pageTopCtrl($loading, $timeout, $scope, $window, $uibModal, config, PageTopSvc, $uibModalStack, $localStorage, toastr, fileReader) {
    $scope.form = {}
    $scope.showPopup = async function (status) {
      $scope.form = {}
      var size = "md";
      if (status == 'ChangePassword') {
        var url = 'ChangePassword.html'
      } else if (status == 'EditProfile') {
        var url = 'EditProfile.html'
        $scope.control = false
        $scope.form.full_name = $localStorage.full_name
        $scope.form.user_name = $localStorage.user_name
        $scope.form.email = $localStorage.email
        $scope.form.id = $localStorage.id
      }
      var modal = $uibModal.open({
        animation: true,
        templateUrl: 'app/theme/components/pageTop/' + url,
        size: size,
        scope: $scope,
        controller: function ($scope, $uibModalInstance, $rootScope) {
          $rootScope.closemodal = function () {
            $uibModalInstance.dismiss('cancel');
          }
        }
      });
    }
    $scope.UrlFp = "assets/img/app/profile/avatar.png";
    $scope.isForgot = false
    $scope.isForgotFunct = function (status) {
      if (status == false) {
        $scope.isForgot = false
      } else {
        $scope.isForgot = true
      }
    }
    $scope.comparePassword = function (password, confirm) {
      if (confirm != undefined) {
        if (password != confirm) {
          $scope.notequal = true;
        } else {
          $scope.notequal = false;
        }
      } else {
        $scope.notequal = false;
      }
    }
    $scope.action = {};
    $scope.submitEditProfile = function () {
      $loading.start('save')
      PageTopSvc.editProfile($scope.form).then(function (res) {
        $loading.finish('save')
        if (res.data.error_code == 0) {
          toastr.success("Successfully Edit Profile");
          $localStorage.user_name = $scope.form.user_name
          $localStorage.email = $scope.form.email
          $localStorage.full_name = $scope.form.full_name
          $scope.action.control = !$scope.action.control;
        }else{
          toastr.error(res.data.message);
        }
      });
    }
    $scope.submitChangePassword = function () {
      $loading.start('save')
      var data = {
        id : $localStorage.id,
        old_password :$scope.form.OldPassword,
        new_password :$scope.form.NewPassword
      }
      PageTopSvc.changePassword(data).then(function (res) {
        $loading.finish('save')
        if (res.data.error_code == 0) {
          toastr.success("Successfully Change Password");
        } else {
          toastr.error(res.data.message);
        }
      });
    }
  }

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html',
      controller: 'pageTopCtrl',
    };
  }
  function listMenu() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/listMenu.html'
    };
  }

})(); 
/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '='
      }
    };
  }

})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
angular.module('BlurAdmin').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/dashboard/dashboard.html','<dashboard-pie-chart></dashboard-pie-chart><div class="row"><div class="col-lg-6 col-md-12 col-sm-12" ba-panel="" ba-panel-title="Acquisition Channels" ba-panel-class="medium-panel traffic-panel"><traffic-chart></traffic-chart></div><div class="col-lg-6 col-md-12 col-sm-12" ba-panel="" ba-panel-title="Users by Country" ba-panel-class="medium-panel"><dashboard-map></dashboard-map></div></div><div class="row"><div class="col-xlg-9 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="row"><div class="col-xlg-8 col-lg-12 col-md-12 col-sm-7 col-xs-12" ba-panel="" ba-panel-title="Revenue" ba-panel-class="medium-panel"><dashboard-line-chart></dashboard-line-chart></div><div class="col-xlg-4 col-lg-12 col-md-12 col-sm-5 col-xs-12" ba-panel="" ba-panel-class="popular-app medium-panel"><popular-app></popular-app></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-12 col-xs-12" ba-panel="" ba-panel-title="Feed" ba-panel-class="large-panel with-scroll feed-panel"><blur-feed></blur-feed></div></div><div class="row shift-up"><div class="col-xlg-3 col-lg-6 col-md-6 col-xs-12" ba-panel="" ba-panel-title="To Do List" ba-panel-class="xmedium-panel feed-comply-panel with-scroll todo-panel"><dashboard-todo></dashboard-todo></div><div class="col-xlg-6 col-lg-6 col-md-6 col-xs-12" ba-panel="" ba-panel-title="Calendar" ba-panel-class="xmedium-panel feed-comply-panel with-scroll calendar-panel"><dashboard-calendar></dashboard-calendar></div></div><div class="row"><div class="col-lg-4 col-sm-6 col-xs-12"><div ba-panel="" ba-panel-title="Weather" ba-panel-class="medium-panel with-scroll"><blur-weather forecast="5"></blur-weather></div></div></div>');
$templateCache.put('app/pages/document/export.html','<div class="row"><div class="col-md-12"><div class="panel"><div class="panel-heading"><h6 class="panel-title fs-14">Export Document <button type="button" class="close" data-dismiss="dialog" style="color: #616161" ng-click="$close()"><span aria-hidden="true">&times;</span> <span class="sr-only">Close</span></button></h6></div><div class="panel-body"><form class="form-horizontal" ng-submit="doExport()"><div class="form-group row clearfix"><label class="col-sm-3">Period</label><div class="col-sm-9"><ui-select ng-model="export_ui_select.period" lass="form-control" theme="bootstrap" bs-validation="" required=""><ui-select-match placeholder="Select Period">{{$select.selected}}</ui-select-match><ui-select-choices repeat="list in listPeriod | filter: $select.search"><div ng-bind-html="list | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="form-group row clearfix" ng-if="export_ui_select.period==\'Monthly\'"><label class="col-sm-3"></label><div class="col-sm-4"><div class="input-group"><ui-select ng-model="export_ui_select.month" lass="form-control" theme="bootstrap" bs-validation="" required=""><ui-select-match placeholder="Select Month">{{$select.selected}}</ui-select-match><ui-select-choices repeat="list in listMonth | filter: $select.search"><div ng-bind-html="list | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-sm-4 col-sm-offset-1 pl-0"><div class="input-group"><ui-select ng-model="export_ui_select.year" lass="form-control" theme="bootstrap" ng-disabled="export_ui_select.month==undefined" bs-validation="" required=""><ui-select-match placeholder="Select Year">{{$select.selected}}</ui-select-match><ui-select-choices repeat="list in listYear | filter: $select.search"><div ng-bind-html="list | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div><div class="form-group row clearfix" ng-if="export_ui_select.period==\'Ranged Date\'"><label class="col-sm-3"></label><div class="col-sm-4"><div class="input-group"><input type="text" placeholder="dd-MMM-yyyy" class="form-control" ng-model="export_form.PeriodStart" ng-click="exportIsOpenStartDate=true" uib-datepicker-popup="{{format}}" datepicker-options="dateOptions" is-open="exportIsOpenStartDate" close-text="Close" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="exportIsOpenStartDate=true"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-sm-4 col-sm-offset-1 pl-0"><div class="input-group"><input type="text" placeholder="dd-MMM-yyyy" class="form-control" ng-model="export_form.PeriodEnd" ng-click="exportIsOpenEndDate=true" uib-datepicker-popup="{{format}}" datepicker-options="dateOptions" is-open="exportIsOpenEndDate" close-text="Close" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="exportIsOpenEndDate=true"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group row clearfix" style="margin-top:30px;"><div class="col-md-12 col-xs-12 col-sm-12"><button class="btn btn-custom pull-right col-xs-6 margin-left col-md-4 col-sm-6" type="submit"><i class="fa fa-download"></i> Download</button> <button class="btn btn-default pull-right col-xs-6 col-md-4 col-sm-6" type="button" ng-click="$close()"><i class="fa fa-arrow-left"></i> Close</button></div></div></form></div></div></div></div>');
$templateCache.put('app/pages/document/form.html','<div class="row"><div class="col-md-12"><div class="panel"><div class="panel-heading panel-lia"><h3 class="panel-title">Document - Form</h3><button type="button" class="toast-close-button" data-dismiss="dialog" ng-click="$close()"><span aria-hidden="true">&times;</span> <span class="sr-only">Close</span></button></div><div class="panel-body"><form class="form-horizontal" ng-submit="doSubmit();" name="formSubmit" novalidate=""><div class="form-group row clearfix"><label class="col-sm-3">Unit</label><div class="col-md-9"><div class="input-group"><ui-select ng-model="ui_select.unit" lass="form-control" theme="bootstrap" ng-change="getBranch(ui_select.unit.id);" ng-disabled="!action.control" bs-validation="" required=""><ui-select-match placeholder="Pilih Unit">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="list in listUnit | filter: $select.search"><div ng-bind-html="list.name| highlight: $select.search"></div></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="getUnit()" ng-disabled="!action.control"><i class="glyphicon glyphicon-refresh blue" ng-class="{\'gly-spin\':spinUnit==true}"></i></button></span></div></div></div><div class="form-group row clearfix"><label class="col-sm-3">Perusahaan</label><div class="col-md-9"><div class="input-group"><ui-select ng-change="getEmployee(ui_select.branch.id);" ng-model="ui_select.branch" lass="form-control" theme="bootstrap" ng-disabled="!action.control || ui_select.unit.id == undefined" bs-validation="" required=""><ui-select-match placeholder="Pilih Perusahaan">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="list in listBranch | filter: $select.search"><div ng-bind-html="list.name| highlight: $select.search"></div></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="getBranch(ui_select.unit.id)" ng-disabled="!action.control || ui_select.unit.id == undefined"><i class="glyphicon glyphicon-refresh blue" ng-class="{\'gly-spin\':spinBranch==true}"></i></button></span></div></div></div><div class="form-group row cleafix"><label class="col-sm-3">Nama Dokumen</label><div class="col-md-9"><input type="text" class="form-control" ng-model="form.name" ng-readonly="!action.control" required=""></div></div><div class="form-group row cleafix" ng-if="!action.add"><label class="col-sm-3">Kode Dokumen</label><div class="col-md-9"><input type="text" class="form-control" ng-model="form.code" ng-readonly="!action.control" required=""></div></div><div class="form-group row clearfix"><label class="col-sm-3">Jenis</label><div class="col-md-9"><div class="input-group"><ui-select ng-model="ui_select.document_type" lass="form-control" theme="bootstrap" ng-disabled="!action.control" bs-validation="" required=""><ui-select-match placeholder="Pilih Jenis">{{$select.selected.value}}</ui-select-match><ui-select-choices repeat="list in listDocumentType | filter: $select.search"><div ng-bind-html="list.value| highlight: $select.search"></div></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="getDocumentType()" ng-disabled="!action.control"><i class="glyphicon glyphicon-refresh blue" ng-class="{\'gly-spin\':spinDocumentType==true}"></i></button></span></div></div></div><div class="form-group row clearfix"><label class="col-sm-3">Keterangan</label><div class="col-md-9"><textarea class="form-control" ng-model="form.description" ng-readonly="!action.control"></textarea></div></div><div class="form-group row cleafix"><label class="col-sm-3">Gambar (Optional)</label><div class="col-md-9"><div ng-if="!other.disableFileInputPhoto"><input type="file" ng-disabled="!action.control" class="form-control" accept="image/*" upload-profile=""></div><div ng-if="other.disableFileInputPhoto"><label style="display: block"><i>{{form.image_file}}<a ng-disabled="!action.control" class="ChangeFile" ng-click="other.disableFileInputPhoto=false;">Change</a></i></label></div><a href="{{form.image_file_url}}" target="_blank" ng-if="form.image_file_url != undefined"><img ng-if="form.image_file_url != undefined" class="img-thumbnail" ng-src="{{form.image_file_url}}" style="max-width: 500px;max-height: 300px;"></a></div></div><div class="form-group row cleafix" ng-if="!action.add"><label class="col-sm-3">Print Form</label><div class="col-md-9"><a href="{{form.pdf_file_url}}&paper=a4" target="_blank" ng-if="form.pdf_file_url != undefined">Click Here To Download (A4)</a> / <a href="{{form.pdf_file_url}}&paper=a6" target="_blank" ng-if="form.pdf_file_url != undefined">Click Here To Download (A6)</a></div></div><div class="form-group row cleafix"><div class="col-sm-12"><b>Tracking</b></div><div class="col-md-12"><div class="table-responsive"><table class="table table-bordered custom-table"><thead><tr><th class="wid44">No</th><th>Nama Penerima</th><th>Instansi</th><th>Lokasi</th><th>Note</th><th style="width:100px;">Gambar</th><th>Waktu</th><th class="wid44">Aksi</th></tr></thead><tbody><tr ng-repeat="s in form.trackings | orderBy:\'-created_at\'"><td class="vAlign">{{$index+1}}</td><td>{{s.employee_name}}</td><td>{{s.instansi}}</td><td>{{s.location}}</td><td>{{s.note}}</td><td class="v-align" style="padding:5px;"><a href="{{s.image_file_url}}" target="_blank" ng-if="s.image_file_url"><img src="{{s.image_file_url}}" class="img-thumbnail" style="width:30px;height:30px;"></a></td><td>{{s.created_at | date: \'dd-MMM-yyyy HH:mm\'}}</td><td class="vAlign input-table" ng-class="{\'noEvents disableItem\':!action.control}"><span ng-click="deleteRow($index)" class="ion-trash-b deleteItem"></span></td></tr><tr ng-if="form.trackings.length == 0"><td colspan="7">Data Not Found</td></tr></tbody></table></div></div></div><div class="form-group row clearfix"><label class="col-sm-4"></label><div class="col-md-8"><div ng-show="action.control"><button ng-disabled="loading" type="submit" class="btn btn-custom margin-left pull-right col-xs-6 col-md-3"><i class="fa fa-save"></i> Save</button> <button ng-disabled="loading" ng-show="!action.edit" type="button" class="btn btn-default pull-right col-xs-6 col-md-3" ng-click="$close()"><i class="fa fa-close"></i> Cancel</button> <button ng-click="behavior_view()" type="button" ng-show="action.edit" class="btn btn-default pull-right col-xs-6 col-md-3"><i class="fa fa-close"></i> Cancel</button></div><div ng-show="!action.control"><button ng-if="privileges.can_update" ng-disabled="loading" ng-click="behavior_edit();" type="button" class="btn btn-custom margin-left pull-right col-xs-6 col-md-3"><i class="fa fa-edit"></i> Edit</button> <button ng-disabled="loading" class="btn btn-default pull-right col-xs-6 col-md-3" type="button" ng-click="$close()"><i class="fa fa-arrow-left"></i> Close</button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/pages/document/index.html','<div class="row" ng-init="getData()"><div class="col-md-12"><div class="panel"><div class="panel-heading"><h3 class="panel-title">{{privileges.can_read?privileges.menu_label+" - List":"403 Forbidden"}}</h3><content-top ng-if="privileges.can_read"></content-top></div><div class="panel-body" ng-if="privileges.can_read"><div class="btn-group"><button class="btn btn-custom example-responsive" ng-click="refreshTable()"><i class="glyphicon glyphicon-refresh" ng-class="spinReload==true?\'gly-spin\':\'\'"></i></button></div><div class="btn-group" ng-if="privileges.can_create"><button class="btn btn-custom btn-with-icon example-responsive" ng-click="showForm();behavior_add()"><i class="fa fa-file-text-o"></i> <span>Create</span></button></div><div class="btn-group" ng-if="privileges.can_read"><button class="btn btn-success btn-with-icon example-responsive" ng-click="openExport();"><i class="fa fa-file-excel-o"></i> <span>Export to Excel</span></button></div><div class="btn-group" ng-if="privileges.can_delete"><button ng-show="(selected.length > 0)" ng-click="openDelete();" class="btn btn-danger btn-with-icon example-responsive"><i class="fa fa-trash"></i> <span>Delete</span></button></div><div class="pull-right"><span>Total Data : {{dataList.total_data}}</span></div><div st-table="dataList.data" st-pipe="callServer" st-safe-src="dataList.data"><div class="table-responsive"><table class="table table-hover table-bordered custom-table"><thead><tr class="sortable"><th class="v-align table-id" rowspan="2" st-sort="id">No</th><th class="wid44">Select</th><th st-sort="branch_name">Perusahaan</th><th st-sort="name">Nama Dokumen</th><th st-sort="code">Kode Dokumen</th><th st-sort="document_type_value">Jenis</th><th st-sort="description">Deskripsi</th><th st-sort="created_at">Tanggal Dibuat</th></tr><tr><th row-select-all="dataList.data" selected="selected" ng-click="selectAll(dataList.data,\'id\')"></th><th><input st-search="branch_name" type="text" class="form-control custom-control" ng-model="branch_name" ng-change="changeFilter()"></th><th><input st-search="name" type="text" class="form-control custom-control" ng-model="name" ng-change="changeFilter()"></th><th><input st-search="code" type="text" class="form-control custom-control" ng-model="code" ng-change="changeFilter()"></th><th><select st-search="document_type_id" class="form-control custom-control" ng-model="document_type_id" ng-change="changeFilter()"><option value="">Lihat Semua</option><option ng-repeat="s in listDocumentType" value="{{s.id}}">{{s.value}}</option></select></th><th><input st-search="description" type="text" class="form-control custom-control" ng-model="description" ng-change="changeFilter()"></th><th><input st-search="created_at" type="date" class="form-control custom-control" ng-model="created_at" ng-change="changeFilter()"></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="s in (results = dataList.data)" class="editable-row" context-menu="menuOptions" data-id="{{s.id}}" ng-class="$index %2 ==0?\'table-strip\':\'\'"><td ng-click="showForm();behavior_view();viewById(s.id);">{{((dataList.page-1)*limit)+$index+1}}</td><td row-select="s" ng-click="select(s.id)" class="v-align row-select"></td><td ng-click="showForm();behavior_view();viewById(s.id);">{{s.branch_name}}</td><td ng-click="showForm();behavior_view();viewById(s.id);">{{s.name}}</td><td ng-click="showForm();behavior_view();viewById(s.id);">{{s.code}}</td><td ng-click="showForm();behavior_view();viewById(s.id);">{{s.document_type_value}}</td><td ng-click="showForm();behavior_view();viewById(s.id);">{{s.description}}</td><td ng-click="showForm();behavior_view();viewById(s.id);">{{s.created_at | date: \'dd-MMM-yyyy HH:mm\'}}</td></tr><tr ng-if="results.length == 0"><td colspan="12">Data not found</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="12"><div class="loading-indicator"></div></td></tr></tbody></table></div><div class="pull-right" st-pagination="" st-items-by-page="10" st-displayed-pages="5"></div><div class="form-group clearfix pull-right" style="padding-top:21px;"><label class="col-md-4" style="top:8px;">Show</label><div class="col-md-8"><ui-select ng-model="limit" lass="form-control" theme="bootstrap" ng-change="changeFilter();refreshTable(limit)" style="width: 73px;"><ui-select-match placeholder="Select">{{$select.selected}}</ui-select-match><ui-select-choices repeat="list in Limits | filter: $select.search"><div ng-bind-html="list | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/history-tracking/index.html','<div class="row" ng-init="getData()"><div class="col-md-12"><div class="panel"><div class="panel-heading"><h3 class="panel-title">{{privileges.can_read?privileges.menu_label+" - List":"403 Forbidden"}}</h3><content-top ng-if="privileges.can_read"></content-top></div><div class="panel-body" ng-if="privileges.can_read"><div class="btn-group"><button class="btn btn-custom example-responsive" ng-click="refreshTable()"><i class="glyphicon glyphicon-refresh" ng-class="spinReload==true?\'gly-spin\':\'\'"></i></button></div><div class="pull-right"><span>Total Data : {{dataList.total_data}}</span></div><div st-table="dataList.data" st-pipe="callServer" st-safe-src="dataList.data"><div class="table-responsive"><table class="table table-hover table-bordered custom-table"><thead><tr class="sortable"><th class="v-align table-id">No</th><th st-sort="user_created_by.full_name">Nama User</th><th st-sort="document.name">Nama Dokumen</th><th st-sort="employee_name">Nama Penerima</th><th st-sort="instansi">Instansi</th><th st-sort="location">Lokasi</th><th st-sort="note">Note</th><th style="width:100px;">Gambar</th><th st-sort="created_at">Waktu</th></tr><tr><th></th><th><input st-search="user_created_by.full_name" type="text" class="form-control custom-control" ng-model="user_created_by_full_name" ng-change="changeFilter()"></th><th><input st-search="document.name" type="text" class="form-control custom-control" ng-model="document_name" ng-change="changeFilter()"></th><th><input st-search="employee_name" type="text" class="form-control custom-control" ng-model="employee_name" ng-change="changeFilter()"></th><th><input st-search="instansi" type="text" class="form-control custom-control" ng-model="instansi" ng-change="changeFilter()"></th><th><input st-search="location" type="text" class="form-control custom-control" ng-model="location" ng-change="changeFilter()"></th><th><input st-search="note" type="text" class="form-control custom-control" ng-model="note" ng-change="changeFilter()"></th><th></th><th><input st-search="created_at" type="date" class="form-control custom-control" ng-model="created_at" ng-change="changeFilter()"></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="s in (results = dataList.data)" class="editable-row" ng-class="$index %2 ==0?\'table-strip\':\'\'"><td>{{((dataList.page-1)*limit)+$index+1}}</td><td>{{s.created_by_name}}</td><td>{{s.document_name}}</td><td>{{s.employee_name}}</td><td>{{s.instansi}}</td><td>{{s.location}}</td><td>{{s.note}}</td><td class="v-align" style="padding:5px;"><a href="{{s.image_file_url}}" target="_blank" ng-if="s.image_file_url"><img src="{{s.image_file_url}}" class="img-thumbnail" style="width:30px;height:30px;"></a></td><td>{{s.created_at | date: \'dd-MMM-yyyy HH:mm\'}}</td></tr><tr ng-if="results.length == 0"><td colspan="12">Data not found</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="12"><div class="loading-indicator"></div></td></tr></tbody></table></div><div class="pull-right" st-pagination="" st-items-by-page="10" st-displayed-pages="5"></div><div class="form-group clearfix pull-right" style="padding-top:21px;"><label class="col-md-4" style="top:8px;">Show</label><div class="col-md-8"><ui-select ng-model="limit" lass="form-control" theme="bootstrap" ng-change="changeFilter();refreshTable(limit)" style="width: 73px;"><ui-select-match placeholder="Select">{{$select.selected}}</ui-select-match><ui-select-choices repeat="list in Limits | filter: $select.search"><div ng-bind-html="list | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div></div></div></div></div>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index);cari($index);"><div ng-if="title ==\'Master Program\'" class="{{setTop == true ? \'circle-top\' : \'circle\'}} {{$baWizardController.tabNum == $index && step[$index] == false ? \'circle-red\' : \'\'}} {{$baWizardController.tabNum != $index && step[$index] == true || $baWizardController.tabNum == $index && step[$index] == true ? \'circle-green\' : \'\'}}"><span>{{$index+1}}</span></div><div ng-if="title !=\'Master Program\'" class="{{setTop == true ? \'circle-top\' : \'circle\'}} {{$baWizardController.tabNum == $index && step[$index] == true ? \'circle-red\' : \'\'}} {{$baWizardController.tabNum != $index && step[$index] == true ? \'circle-green\' : \'\'}}"><span>{{$index+1}}</span></div>{{t.title}}</div></div><div class="progress ba-wizard-progress"><div ng-if="title !=\'Resource Management\'" class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div><div ng-if="title ==\'Resource Management\'" class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{height: $baWizardController.progress + \'%\'}"></div></div><div class="steps wid-auto" ng-transclude=""></div><nav class="wid-auto"><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-custom"><i class="fa fa-arrow-left"></i> Back</button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-custom">Next <i class="fa fa-arrow-right"></i></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix"><list-menu class="visible-lg-inline"></list-menu></ul>');
$templateCache.put('app/theme/components/msgCenter/PopupCalendar.html','<div class="row"><div class="col-md-12"><div class="panel"><div class="panel-heading panel-lia"><h3 class="panel-title">Calendar Academic</h3><button type="button" class="toast-close-button" data-dismiss="dialog" ng-click="$close()"><span aria-hidden="true">&times;</span> <span class="sr-only">Close</span></button></div><div class="panel-body"><form class="form-horizontal"><div class="form-group row clearfix"><label class="col-sm-2">Branch</label><div class="col-sm-10"><div class="input-group"><ui-select ng-model="form.listBranch" lass="form-control" theme="bootstrap" ng-change="getProgram(form.listBranch.Id)"><ui-select-match placeholder="Select Branch">{{$select.selected.Name}}</ui-select-match><ui-select-choices repeat="list in branch | filter: $select.search"><div ng-bind-html="list.Name| highlight: $select.search"></div></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="getBranch()"><i class="glyphicon glyphicon-refresh" ng-class="{\'gly-spin\':spinBranch==true}"></i></button></span></div></div></div><div class="form-group row clearfix"><label class="col-sm-2">Program</label><div class="col-sm-10"><div class="input-group"><ui-select ng-model="form.listProgram" lass="form-control" theme="bootstrap" ng-disabled="form.listBranch.Id==undefined" ng-change="getBranchClass(form.listProgram.Id)"><ui-select-match placeholder="Select Program">{{$select.selected.Name}}</ui-select-match><ui-select-choices repeat="list in Program | filter: $select.search"><div ng-bind-html="list.Name| highlight: $select.search"></div></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="getBranchClass(form.listProgram.Id)" ng-disabled="form.listBranch.Id==undefined"><i class="glyphicon glyphicon-refresh" ng-class="{\'gly-spin\':spinProgram==true}"></i></button></span></div></div></div><div class="form-group row clearfix"><label class="col-sm-2">Class</label><div class="col-sm-10"><div class="input-group"><ui-select ng-model="form.listClass" lass="form-control" theme="bootstrap" ng-disabled="form.listProgram.Id==undefined" ng-change="getBranchClassAcademicCalendar(form.listClass.Id)"><ui-select-match placeholder="Select Class">{{$select.selected.BranchClassCode}}</ui-select-match><ui-select-choices repeat="list in Class | filter: $select.search"><div ng-bind-html="list.BranchClassCode| highlight: $select.search"></div></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="getBranchClass(form.listProgram.Id)" ng-disabled="form.listProgram.Id==undefined"><i class="glyphicon glyphicon-refresh" ng-class="{\'gly-spin\':spinClass==true}"></i></button></span></div></div></div><div ng-show="BranchClassAcademicCalendar.length > 0"><div class="information-calendar"><div ng-repeat="s in detailEvent"><div style="padding:6px;width:100%;background:{{s.detail[0].color}};color:#fff;opacity: 0.4;">{{s.detail[0].start | date:\'dd\'}} - {{s.detail[s.detail.length-1].endDate | date:\'dd\'}} {{s.detail[0].start | date:\'MMM yyyy\'}} : {{s.title}}</div><p ng-repeat="d in s.detail" style="padding-left:30px;">{{d.start | date:\'dd\'}} - {{d.endDate | date:\'dd\'}} {{d.start | date:\'MMM\'}} : {{d.detail}}</p></div></div><academic-calendar></academic-calendar></div></form></div></div></div></div><button id="hideButton" ng-click="control = false;" type="button" ng-show="false"></button><style>\r\n    .modal-open .modal {\r\n        overflow: hidden!important;\r\n    }\r\n    th.fc-day-header.fc-widget-header {\r\n        color: #000!important;\r\n        text-align: center;\r\n    }\r\n    @media screen and (min-width: 992px){\r\n        .modal-dialog {\r\n            position: relative;\r\n            margin: 61px auto;\r\n        }\r\n    }\r\n    #calendar,.information-calendar{\r\n        height: 294px;\r\n        width: 50%;\r\n        float: left;\r\n        overflow: hidden;\r\n    }\r\n    .fc-scroller.fc-day-grid-container{\r\n        overflow: hidden!important;\r\n    }\r\n    .information-calendar{\r\n        float:right;\r\n        overflow: hidden auto!important;\r\n    }\r\n</style>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems track by $index" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" data-toggle="tooltip" title="{{::item.title }}" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" data-toggle="tooltip" title="{{::item.title }}" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu,selected:$state.includes(subitem.stateView)}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link" data-toggle="tooltip" title="{{::subSubitem.title }}">{{ ::subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}" data-toggle="tooltip" title="{{::subSubitem.title }}" class="sidebarText">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" data-toggle="tooltip" title="{{::subitem.title }}" class="al-sidebar-list-link">{{ ::subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}" data-toggle="tooltip" title="{{::subitem.title }}" class="sidebarText">{{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/pageTop/ChangePassword.html','<div class="row"><div class="col-md-12"><div class="panel"><div class="panel-heading panel-lia"><h3 class="panel-title" ng-if="!isForgot">Change Password</h3><h3 class="panel-title" ng-if="isForgot">Reset Password</h3><button type="button" class="toast-close-button" data-dismiss="dialog" style="color: #616161" ng-click="$close()"><span aria-hidden="true" style="color:white">&times;</span> <span class="sr-only">Close</span></button></div><div class="panel-body"><form class="form-horizontal" ng-submit="submitChangePassword();"><div ng-if="!isForgot"><div class="form-group row clearfix"><label class="col-sm-4">Old Password</label><div class="col-sm-8"><input type="password" class="form-control" ng-model="form.OldPassword" required=""></div></div><div class="form-group row clearfix"><label class="col-sm-4">New Password</label><div class="col-sm-8"><input type="password" class="form-control" ng-model="form.NewPassword" ng-class="notequal==true?\'b-red\':\'\'" ng-change="comparePassword(form.NewPassword,form.RetypeNewPassword)" required=""></div></div><div class="form-group row clearfix"><label class="col-sm-4">Retype New Password</label><div class="col-sm-8"><input type="password" class="form-control" ng-model="form.RetypeNewPassword" ng-class="notequal==true?\'b-red\':\'\'" ng-change="comparePassword(form.NewPassword,form.RetypeNewPassword)" required=""> <span class="error-message" ng-show="notequal==true">Password does not match.</span></div></div></div><div ng-if="isForgot"><div class="form-group row clearfix"><label class="col-sm-3">Email</label><div class="col-sm-9"><input type="email" class="form-control" ng-model="form.Email" required=""></div></div></div><div class="form-group row clearfix"><label class="col-sm-4"></label><div class="col-sm-8"><a class="to-password pull-right no-animate" ng-if="isForgot" ng-click="isForgotFunct(false)">Change Password?</a></div></div><br><div class="form-group row clearfix"><label class="col-sm-4"></label><div class="col-sm-8"><div><button type="submit" ng-if="!isForgot" class="btn btn-custom margin-left pull-right col-xs-6 col-md-4"><i class="fa fa-save"></i> Save</button> <button type="submit" ng-if="isForgot" class="btn btn-custom margin-left pull-right col-xs-6 col-md-4"><i class="fa fa-save"></i> Reset</button> <button type="button" class="btn btn-default pull-right col-xs-6 col-md-4" ng-click="$close()"><i class="fa fa-close"></i> Cancel</button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/theme/components/pageTop/EditProfile.html','<div class="row"><div class="col-md-12"><div class="panel"><div class="panel-heading panel-lia"><h3 class="panel-title">Edit Profile</h3><button type="button" class="toast-close-button" data-dismiss="dialog" style="color: #616161" ng-click="$close()"><span aria-hidden="true" style="color:white">&times;</span> <span class="sr-only">Close</span></button></div><div class="panel-body"><form class="form-horizontal" ng-submit="submitEditProfile();"><div ng-if="!isForgot"><div class="form-group row clearfix"><label class="col-sm-4">Full Name</label><div class="col-sm-8"><input type="text" class="form-control" ng-readonly="!action.control" ng-model="form.full_name" required=""></div></div><div class="form-group row clearfix"><label class="col-sm-4">User Name</label><div class="col-sm-8"><input type="text" class="form-control" ng-readonly="!action.control" ng-model="form.user_name" required=""></div></div><div class="form-group row clearfix"><label class="col-sm-4">Email</label><div class="col-sm-8"><input type="email" class="form-control" ng-model="form.email" ng-readonly="!action.control" required=""></div></div></div><div class="form-group row clearfix"><label class="col-sm-4"></label><div class="col-md-8"><div ng-show="action.control"><button type="submit" class="btn btn-custom margin-left pull-right"><i class="fa fa-save"></i> Save</button> <button type="button" class="btn btn-default pull-right" ng-click="action.control = false"><i class="fa fa-close"></i> Cancel</button></div><div ng-show="!action.control"><button ng-click="action.control = !action.control;" type="button" class="btn btn-custom margin-left pull-right"><i class="fa fa-edit"></i> Edit</button> <button class="btn btn-default pull-right" type="button" ng-click="$close()"><i class="fa fa-arrow-left"></i> Close</button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/theme/components/pageTop/listMenu.html','');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><a href="#/dashboard" class="al-logo clearfix"><span style="color:#2065ad"><img src="assets/img/logo.png" style="width: 140px;"></span></a> <a href="" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a><div class="search brand-lia">PI</div><div class="user-profile clearfix"><div class="al-user-profile" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link"><span class="fullname">{{storage.full_name}}</span> <img src="{{UrlFp}}"></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li class="user-header"><a class="user-info" style="cursor:pointer"><img class="user-image" src="{{UrlFp}}"><p style="white-space: pre-wrap !important; overflow-wrap: break-word;">{{storage.full_name}}</p><div class="w-wrap"><small ng-repeat="s in listUnit" uib-popover-html="\'{{generateRoles(s)}}\'" popover-trigger="mouseenter" popover-title="{{s.unit_code}}" popover-placement="left">{{(listUnit.length-1) == $index?s.unit_code:s.unit_code+\' . \'}}</small></div></a></li><li><a ng-click="showPopup(\'EditProfile\');" style="cursor:pointer"><i class="fa fa-user" aria-hidden="true"></i> Edit Profile</a></li><li><a ng-click="showPopup(\'ChangePassword\');" style="cursor:pointer"><i class="fa fa-key" aria-hidden="true"></i> Change Password</a></li><li class="divider"></li><list-menu class="hidden-lg"></list-menu><li class="divider hidden-lg"></li><li><a href="#" ng-click="logout()" class="signout"><i class="fa fa-power-off"></i>Sign out</a></li></ul></div><msg-center></msg-center></div></div>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<ul class="breadcrumb al-breadcrumb breadcrumb-content"><li><a href="#">Home</a></li><li>{{ activePageTitle }}</li></ul>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">ON</span> <span class="handle"></span> <span class="handle handle-off">OFF</span></div></div></label>');
$templateCache.put('app/pages/dashboard/dashboardCalendar/dashboardCalendar.html','<div id="calendar" class="blurCalendar"></div>');
$templateCache.put('app/pages/dashboard/dashboardLineChart/dashboardLineChart.html','<div id="amchart"></div>');
$templateCache.put('app/pages/dashboard/blurFeed/blurFeed.html','<div class="feed-messages-container" track-width="smallContainerWidth" min-width="360"><div class="feed-message" ng-repeat="message in feed" ng-click="expandMessage(message)"><div class="message-icon" ng-if="message.type == \'text-message\'"><img class="photo-icon" ng-src="{{::( message.author | profilePicture )}}"></div><div class="message-icon" ng-if="message.type != \'text-message\'"><img class="photo-icon" ng-src="{{::( message.author | profilePicture )}}"> <span class="sub-photo-icon" ng-class="::message.type"></span></div><div class="text-block text-message"><div class="message-header"><span class="author">{{ ::message.author }} {{ ::message.surname}}</span></div><div class="message-content line-clamp" ng-class="{\'line-clamp-2\' : !message.expanded}"><span ng-if="message.preview">{{message.header}}</span>{{::message.text}}</div><div class="preview" ng-show="message.expanded" ng-if="message.preview"><a href="{{::message.link}}" target="_blank"><img ng-src="{{ ::( message.preview | appImage )}}"></a></div><div ng-show="message.expanded" class="message-time"><div class="post-time">{{::message.time}}</div><div class="ago-time">{{::message.ago}}</div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboardMap/dashboardMap.html','<div id="amChartMap"></div>');
$templateCache.put('app/pages/dashboard/dashboardTodo/dashboardTodo.html','<div class="task-todo-container" ng-class="{\'transparent\': transparent}"><input type="text" value="" class="form-control task-todo" placeholder="Task to do.." ng-keyup="addToDoItem($event)" ng-model="newTodoText"> <i ng-click="addToDoItem(\'\',true)" class="add-item-icon ion-plus-round"></i><div class="box-shadow-border"></div><ul class="todo-list" ui-sortable="" ng-model="todoList"><li ng-repeat="item in todoList" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false"><div class="blur-container"><div class="blur-box"></div></div><i class="mark" style="background-color: {{::item.color}}"></i> <label class="todo-checkbox custom-checkbox custom-input-success"><input type="checkbox" ng-model="isChecked"> <span class="cut-with-dots">{{ item.text }}</span></label> <i class="remove-todo ion-ios-close-empty" ng-click="item.deleted = true"></i></li></ul></div>');
$templateCache.put('app/pages/dashboard/popularApp/popularApp.html','<div class="popular-app-img-container"><div class="popular-app-img"><img ng-src="{{::( \'app/my-app-logo.png\' | appImage )}}"> <span class="logo-text">Super&nbspApp</span></div></div><div class="popular-app-cost row"><div class="col-xs-9">Most Popular App</div><div class="col-xs-3 text-right">175$</div></div><div class="popular-app-info row"><div class="col-xs-4 text-left"><div class="info-label">Total Visits</div><div>47,512</div></div><div class="col-xs-4 text-center"><div class="info-label">New Visits</div><div>9,217</div></div><div class="col-xs-4 text-right"><div class="info-label">Sales</div><div>2,928</div></div></div>');
$templateCache.put('app/pages/dashboard/trafficChart/trafficChart.html','<div class="channels-block" ng-class="{\'transparent\': transparent}"><div class="chart-bg"></div><div class="traffic-chart" id="trafficChart"><div class="canvas-holder"><canvas id="chart-area" width="280" height="280"></canvas><div class="traffic-text">1,900,128 <span>Views Total</span></div></div></div><div class="channels-info"><div><div class="channels-info-item" ng-repeat="label in doughnutData.labels" ng-init="i = $index; data = doughnutData.datasets[0]"><div class="legend-color" style="background-color: {{::data.backgroundColor[i]}}"></div><p>{{::label}}<span class="channel-number">+{{data.percentage[i]}}%</span></p><div class="progress progress-sm channel-progress"><div class="progress-bar" role="progressbar" aria-valuenow="{{data.percentage[i]}}" aria-valuemin="0" aria-valuemax="100" style="width: {{item.percentage}}%"></div></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/weather/weather.html','<div class="weather-wrapper"><div class="weather-main-info"><h5 class="city-date font-x1dot5"><div>{{geoData.geoplugin_city}} - {{geoData.geoplugin_countryName | uppercase}}</div><div>{{ weather.days[weather.current].date | date : \'EEEE h:mm\'}}</div></h5><div class="weather-description font-x1dot5"><i class="font-x3 {{weatherIcons[weather.days[weather.current].icon]}}"></i><div class="weather-info">{{weather.days[weather.current].main}} - {{weather.days[weather.current].description}}</div></div><div class="weather-temp font-x1dot5"><i class="font-x2 ion-thermometer"></i><div class="weather-info" ng-switch="" on="units"><span ng-switch-when="metric">{{weather.days[weather.current].temp}} \xB0C | <a ng-click="switchUnits(\'imperial\')" href="">\xB0F</a></span> <span ng-switch-when="imperial">{{weather.days[weather.current].temp}} \xB0F | <a ng-click="switchUnits(\'metric\')" href="">\xB0C</a></span></div></div></div><div id="tempChart" class="temp-by-time"></div><div class="select-day"><div class="day" ng-repeat="day in weather.days" ng-click="switchDay($index)"><div><span class="font-x1dot25">{{day.temp}}</span></div><div><i class="weatherIcon font-x2 {{weatherIcons[day.icon]}}"></i> <span class="select-day-info">{{day.main}}</span></div><div><span>{{day.date | date : \'EEE\'}}</span></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboardPieChart/dashboardPieChart.html','<div class="row pie-charts"><div class="pie-chart-item-container" ng-repeat="chart in charts"><div ba-panel=""><div class="pie-chart-item"><div class="chart" rel="{{ ::chart.color }}" data-percent="60"><span class="percent"></span></div><div class="description"><div>{{ ::chart.description }}</div><div class="description-stats">{{ ::chart.stats }}</div></div><i class="chart-icon i-{{ ::chart.icon }}"></i></div></div></div></div>');
$templateCache.put('app/pages/userManagement/menu/form.html','<div class="row"><div class="col-md-12"><div class="panel"><div class="panel-heading panel-lia"><h3 class="panel-title">Menu - Form</h3><button type="button" class="toast-close-button" data-dismiss="dialog" ng-click="$close()"><span aria-hidden="true">&times;</span> <span class="sr-only">Close</span></button></div><div class="panel-body"><form class="form-horizontal" ng-submit="doSubmit();" name="formSubmit" novalidate=""><div class="col-sm-8 no-padding"><div class="form-group row clearfix"><label class="col-sm-4">Application</label><div class="col-md-8"><div class="input-group"><ui-select ng-disabled="!action.control" ng-model="ui_select.application" lass="form-control" theme="bootstrap" ng-change="getParent(ui_select.application.id)" bs-validation="" required=""><ui-select-match placeholder="Select Application">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="list in listApplication | filter: $select.search"><div ng-bind-html="list.name| highlight: $select.search"></div></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-disabled="!action.control" class="btn btn-default" ng-click="getApplication()"><i class="glyphicon glyphicon-refresh blue" ng-class="{\'gly-spin\':spinApplication==true}"></i></button></span></div></div></div><div class="form-group row cleafix"><label class="col-sm-4">Menu Name</label><div class="col-md-8"><input type="text" class="form-control" ng-model="form.menu_name" ng-readonly="!action.control" required=""></div></div><div class="form-group row cleafix"><label class="col-sm-4">Label</label><div class="col-md-8"><input type="text" class="form-control" ng-model="form.label" ng-readonly="!action.control" required=""></div></div><div class="form-group row cleafix"><label class="col-sm-4">Parent Menu</label><div class="col-md-8"><div class="input-group"><ui-select ng-model="ui_select.parent" lass="form-control" theme="bootstrap" ng-disabled="!action.control || ui_select.application.id == undefined"><ui-select-match placeholder="Select Parent Menu">{{$select.selected.menu_name}}</ui-select-match><ui-select-choices repeat="list in listParent | filter: $select.search"><div ng-bind-html="list.menu_name| highlight: $select.search"></div></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="getParent(ui_select.application.id)" ng-disabled="!action.control || ui_select.application.id == undefined"><i style="color: #006BB1" class="glyphicon glyphicon-refresh" ng-class="spinParent==true?\'gly-spin\':\'\'"></i></button></span></div></div></div><div class="form-group row cleafix"><label class="col-sm-4">Url</label><div class="col-md-8"><input type="text" class="form-control" ng-model="form.url" ng-readonly="!action.control" required=""></div></div><div class="form-group row cleafix"><label class="col-sm-4">Sequence</label><div class="col-md-8"><input type="number" class="form-control right-text" ng-model="form.sequence" ng-readonly="!action.control"></div></div></div><div class="col-sm-4 no-padding col-distance"><div class="form-group row cleafix"><div class="col-md-11 col-md-offset-1"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="form.active" ng-disabled="!action.control"> <span style="padding-top:9px;">Active</span></label> <span class="bs-invalid-msg help-block"></span></div></div><div class="form-group row cleafix" style="margin-top: 11px!important;"><div class="col-md-11 col-md-offset-1"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="form.all_menues" ng-disabled="!action.control"> <span style="padding-top:9px;">All App Menues</span></label> <span class="bs-invalid-msg help-block"></span></div></div><div class="form-group row cleafix" style="margin-top: 11px!important;"><div class="col-md-11 col-md-offset-1"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="form.unit_filter" ng-disabled="!action.control"> <span style="padding-top:9px;">Unit Filter</span></label> <span class="bs-invalid-msg help-block"></span></div></div><div class="form-group row cleafix" style="margin-top: 11px!important;"><div class="col-md-11 col-md-offset-1"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="form.branch_filter" ng-disabled="!action.control"> <span style="padding-top:9px;">Branch Filter</span></label> <span class="bs-invalid-msg help-block"></span></div></div><div class="form-group row cleafix" style="margin-top: 11px!important;"><div class="col-md-11 col-md-offset-1"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="form.hidden" ng-disabled="!action.control"> <span style="padding-top:9px;">Hidden</span></label> <span class="bs-invalid-msg help-block"></span></div></div></div><div class="col-sm-12 no-padding"><div class="form-group row clearfix"><label class="col-sm-4"></label><div class="col-md-8"><div ng-show="action.control"><button ng-disabled="loading" type="submit" class="btn btn-custom margin-left pull-right col-xs-6 col-md-3"><i class="fa fa-save"></i> Save</button> <button ng-disabled="loading" ng-show="!action.edit" type="button" class="btn btn-default pull-right col-xs-6 col-md-3" ng-click="$close()"><i class="fa fa-close"></i> Cancel</button> <button ng-click="behavior_view()" type="button" ng-show="action.edit" class="btn btn-default pull-right col-xs-6 col-md-3"><i class="fa fa-close"></i> Cancel</button></div><div ng-show="!action.control"><button ng-show="privileges.can_update" ng-disabled="loading" ng-click="behavior_edit();" type="button" class="btn btn-custom margin-left pull-right col-xs-6 col-md-3"><i class="fa fa-edit"></i> Edit</button> <button ng-disabled="loading" class="btn btn-default pull-right col-xs-6 col-md-3" type="button" ng-click="$close()"><i class="fa fa-arrow-left"></i> Close</button></div></div></div></div></form></div></div></div></div>');
$templateCache.put('app/pages/userManagement/menu/index.html','<div class="row" ng-init="getData()"><div class="col-md-12"><div class="panel"><div class="panel-heading"><h3 class="panel-title">{{privileges.can_read?privileges.menu_label+" - List":"403 Forbidden"}}</h3><content-top ng-if="privileges.can_read"></content-top></div><div class="panel-body" ng-if="privileges.can_read"><div class="btn-group"><button class="btn btn-custom example-responsive" ng-click="refreshTable()"><i class="glyphicon glyphicon-refresh" ng-class="spinReload==true?\'gly-spin\':\'\'"></i></button></div><div class="btn-group" ng-if="privileges.can_create"><button class="btn btn-custom btn-with-icon example-responsive" ng-click="showForm();behavior_add()"><i class="fa fa-file-text-o"></i> <span>Create</span></button></div><div class="btn-group" ng-if="privileges.can_delete"><button ng-show="(selected.length > 0)" ng-click="openDelete();" class="btn btn-danger btn-with-icon example-responsive"><i class="fa fa-trash"></i> <span>Delete</span></button></div><div class="pull-right"><span>Total Data : {{dataList.total_data}}</span></div><div st-table="dataList.data" st-pipe="callServer" st-safe-src="dataList.data"><div class="table-responsive"><table class="table table-hover table-bordered custom-table"><thead><tr class="sortable"><th class="v-align table-id" rowspan="2" st-sort="id">No</th><th class="wid44">Select</th><th st-sort="application.name">Application Name</th><th st-sort="menu_name">Menu Name</th><th st-sort="label">Label</th><th st-sort="parent.menu_name">Parent Menu</th><th st-sort="url">Url</th><th st-sort="sequence">Sequence</th><th st-sort="active">Active</th><th st-sort="all_menues">All App Menues</th><th st-sort="unit_filter">Unit Filter</th><th st-sort="branch_filter">Branch Filter</th><th st-sort="hidden">Hidden Menu</th></tr><tr><th row-select-all="dataList.data" selected="selected" ng-click="selectAll(dataList.data,\'id\')"></th><th><input st-search="application.name" type="text" class="form-control custom-control" ng-model="filterApplicationName" ng-change="changeFilter()"></th><th><input st-search="menu_name" type="text" class="form-control custom-control" ng-model="filterMenuName" ng-change="changeFilter()"></th><th><input st-search="label" type="text" class="form-control custom-control" ng-model="filterLabel" ng-change="changeFilter()"></th><th><input st-search="parent.menu_name" type="text" class="form-control custom-control" ng-model="filterParent" ng-change="changeFilter()"></th><th><input st-search="url" type="text" class="form-control custom-control" ng-model="filterUrl" ng-change="changeFilter()"></th><th><input st-search="sequence" type="text" class="form-control custom-control" ng-model="filterSequence" ng-change="changeFilter()"></th><th><select st-search="active" ng-model="filterActive" ng-change="changeFilter()" class="form-control custom-control"><option value="">Show All</option><option value="1">Yes</option><option value="0">No</option></select></th><th><select st-search="all_menues" ng-model="filterallapp" ng-change="changeFilter()" class="form-control custom-control"><option value="">Show All</option><option value="1">Yes</option><option value="0">No</option></select></th><th><select st-search="unit_filter" ng-model="filterUnitfi" ng-change="changeFilter()" class="form-control custom-control"><option value="">Show All</option><option value="1">Yes</option><option value="0">No</option></select></th><th><select st-search="branch_filter" ng-model="filterbranchfi" ng-change="changeFilter()" class="form-control custom-control"><option value="">Show All</option><option value="1">Yes</option><option value="0">No</option></select></th><th><select st-search="hidden" ng-model="filterhidden" ng-change="changeFilter()" class="form-control custom-control"><option value="">Show All</option><option value="1">Yes</option><option value="0">No</option></select></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="s in (results = dataList.data)" class="editable-row" context-menu="menuOptions" data-id="{{s.id}}" ng-class="$index %2 ==0?\'table-strip\':\' \'"><td ng-click="showForm();behavior_view();viewById(s.id);">{{((dataList.page-1)*limit)+$index+1}}</td><td row-select="s" ng-click="select(s.id)" class="v-align row-select"></td><td ng-click="showForm();behavior_view();viewById(s.id);">{{s.application_name}}</td><td ng-click="showForm();behavior_view();viewById(s.id);">{{s.menu_name}}</td><td ng-click="showForm();behavior_view();viewById(s.id);">{{s.label}}</td><td ng-click="showForm();behavior_view();viewById(s.id);">{{s.parent_menu_name}}</td><td ng-click="showForm();behavior_view();viewById(s.id);">{{s.url}}</td><td ng-click="showForm();behavior_view();viewById(s.id);"><span class="text-right">{{s.sequence}}</span></td><td ng-click="showForm();behavior_view();viewById(s.id);"><span ng-if="s.active == 1" ng-class="s.active == 0?\'red-siyn\':\'green-siyn\'">Active</span> <span ng-if="s.active == 0" ng-class="s.active == 0?\'red-siyn\':\'green-siyn\'">Not Active</span></td><td ng-click="showForm();behavior_view();viewById(s.id);"><span ng-if="s.all_menues == 1" ng-class="s.all_menues == 0?\'red-siyn\':\'green-siyn\'">TRUE</span> <span ng-if="s.all_menues == 0" ng-class="s.all_menues == 0?\'red-siyn\':\'green-siyn\'">FALSE</span></td><td ng-click="showForm();behavior_view();viewById(s.id);"><span ng-if="s.unit_filter == 1" ng-class="s.unit_filter == 0?\'red-siyn\':\'green-siyn\'">TRUE</span> <span ng-if="s.unit_filter == 0" ng-class="s.unit_filter == 0?\'red-siyn\':\'green-siyn\'">FALSE</span></td><td ng-click="showForm();behavior_view();viewById(s.id);"><span ng-if="s.branch_filter == 1" ng-class="s.branch_filter == 0?\'red-siyn\':\'green-siyn\'">TRUE</span> <span ng-if="s.branch_filter == 0" ng-class="s.branch_filter == 0?\'red-siyn\':\'green-siyn\'">FALSE</span></td><td ng-click="showForm();behavior_view();viewById(s.id);"><span ng-if="s.hidden == 1" ng-class="s.hidden == 0?\'red-siyn\':\'green-siyn\'">TRUE</span> <span ng-if="s.hidden == 0" ng-class="s.hidden == 0?\'red-siyn\':\'green-siyn\'">FALSE</span></td></tr><tr ng-if="results.length == 0"><td colspan="13">Data not found</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="13"><div class="loading-indicator"></div></td></tr></tbody></table></div><div class="pull-right" st-pagination="" st-items-by-page="10" st-displayed-pages="5"></div><div class="form-group clearfix pull-right" style="padding-top:21px;"><label class="col-md-4" style="top:8px;">Show</label><div class="col-md-8"><ui-select ng-model="limit" lass="form-control" theme="bootstrap" ng-change="changeFilter();refreshTable(limit)" style="width: 73px;"><ui-select-match placeholder="Select">{{$select.selected}}</ui-select-match><ui-select-choices repeat="list in Limits | filter: $select.search"><div ng-bind-html="list | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/userManagement/privilege/form.html','<div class="row"><div class="col-md-12"><div class="panel"><div class="panel-heading panel-lia"><h3 class="panel-title">Privilege - Form</h3><button type="button" class="toast-close-button" data-dismiss="dialog" ng-click="$close()"><span aria-hidden="true">&times;</span> <span class="sr-only">Close</span></button></div><div class="panel-body"><form class="form-horizontal" ng-submit="doSubmit();" name="formSubmit" novalidate=""><div class="form-group row cleafix"><label class="col-sm-3">Unit</label><div class="col-md-9"><input type="text" class="form-control" ng-model="form.unit_name" ng-readonly="true"></div></div><div class="form-group row cleafix"><label class="col-sm-3">Role</label><div class="col-md-9"><input type="text" class="form-control" ng-model="form.name" ng-readonly="true"></div></div><div class="form-group row clearfix"><label class="col-sm-3">Application</label><div class="col-md-9"><div class="input-group"><ui-select ng-model="ui_select.application" lass="form-control" theme="bootstrap" ng-change="getAllMenues(form.id,ui_select.application.id)" bs-validation="" required=""><ui-select-match placeholder="Select Application">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="list in listApplication | filter: $select.search"><div ng-bind-html="list.name| highlight: $select.search"></div></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="getApplication()"><i class="glyphicon glyphicon-refresh blue" ng-class="{\'gly-spin\':spinApplication==true}"></i></button></span></div></div></div><div class="form-group row cleafix"><div class="col-md-12"><b><u>Menu</u></b><br><table class="table table-bordered custom-table"><thead><tr><th>Menu Name</th><th>Read</th><th>Create</th><th>Update</th><th>Delete</th></tr></thead><tbody ng-if="!spinMenu && form.privileges.length>0" ng-bind-html="generateHtml(form.privileges)" compile-template=""></tbody><tbody ng-if="spinMenu"><tr><td colspan="10"><div class="loading-indicator"></div></td></tr></tbody><tbody ng-if="(form.privileges.length==0 || form.privileges==undefined) && !spinMenu"><tr><td colspan="10">Table Is Empty</td></tr></tbody></table></div></div><div class="form-group row clearfix"><label class="col-sm-4"></label><div class="col-md-8"><div ng-show="action.control"><button ng-disabled="loading" type="submit" class="btn btn-custom margin-left pull-right col-xs-6 col-md-3"><i class="fa fa-save"></i> Save</button> <button ng-disabled="loading" ng-show="!action.edit" type="button" class="btn btn-default pull-right col-xs-6 col-md-3" ng-click="$close()"><i class="fa fa-close"></i> Cancel</button> <button ng-click="behavior_view()" type="button" ng-show="action.edit" class="btn btn-default pull-right col-xs-6 col-md-3"><i class="fa fa-close"></i> Cancel</button></div><div ng-show="!action.control"><button ng-show="privileges.can_update" ng-disabled="loading" ng-click="behavior_edit();" type="button" class="btn btn-custom margin-left pull-right col-xs-6 col-md-3"><i class="fa fa-edit"></i> Edit</button> <button ng-disabled="loading" class="btn btn-default pull-right col-xs-6 col-md-3" type="button" ng-click="$close()"><i class="fa fa-arrow-left"></i> Close</button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/pages/userManagement/privilege/index.html','<div class="row" ng-init="getData()"><div class="col-md-12"><div class="panel"><div class="panel-heading"><h3 class="panel-title">{{privileges.can_read?privileges.menu_label+" - List":"403 Forbidden"}}</h3><content-top ng-if="privileges.can_read"></content-top></div><div class="panel-body" ng-if="privileges.can_read"><div class="btn-group"><button class="btn btn-custom example-responsive" ng-click="refreshTable()"><i class="glyphicon glyphicon-refresh" ng-class="spinReload==true?\'gly-spin\':\'\'"></i></button></div><div class="pull-right"><span>Total Data : {{dataList.total_data}}</span></div><div st-table="dataList.data" st-pipe="callServer" st-safe-src="dataList.data"><div class="table-responsive"><table class="table table-hover table-bordered custom-table"><thead><tr class="sortable"><th class="v-align table-id" rowspan="2" st-sort="id">No</th><th class="wid44">Select</th><th st-sort="unit_name">Unit</th><th st-sort="name">Role</th></tr><tr><th row-select-all="dataList.data" selected="selected" ng-click="selectAll(dataList.data,\'id\')"></th><th><input st-search="unit_name" type="text" class="form-control custom-control" ng-model="unit" ng-change="changeFilter()"></th><th><input st-search="name" type="text" class="form-control custom-control" ng-model="name" ng-change="changeFilter()"></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="s in (results = dataList.data)" class="editable-row" context-menu="menuOptions" data-id="{{s.id}}" ng-class="$index %2 ==0?\'table-strip\':\' \'"><td ng-click="showForm();behavior_view();viewById(s.id);">{{((dataList.page-1)*limit)+$index+1}}</td><td row-select="s" ng-click="select(s.id)" class="v-align row-select"></td><td ng-click="showForm();behavior_view();viewById(s.id);">{{s.unit_name}}</td><td ng-click="showForm();behavior_view();viewById(s.id);">{{s.name}}</td></tr><tr ng-if="results.length == 0"><td colspan="12">Data not found</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="12"><div class="loading-indicator"></div></td></tr></tbody></table></div><div class="pull-right" st-pagination="" st-items-by-page="10" st-displayed-pages="5"></div><div class="form-group clearfix pull-right" style="padding-top:21px;"><label class="col-md-4" style="top:8px;">Show</label><div class="col-md-8"><ui-select ng-model="limit" lass="form-control" theme="bootstrap" ng-change="changeFilter();refreshTable(limit)" style="width: 73px;"><ui-select-match placeholder="Select">{{$select.selected}}</ui-select-match><ui-select-choices repeat="list in Limits | filter: $select.search"><div ng-bind-html="list | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/userManagement/user/form.html','<div class="row"><div class="col-md-12"><div class="panel"><div class="panel-heading panel-lia"><h3 class="panel-title">User - Form</h3><button type="button" class="toast-close-button" data-dismiss="dialog" ng-click="$close()"><span aria-hidden="true">&times;</span> <span class="sr-only">Close</span></button></div><div class="panel-body"><form class="form-horizontal" ng-submit="doSubmit();" name="formSubmit" novalidate=""><div class="form-group row cleafix"><label class="col-sm-3">Username</label><div class="col-md-9"><input type="text" class="form-control" ng-model="form.user_name" ng-readonly="!action.control" required=""></div></div><div class="form-group row cleafix"><label class="col-sm-3">Full Name</label><div class="col-md-9"><input type="text" class="form-control" ng-model="form.full_name" ng-readonly="!action.control" required=""></div></div><div class="form-group row cleafix"><label class="col-sm-3">Email</label><div class="col-md-9"><input type="email" class="form-control" ng-model="form.email" ng-readonly="!action.control" required=""></div></div><div class="form-group row cleafix" ng-if="action.add"><label class="col-sm-3">Password</label><div class="col-md-9"><input type="password" class="form-control" ng-class="notequal==true?\'b-red\':\'\'" ng-model="form.password" ng-readonly="!action.control" ng-change="comparePassword(form.password,form.RetypePassword)" required=""></div></div><div class="form-group row cleafix" ng-if="action.add"><label class="col-sm-3">Re-type Password</label><div class="col-md-9"><input type="password" class="form-control" ng-class="notequal==true?\'b-red\':\'\'" ng-model="form.RetypePassword" ng-readonly="!action.control" ng-change="comparePassword(form.password,form.RetypePassword)" required=""> <span class="error-message" ng-show="notequal==true">Passwords do not match.</span></div></div><div class="form-group row clearfix"><div class="col-sm-12"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="form.active" ng-disabled="!action.control"> <span style="padding-top:9px;">Active</span></label> <span class="bs-invalid-msg help-block"></span></div></div><div class="form-group row cleafix"><div class="col-sm-12"><b style="position: relative; top: 10px;">Roles</b> <button class="btn btn-custom" ng-click="addUnit(units.length)" type="button" ng-disabled="!action.control"><i class="fa fa-plus"></i> Add Unit</button></div><div class="col-md-12"><table class="table table-bordered custom-table"><thead><tr><th class="wid44">No</th><th>Unit Name</th><th class="wid44">Action</th></tr></thead><tbody ng-if="!spinUnit" ng-repeat="s in units" ng-init="index1=$index"><tr><td class="vAlign" rowspan="3">{{$index+1}}</td><td class="input-table"><div class="input-group"><ui-select ng-model="units[$index].ui_select.unit" lass="form-control" theme="bootstrap" class="ui-select-table" ng-disabled="!action.control" ng-change="getBranch(units[$index].ui_select.unit.id,$index);getRole(units[$index].ui_select.unit.id,$index);"><ui-select-match placeholder="Select Unit">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="list in listUnit | filter: $select.search"><div ng-bind-html="list.name| highlight: $select.search"></div></ui-select-choices></ui-select></div></td><td rowspan="3" class="vAlign input-table" ng-class="{\'noEvents disableItem\':!action.control}"><span ng-click="deleteUnit(index1)" class="ion-trash-b deleteItem"></span></td></tr><tr><td class="input-table"><table class="table table-bordered"><thead><tr><th class="wid44"><button class="btnAddRole" type="button" ng-click="addRole(index1)" ng-disabled="!action.control">Add Role</button></th><th>Role Name</th><th>Branch</th></tr></thead><tbody><tr ng-repeat="r in s.user_roles"><td class="vAlign input-table" ng-class="{\'noEvents disableItem\':!action.control}"><span ng-click="deleteRole(index1,$index)" class="ion-trash-b deleteItem"></span></td><td class="input-table"><div class="input-group"><ui-select class="ui-select-table" ng-model="units[index1].user_roles[$index].ui_select.role" lass="form-control" theme="bootstrap" ng-disabled="!action.control || units[index1].ui_select.unit.id==undefined"><ui-select-match placeholder="Select Role">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="list in units[index1].listRole | filter: $select.search"><div ng-bind-html="list.name| highlight: $select.search"></div></ui-select-choices></ui-select></div></td><td class="input-table"><div class="input-group"><ui-select class="ui-select-table" ng-model="units[index1].user_roles[$index].ui_select.branches" lass="form-control" theme="bootstrap" ng-disabled="!action.control || units[index1].user_roles[$index].ui_select.role.id==undefined" close-on-select="false" multiple=""><ui-select-match placeholder="Select Branch">{{$item.name}}</ui-select-match><ui-select-choices repeat="person in units[index1].listBranch | filter:$select.search"><div ng-bind-html="person.name | highlight: $select.search"></div></ui-select-choices></ui-select></div></td></tr></tbody></table></td></tr></tbody><tbody ng-if="units.length==0 && !spinUnit"><tr><td colspan="3">Data Not Found</td></tr></tbody><tbody ng-show="spinUnit"><tr><td colspan="12"><div class="loading-indicator"></div></td></tr></tbody></table></div></div><div class="form-group row cleafix" ng-if="!action.add && form.id != undefined"><div class="col-sm-12"><b>History Tracking</b></div><div class="col-md-12" ng-init="getTracking()"><div class="table-responsive"><table class="table table-bordered custom-table"><thead><tr><th class="wid44">No</th><th>Nama Dokumen</th><th>Nama Penerima</th><th>Lokasi</th><th>Note</th><th style="width:100px;">Gambar</th><th>Waktu</th></tr></thead><tbody><tr ng-repeat="s in listTracking | orderBy:\'created_at\'"><td class="vAlign">{{$index+1}}</td><td>{{s.document_name}}</td><td>{{s.employee_name}}</td><td>{{s.location}}</td><td>{{s.note}}</td><td class="v-align" style="padding:5px;"><a href="{{s.image_file_url}}" target="_blank" ng-if="s.image_file_url"><img src="{{s.image_file_url}}" class="img-thumbnail" style="width:30px;height:30px;"></a></td><td>{{s.created_at | date: \'dd-MMM-yyyy HH:mm\'}}</td></tr><tr ng-if="listTracking.length == 0"><td colspan="7">Data Not Found</td></tr></tbody></table></div></div></div><div class="form-group row clearfix"><label class="col-sm-4"></label><div class="col-md-8"><div ng-show="action.control"><button ng-disabled="loading" type="submit" class="btn btn-custom margin-left pull-right col-xs-6 col-md-3"><i class="fa fa-save"></i> Save</button> <button ng-disabled="loading" ng-show="!action.edit" type="button" class="btn btn-default pull-right col-xs-6 col-md-3" ng-click="$close()"><i class="fa fa-close"></i> Cancel</button> <button ng-click="behavior_view()" type="button" ng-show="action.edit" class="btn btn-default pull-right col-xs-6 col-md-3"><i class="fa fa-close"></i> Cancel</button></div><div ng-show="!action.control"><button ng-show="privileges.can_update" ng-disabled="loading" ng-click="behavior_edit();" type="button" class="btn btn-custom margin-left pull-right col-xs-6 col-md-3"><i class="fa fa-edit"></i> Edit</button> <button ng-disabled="loading" class="btn btn-default pull-right col-xs-6 col-md-3" type="button" ng-click="$close()"><i class="fa fa-arrow-left"></i> Close</button></div></div></div></form></div></div></div></div><style>\r\n    .btnAddRole {\r\n        background: 0 0;\r\n        border: 0;\r\n        outline: 0;\r\n    }\r\n</style>');
$templateCache.put('app/pages/userManagement/user/index.html','<div class="row" ng-init="getData()"><div class="col-md-12"><div class="panel"><div class="panel-heading"><h3 class="panel-title">{{privileges.can_read?privileges.menu_label+" - List":"403 Forbidden"}}</h3><content-top ng-if="privileges.can_read"></content-top></div><div class="panel-body" ng-if="privileges.can_read"><div class="btn-group"><button class="btn btn-custom example-responsive" ng-click="refreshTable()"><i class="glyphicon glyphicon-refresh" ng-class="spinReload==true?\'gly-spin\':\'\'"></i></button></div><div class="btn-group" ng-if="privileges.can_create"><button class="btn btn-custom btn-with-icon example-responsive" ng-click="showForm();behavior_add()"><i class="fa fa-file-text-o"></i> <span>Create</span></button></div><div class="btn-group" ng-if="privileges.can_delete"><button ng-show="(selected.length > 0)" ng-click="openDelete();" class="btn btn-danger btn-with-icon example-responsive"><i class="fa fa-trash"></i> <span>Delete</span></button></div><div class="pull-right"><span>Total Data : {{dataList.total_data}}</span></div><div st-table="dataList.data" st-pipe="callServer" st-safe-src="dataList.data"><div class="table-responsive"><table class="table table-hover table-bordered custom-table"><thead><tr class="sortable"><th class="v-align table-id" rowspan="2" st-sort="id">No</th><th class="wid44">Select</th><th st-sort="user_name">Username</th><th st-sort="full_name">Full Name</th><th st-sort="email">Email</th></tr><tr><th row-select-all="dataList.data" selected="selected" ng-click="selectAll(dataList.data,\'id\')"></th><th><input st-search="user_name" type="text" class="form-control custom-control" ng-model="username" ng-change="changeFilter()"></th><th><input st-search="full_name" type="text" class="form-control custom-control" ng-model="full_name" ng-change="changeFilter()"></th><th><input st-search="email" type="text" class="form-control custom-control" ng-model="email" ng-change="changeFilter()"></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="s in (results = dataList.data)" class="editable-row" context-menu="menuOptions" data-id="{{s.id}}" ng-class="$index %2 ==0?\'table-strip\':\' \'"><td ng-click="showForm();behavior_view();viewById(s.id);">{{((dataList.page-1)*limit)+$index+1}}</td><td row-select="s" ng-click="select(s.id)" class="v-align row-select"></td><td ng-click="showForm();behavior_view();viewById(s.id);">{{s.user_name}}</td><td ng-click="showForm();behavior_view();viewById(s.id);">{{s.full_name}}</td><td ng-click="showForm();behavior_view();viewById(s.id);">{{s.email}}</td></tr><tr ng-if="results.length == 0"><td colspan="12">Data not found</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="12"><div class="loading-indicator"></div></td></tr></tbody></table></div><div class="pull-right" st-pagination="" st-items-by-page="10" st-displayed-pages="5"></div><div class="form-group clearfix pull-right" style="padding-top:21px;"><label class="col-md-4" style="top:8px;">Show</label><div class="col-md-8"><ui-select ng-model="limit" lass="form-control" theme="bootstrap" ng-change="changeFilter();refreshTable(limit)" style="width: 73px;"><ui-select-match placeholder="Select">{{$select.selected}}</ui-select-match><ui-select-choices repeat="list in Limits | filter: $select.search"><div ng-bind-html="list | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/generalData/branch/form.html','<div class="row"><div class="col-md-12"><div class="panel"><div class="panel-heading panel-lia"><h3 class="panel-title">Branch - Form</h3><button type="button" class="toast-close-button" data-dismiss="dialog" ng-click="$close()"><span aria-hidden="true">&times;</span> <span class="sr-only">Close</span></button></div><div class="panel-body"><form class="form-horizontal" ng-submit="doSubmit();" name="formSubmit" novalidate=""><div class="form-group row clearfix"><label class="col-sm-3">Unit</label><div class="col-md-9"><div class="input-group"><ui-select ng-model="ui_select.unit" lass="form-control" theme="bootstrap" ng-disabled="!action.control" bs-validation="" required=""><ui-select-match placeholder="Select Unit">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="list in listUnit | filter: $select.search"><div ng-bind-html="list.name| highlight: $select.search"></div></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="getUnit()" ng-disabled="!action.control"><i class="glyphicon glyphicon-refresh blue" ng-class="{\'gly-spin\':spinUnit==true}"></i></button></span></div></div></div><div class="form-group row cleafix"><label class="col-sm-3">Code</label><div class="col-md-9"><input type="text" class="form-control" ng-model="form.code" ng-readonly="!action.control" required=""></div></div><div class="form-group row cleafix"><label class="col-sm-3">Name</label><div class="col-md-9"><input type="text" class="form-control" ng-model="form.name" ng-readonly="!action.control" required=""></div></div><div class="form-group row cleafix"><label class="col-sm-3">Head Office</label><div class="col-md-9"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="form.head_office" bs-no-validation=""> <span style="padding-top:9px;"></span></label></div></div><div class="form-group row clearfix"><label class="col-sm-3">Address</label><div class="col-sm-9"><textarea class="form-control" ng-model="form.address" ng-readonly="!action.control" required=""></textarea></div></div><div class="form-group row clearfix"><label class="col-sm-4"></label><div class="col-md-8"><div ng-show="action.control"><button ng-disabled="loading" type="submit" class="btn btn-custom margin-left pull-right col-xs-6 col-md-3"><i class="fa fa-save"></i> Save</button> <button ng-disabled="loading" ng-show="!action.edit" type="button" class="btn btn-default pull-right col-xs-6 col-md-3" ng-click="$close()"><i class="fa fa-close"></i> Cancel</button> <button ng-click="behavior_view()" type="button" ng-show="action.edit" class="btn btn-default pull-right col-xs-6 col-md-3"><i class="fa fa-close"></i> Cancel</button></div><div ng-show="!action.control"><button ng-show="privileges.can_update" ng-disabled="loading" ng-click="behavior_edit();" type="button" class="btn btn-custom margin-left pull-right col-xs-6 col-md-3"><i class="fa fa-edit"></i> Edit</button> <button ng-disabled="loading" class="btn btn-default pull-right col-xs-6 col-md-3" type="button" ng-click="$close()"><i class="fa fa-arrow-left"></i> Close</button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/pages/generalData/branch/index.html','<div class="row" ng-init="getData()"><div class="col-md-12"><div class="panel"><div class="panel-heading"><h3 class="panel-title">{{privileges.can_read?privileges.menu_label+" - List":"403 Forbidden"}}</h3><content-top ng-if="privileges.can_read"></content-top></div><div class="panel-body" ng-if="privileges.can_read"><div class="btn-group"><button class="btn btn-custom example-responsive" ng-click="refreshTable()"><i class="glyphicon glyphicon-refresh" ng-class="spinReload==true?\'gly-spin\':\'\'"></i></button></div><div class="btn-group" ng-if="privileges.can_create"><button class="btn btn-custom btn-with-icon example-responsive" ng-click="showForm();behavior_add()"><i class="fa fa-file-text-o"></i> <span>Create</span></button></div><div class="btn-group" ng-if="privileges.can_delete"><button ng-show="(selected.length > 0)" ng-click="openDelete();" class="btn btn-danger btn-with-icon example-responsive"><i class="fa fa-trash"></i> <span>Delete</span></button></div><div class="pull-right"><span>Total Data : {{dataList.total_data}}</span></div><div st-table="dataList.data" st-pipe="callServer" st-safe-src="dataList.data"><div class="table-responsive"><table class="table table-hover table-bordered custom-table"><thead><tr class="sortable"><th class="v-align table-id" rowspan="2" st-sort="id">No</th><th class="wid44">Select</th><th st-sort="unit.name">Unit</th><th st-sort="code">Code</th><th st-sort="name">Name</th><th st-sort="head_office">Head Office</th></tr><tr><th row-select-all="dataList.data" selected="selected" ng-click="selectAll(dataList.data,\'id\')"></th><th><input st-search="unit.name" type="text" class="form-control custom-control" ng-model="unit" ng-change="changeFilter()"></th><th><input st-search="code" type="text" class="form-control custom-control" ng-model="code" ng-change="changeFilter()"></th><th><input st-search="name" type="text" class="form-control custom-control" ng-model="name" ng-change="changeFilter()"></th><th><select st-search="head_office" ng-model="head_office" ng-change="changeFilter()" class="form-control custom-control"><option value="">Show All</option><option value="1">Yes</option><option value="0">No</option></select></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="s in (results = dataList.data)" class="editable-row" context-menu="menuOptions" data-id="{{s.id}}" ng-class="$index %2 ==0?\'table-strip\':\' \'"><td ng-click="showForm();behavior_view();viewById(s.id);">{{((dataList.page-1)*limit)+$index+1}}</td><td row-select="s" ng-click="select(s.id)" class="v-align row-select"></td><td ng-click="showForm();behavior_view();viewById(s.id);">{{s.unit_name}}</td><td ng-click="showForm();behavior_view();viewById(s.id);">{{s.code}}</td><td ng-click="showForm();behavior_view();viewById(s.id);">{{s.name}}</td><td ng-click="showForm();behavior_view();viewById(s.id);">{{s.head_office ? \'Yes\' : \'No\'}}</td></tr><tr ng-if="results.length == 0"><td colspan="12">Data not found</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="12"><div class="loading-indicator"></div></td></tr></tbody></table></div><div class="pull-right" st-pagination="" st-items-by-page="10" st-displayed-pages="5"></div><div class="form-group clearfix pull-right" style="padding-top:21px;"><label class="col-md-4" style="top:8px;">Show</label><div class="col-md-8"><ui-select ng-model="limit" lass="form-control" theme="bootstrap" ng-change="changeFilter();refreshTable(limit)" style="width: 73px;"><ui-select-match placeholder="Select">{{$select.selected}}</ui-select-match><ui-select-choices repeat="list in Limits | filter: $select.search"><div ng-bind-html="list | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/generalData/enumeration/form.html','<div class="row"><div class="col-md-12"><div class="panel"><div class="panel-heading panel-lia"><h3 class="panel-title">Enumeration - Form</h3><button type="button" class="toast-close-button" data-dismiss="dialog" ng-click="$close()"><span aria-hidden="true">&times;</span> <span class="sr-only">Close</span></button></div><div class="panel-body"><form class="form-horizontal" ng-submit="doSubmit();" name="formSubmit" novalidate=""><div class="form-group row cleafix"><label class="col-sm-3">Key</label><div class="col-md-9"><input type="text" class="form-control" ng-model="form.key" ng-readonly="!action.control" required=""></div></div><div class="form-group row cleafix"><label class="col-sm-3">Value</label><div class="col-md-9"><input type="text" class="form-control" ng-model="form.value" ng-readonly="!action.control" required=""></div></div><div class="form-group row cleafix"><label class="col-sm-3">Enumeration Group</label><div class="col-md-9"><input type="text" class="form-control" ng-model="form.enumeration_group" ng-readonly="!action.control"></div></div><div class="form-group row clearfix"><label class="col-sm-4"></label><div class="col-md-8"><div ng-show="action.control"><button ng-disabled="loading" type="submit" class="btn btn-custom margin-left pull-right col-xs-6 col-md-3"><i class="fa fa-save"></i> Save</button> <button ng-disabled="loading" ng-show="!action.edit" type="button" class="btn btn-default pull-right col-xs-6 col-md-3" ng-click="$close()"><i class="fa fa-close"></i> Cancel</button> <button ng-click="behavior_view()" type="button" ng-show="action.edit" class="btn btn-default pull-right col-xs-6 col-md-3"><i class="fa fa-close"></i> Cancel</button></div><div ng-show="!action.control"><button ng-show="privileges.can_update" ng-disabled="loading" ng-click="behavior_edit();" type="button" class="btn btn-custom margin-left pull-right col-xs-6 col-md-3"><i class="fa fa-edit"></i> Edit</button> <button ng-disabled="loading" class="btn btn-default pull-right col-xs-6 col-md-3" type="button" ng-click="$close()"><i class="fa fa-arrow-left"></i> Close</button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/pages/generalData/enumeration/index.html','<div class="row" ng-init="getData()"><div class="col-md-12"><div class="panel"><div class="panel-heading"><h3 class="panel-title">{{privileges.can_read?privileges.menu_label+" - List":"403 Forbidden"}}</h3><content-top ng-if="privileges.can_read"></content-top></div><div class="panel-body" ng-if="privileges.can_read"><div class="btn-group"><button class="btn btn-custom example-responsive" ng-click="refreshTable()"><i class="glyphicon glyphicon-refresh" ng-class="spinReload==true?\'gly-spin\':\'\'"></i></button></div><div class="btn-group" ng-if="privileges.can_create"><button class="btn btn-custom btn-with-icon example-responsive" ng-click="showForm();behavior_add()"><i class="fa fa-file-text-o"></i> <span>Create</span></button></div><div class="btn-group" ng-if="privileges.can_delete"><button ng-show="(selected.length > 0)" ng-click="openDelete();" class="btn btn-danger btn-with-icon example-responsive"><i class="fa fa-trash"></i> <span>Delete</span></button></div><div class="pull-right"><span>Total Data : {{dataList.total_data}}</span></div><div st-table="dataList.data" st-pipe="callServer" st-safe-src="dataList.data"><div class="table-responsive"><table class="table table-hover table-bordered custom-table"><thead><tr class="sortable"><th class="v-align table-id" rowspan="2" st-sort="id">No</th><th class="wid44">Select</th><th st-sort="key">Key</th><th st-sort="value">Value</th><th st-sort="enumeration_group">Enumeration Group</th></tr><tr><th row-select-all="dataList.data" selected="selected" ng-click="selectAll(dataList.data,\'id\')"></th><th><input st-search="key" type="text" class="form-control custom-control" ng-model="key" ng-change="changeFilter()"></th><th><input st-search="value" type="text" class="form-control custom-control" ng-model="value" ng-change="changeFilter()"></th><th><input st-search="enumeration_group" type="text" class="form-control custom-control" ng-model="enumeration_group" ng-change="changeFilter()"></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="s in (results = dataList.data)" class="editable-row" context-menu="menuOptions" data-id="{{s.id}}" ng-class="$index %2 ==0?\'table-strip\':\' \'"><td ng-click="showForm();behavior_view();viewById(s.id);">{{((dataList.page-1)*limit)+$index+1}}</td><td row-select="s" ng-click="select(s.id)" class="v-align row-select"></td><td ng-click="showForm();behavior_view();viewById(s.id);">{{s.key}}</td><td ng-click="showForm();behavior_view();viewById(s.id);">{{s.value}}</td><td ng-click="showForm();behavior_view();viewById(s.id);">{{s.enumeration_group}}</td></tr><tr ng-if="results.length == 0"><td colspan="12">Data not found</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="12"><div class="loading-indicator"></div></td></tr></tbody></table></div><div class="pull-right" st-pagination="" st-items-by-page="10" st-displayed-pages="5"></div><div class="form-group clearfix pull-right" style="padding-top:21px;"><label class="col-md-4" style="top:8px;">Show</label><div class="col-md-8"><ui-select ng-model="limit" lass="form-control" theme="bootstrap" ng-change="changeFilter();refreshTable(limit)" style="width: 73px;"><ui-select-match placeholder="Select">{{$select.selected}}</ui-select-match><ui-select-choices repeat="list in Limits | filter: $select.search"><div ng-bind-html="list | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/userManagement/application/form.html','<div class="row"><div class="col-md-12"><div class="panel"><div class="panel-heading panel-lia"><h3 class="panel-title">Application - Form</h3><button type="button" class="toast-close-button" data-dismiss="dialog" ng-click="$close()"><span aria-hidden="true">&times;</span> <span class="sr-only">Close</span></button></div><div class="panel-body"><form class="form-horizontal" ng-submit="doSubmit();" name="formSubmit" novalidate=""><div class="form-group row cleafix"><label class="col-sm-3">Name</label><div class="col-md-9"><input type="text" class="form-control" ng-model="form.name" ng-readonly="!action.control" required=""></div></div><div class="form-group row cleafix"><label class="col-sm-3">Application Id</label><div class="col-md-9"><input type="text" class="form-control" ng-model="form.application_id" ng-readonly="!action.control" required=""></div></div><div class="form-group row cleafix"><label class="col-sm-3">Url</label><div class="col-md-9"><input type="text" class="form-control" ng-model="form.url" ng-readonly="!action.control" required=""></div></div><div class="form-group row cleafix"><label class="col-sm-3">Welcome Api</label><div class="col-md-9"><input type="text" class="form-control" ng-model="form.welcome_api" ng-readonly="!action.control"></div></div><div class="form-group row clearfix"><label class="col-sm-4"></label><div class="col-md-8"><div ng-show="action.control"><button ng-disabled="loading" type="submit" class="btn btn-custom margin-left pull-right col-xs-6 col-md-3"><i class="fa fa-save"></i> Save</button> <button ng-disabled="loading" ng-show="!action.edit" type="button" class="btn btn-default pull-right col-xs-6 col-md-3" ng-click="$close()"><i class="fa fa-close"></i> Cancel</button> <button ng-click="behavior_view()" type="button" ng-show="action.edit" class="btn btn-default pull-right col-xs-6 col-md-3"><i class="fa fa-close"></i> Cancel</button></div><div ng-show="!action.control"><button ng-show="privileges.can_update" ng-disabled="loading" ng-click="behavior_edit();" type="button" class="btn btn-custom margin-left pull-right col-xs-6 col-md-3"><i class="fa fa-edit"></i> Edit</button> <button ng-disabled="loading" class="btn btn-default pull-right col-xs-6 col-md-3" type="button" ng-click="$close()"><i class="fa fa-arrow-left"></i> Close</button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/pages/userManagement/application/index.html','<div class="row" ng-init="getData()"><div class="col-md-12"><div class="panel"><div class="panel-heading"><h3 class="panel-title">{{privileges.can_read?privileges.menu_label+" - List":"403 Forbidden"}}</h3><content-top ng-if="privileges.can_read"></content-top></div><div class="panel-body" ng-if="privileges.can_read"><div class="btn-group"><button class="btn btn-custom example-responsive" ng-click="refreshTable()"><i class="glyphicon glyphicon-refresh" ng-class="spinReload==true?\'gly-spin\':\'\'"></i></button></div><div class="btn-group" ng-if="privileges.can_create"><button class="btn btn-custom btn-with-icon example-responsive" ng-click="showForm();behavior_add()"><i class="fa fa-file-text-o"></i> <span>Create</span></button></div><div class="btn-group" ng-if="privileges.can_delete"><button ng-show="(selected.length > 0)" ng-click="openDelete();" class="btn btn-danger btn-with-icon example-responsive"><i class="fa fa-trash"></i> <span>Delete</span></button></div><div class="pull-right"><span>Total Data : {{dataList.total_data}}</span></div><div st-table="dataList.data" st-pipe="callServer" st-safe-src="dataList.data"><div class="table-responsive"><table class="table table-hover table-bordered custom-table"><thead><tr class="sortable"><th class="v-align table-id" rowspan="2" st-sort="id">No</th><th class="wid44">Select</th><th st-sort="name">Name</th><th st-sort="application_id">Application Id</th><th st-sort="url">Url</th><th st-sort="welcome_api">Welcome API</th></tr><tr><th row-select-all="dataList.data" selected="selected" ng-click="selectAll(dataList.data,\'id\')"></th><th><input st-search="name" type="text" class="form-control custom-control" ng-model="unit" ng-change="changeFilter()"></th><th><input st-search="application_id" type="text" class="form-control custom-control" ng-model="application_id" ng-change="changeFilter()"></th><th><input st-search="url" type="text" class="form-control custom-control" ng-model="name" ng-change="changeFilter()"></th><th><input st-search="welcome_api" type="text" class="form-control custom-control" ng-model="parent" ng-change="changeFilter()"></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="s in (results = dataList.data)" class="editable-row" context-menu="menuOptions" data-id="{{s.id}}" ng-class="$index %2 ==0?\'table-strip\':\' \'"><td ng-click="showForm();behavior_view();viewById(s.id);">{{((dataList.page-1)*limit)+$index+1}}</td><td row-select="s" ng-click="select(s.id)" class="v-align row-select"></td><td ng-click="showForm();behavior_view();viewById(s.id);">{{s.name}}</td><td ng-click="showForm();behavior_view();viewById(s.id);">{{s.application_id}}</td><td ng-click="showForm();behavior_view();viewById(s.id);">{{s.url}}</td><td ng-click="showForm();behavior_view();viewById(s.id);">{{s.welcome_api}}</td></tr><tr ng-if="results.length == 0"><td colspan="12">Data not found</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="12"><div class="loading-indicator"></div></td></tr></tbody></table></div><div class="pull-right" st-pagination="" st-items-by-page="10" st-displayed-pages="5"></div><div class="form-group clearfix pull-right" style="padding-top:21px;"><label class="col-md-4" style="top:8px;">Show</label><div class="col-md-8"><ui-select ng-model="limit" lass="form-control" theme="bootstrap" ng-change="changeFilter();refreshTable(limit)" style="width: 73px;"><ui-select-match placeholder="Select">{{$select.selected}}</ui-select-match><ui-select-choices repeat="list in Limits | filter: $select.search"><div ng-bind-html="list | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/generalData/unit/form.html','<div class="row"><div class="col-md-12"><div class="panel"><div class="panel-heading panel-lia"><h3 class="panel-title">Unit - Form</h3><button type="button" class="toast-close-button" data-dismiss="dialog" ng-click="$close()"><span aria-hidden="true">&times;</span> <span class="sr-only">Close</span></button></div><div class="panel-body"><form class="form-horizontal" ng-submit="doSubmit();" name="formSubmit" novalidate=""><div class="form-group row cleafix"><label class="col-sm-3">Code</label><div class="col-md-9"><input type="text" class="form-control" ng-model="form.code" ng-readonly="!action.control" required=""></div></div><div class="form-group row cleafix"><label class="col-sm-3">Name</label><div class="col-md-9"><input type="text" class="form-control" ng-model="form.name" ng-readonly="!action.control" required=""></div></div><div class="form-group row clearfix"><label class="col-sm-4"></label><div class="col-md-8"><div ng-show="action.control"><button ng-disabled="loading" type="submit" class="btn btn-custom margin-left pull-right col-xs-6 col-md-3"><i class="fa fa-save"></i> Save</button> <button ng-disabled="loading" ng-show="!action.edit" type="button" class="btn btn-default pull-right col-xs-6 col-md-3" ng-click="$close()"><i class="fa fa-close"></i> Cancel</button> <button ng-click="behavior_view()" type="button" ng-show="action.edit" class="btn btn-default pull-right col-xs-6 col-md-3"><i class="fa fa-close"></i> Cancel</button></div><div ng-show="!action.control"><button ng-show="privileges.can_update" ng-disabled="loading" ng-click="behavior_edit();" type="button" class="btn btn-custom margin-left pull-right col-xs-6 col-md-3"><i class="fa fa-edit"></i> Edit</button> <button ng-disabled="loading" class="btn btn-default pull-right col-xs-6 col-md-3" type="button" ng-click="$close()"><i class="fa fa-arrow-left"></i> Close</button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/pages/generalData/unit/index.html','<div class="row" ng-init="getData()"><div class="col-md-12"><div class="panel"><div class="panel-heading"><h3 class="panel-title">{{privileges.can_read?privileges.menu_label+" - List":"403 Forbidden"}}</h3><content-top ng-if="privileges.can_read"></content-top></div><div class="panel-body" ng-if="privileges.can_read"><div class="btn-group"><button class="btn btn-custom example-responsive" ng-click="refreshTable()"><i class="glyphicon glyphicon-refresh" ng-class="spinReload==true?\'gly-spin\':\'\'"></i></button></div><div class="btn-group" ng-if="privileges.can_create"><button class="btn btn-custom btn-with-icon example-responsive" ng-click="showForm();behavior_add()"><i class="fa fa-file-text-o"></i> <span>Create</span></button></div><div class="btn-group" ng-if="privileges.can_delete"><button ng-show="(selected.length > 0)" ng-click="openDelete();" class="btn btn-danger btn-with-icon example-responsive"><i class="fa fa-trash"></i> <span>Delete</span></button></div><div class="pull-right"><span>Total Data : {{dataList.total_data}}</span></div><div st-table="dataList.data" st-pipe="callServer" st-safe-src="dataList.data"><div class="table-responsive"><table class="table table-hover table-bordered custom-table"><thead><tr class="sortable"><th class="v-align table-id" rowspan="2" st-sort="id">No</th><th class="wid44">Select</th><th st-sort="code">Code</th><th st-sort="name">Name</th></tr><tr><th row-select-all="dataList.data" selected="selected" ng-click="selectAll(dataList.data,\'id\')"></th><th><input st-search="code" type="text" class="form-control custom-control" ng-model="code" ng-change="changeFilter()"></th><th><input st-search="name" type="text" class="form-control custom-control" ng-model="name" ng-change="changeFilter()"></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="s in (results = dataList.data)" class="editable-row" context-menu="menuOptions" data-id="{{s.id}}" ng-class="$index %2 ==0?\'table-strip\':\' \'"><td ng-click="showForm();behavior_view();viewById(s.id);">{{((dataList.page-1)*limit)+$index+1}}</td><td row-select="s" ng-click="select(s.id)" class="v-align row-select"></td><td ng-click="showForm();behavior_view();viewById(s.id);">{{s.code}}</td><td ng-click="showForm();behavior_view();viewById(s.id);">{{s.name}}</td></tr><tr ng-if="results.length == 0"><td colspan="12">Data not found</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="12"><div class="loading-indicator"></div></td></tr></tbody></table></div><div class="pull-right" st-pagination="" st-items-by-page="10" st-displayed-pages="5"></div><div class="form-group clearfix pull-right" style="padding-top:21px;"><label class="col-md-4" style="top:8px;">Show</label><div class="col-md-8"><ui-select ng-model="limit" lass="form-control" theme="bootstrap" ng-change="changeFilter();refreshTable(limit)" style="width: 73px;"><ui-select-match placeholder="Select">{{$select.selected}}</ui-select-match><ui-select-choices repeat="list in Limits | filter: $select.search"><div ng-bind-html="list | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/userManagement/role/form.html','<div class="row"><div class="col-md-12"><div class="panel"><div class="panel-heading panel-lia"><h3 class="panel-title">Role - Form</h3><button type="button" class="toast-close-button" data-dismiss="dialog" ng-click="$close()"><span aria-hidden="true">&times;</span> <span class="sr-only">Close</span></button></div><div class="panel-body"><form class="form-horizontal" ng-submit="doSubmit();" name="formSubmit" novalidate=""><div class="form-group row clearfix"><label class="col-sm-3">Unit</label><div class="col-md-9"><div class="input-group"><ui-select ng-model="ui_select.unit" lass="form-control" theme="bootstrap" ng-change="getParent(ui_select.unit.id)" ng-disabled="!action.control" bs-validation="" required=""><ui-select-match placeholder="Select Unit">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="list in listUnit | filter: $select.search"><div ng-bind-html="list.name| highlight: $select.search"></div></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="getUnit()" ng-disabled="!action.control"><i class="glyphicon glyphicon-refresh blue" ng-class="{\'gly-spin\':spinUnit==true}"></i></button></span></div></div></div><div class="form-group row cleafix"><label class="col-sm-3">Abbreviation</label><div class="col-md-9"><input type="text" class="form-control" ng-model="form.abbreviation" ng-readonly="!action.control" required=""></div></div><div class="form-group row cleafix"><label class="col-sm-3">Name</label><div class="col-md-9"><input type="text" class="form-control" ng-model="form.name" ng-readonly="!action.control" required=""></div></div><div class="form-group row clearfix"><label class="col-sm-3">Parent Role</label><div class="col-md-9"><div class="input-group"><ui-select ng-model="ui_select.parent" lass="form-control" theme="bootstrap" ng-disabled="!action.control || ui_select.unit.id == undefined"><ui-select-match placeholder="Select Parent">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="list in listParent | filter: $select.search"><div ng-bind-html="list.name| highlight: $select.search"></div></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="getParent(ui_select.unit.id)" ng-disabled="!action.control || ui_select.unit.id == undefined"><i class="glyphicon glyphicon-refresh blue" ng-class="{\'gly-spin\':spinParent==true}"></i></button></span></div></div></div><div class="form-group row clearfix"><label class="col-sm-4"></label><div class="col-md-8"><div ng-show="action.control"><button ng-disabled="loading" type="submit" class="btn btn-custom margin-left pull-right col-xs-6 col-md-3"><i class="fa fa-save"></i> Save</button> <button ng-disabled="loading" ng-show="!action.edit" type="button" class="btn btn-default pull-right col-xs-6 col-md-3" ng-click="$close()"><i class="fa fa-close"></i> Cancel</button> <button ng-click="behavior_view()" type="button" ng-show="action.edit" class="btn btn-default pull-right col-xs-6 col-md-3"><i class="fa fa-close"></i> Cancel</button></div><div ng-show="!action.control"><button ng-show="privileges.can_update" ng-disabled="loading" ng-click="behavior_edit();" type="button" class="btn btn-custom margin-left pull-right col-xs-6 col-md-3"><i class="fa fa-edit"></i> Edit</button> <button ng-disabled="loading" class="btn btn-default pull-right col-xs-6 col-md-3" type="button" ng-click="$close()"><i class="fa fa-arrow-left"></i> Close</button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/pages/userManagement/role/index.html','<div class="row" ng-init="getData()"><div class="col-md-12"><div class="panel"><div class="panel-heading"><h3 class="panel-title">{{privileges.can_read?privileges.menu_label+" - List":"403 Forbidden"}}</h3><content-top ng-if="privileges.can_read"></content-top></div><div class="panel-body" ng-if="privileges.can_read"><div class="btn-group"><button class="btn btn-custom example-responsive" ng-click="refreshTable()"><i class="glyphicon glyphicon-refresh" ng-class="spinReload==true?\'gly-spin\':\'\'"></i></button></div><div class="btn-group" ng-if="privileges.can_create"><button class="btn btn-custom btn-with-icon example-responsive" ng-click="showForm();behavior_add()"><i class="fa fa-file-text-o"></i> <span>Create</span></button></div><div class="btn-group" ng-if="privileges.can_delete"><button ng-show="(selected.length > 0)" ng-click="openDelete();" class="btn btn-danger btn-with-icon example-responsive"><i class="fa fa-trash"></i> <span>Delete</span></button></div><div class="pull-right"><span>Total Data : {{dataList.total_data}}</span></div><div st-table="dataList.data" st-pipe="callServer" st-safe-src="dataList.data"><div class="table-responsive"><table class="table table-hover table-bordered custom-table"><thead><tr class="sortable"><th class="v-align table-id" rowspan="2" st-sort="id">No</th><th class="wid44">Select</th><th st-sort="unit_name">Unit</th><th st-sort="abbreviation">Abbreviation</th><th st-sort="name">Name</th><th st-sort="parent.name">Parent Role</th></tr><tr><th row-select-all="dataList.data" selected="selected" ng-click="selectAll(dataList.data,\'id\')"></th><th><input st-search="unit_name" type="text" class="form-control custom-control" ng-model="unit" ng-change="changeFilter()"></th><th><input st-search="abbreviation" type="text" class="form-control custom-control" ng-model="abbreviation" ng-change="changeFilter()"></th><th><input st-search="name" type="text" class="form-control custom-control" ng-model="name" ng-change="changeFilter()"></th><th><input st-search="parent.name" type="text" class="form-control custom-control" ng-model="parent" ng-change="changeFilter()"></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="s in (results = dataList.data)" class="editable-row" context-menu="menuOptions" data-id="{{s.id}}" ng-class="$index %2 ==0?\'table-strip\':\' \'"><td ng-click="showForm();behavior_view();viewById(s.id);">{{((dataList.page-1)*limit)+$index+1}}</td><td row-select="s" ng-click="select(s.id)" class="v-align row-select"></td><td ng-click="showForm();behavior_view();viewById(s.id);">{{s.unit_name}}</td><td ng-click="showForm();behavior_view();viewById(s.id);">{{s.abbreviation}}</td><td ng-click="showForm();behavior_view();viewById(s.id);">{{s.name}}</td><td ng-click="showForm();behavior_view();viewById(s.id);">{{s.parent.name}}</td></tr><tr ng-if="results.length == 0"><td colspan="12">Data not found</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="12"><div class="loading-indicator"></div></td></tr></tbody></table></div><div class="pull-right" st-pagination="" st-items-by-page="10" st-displayed-pages="5"></div><div class="form-group clearfix pull-right" style="padding-top:21px;"><label class="col-md-4" style="top:8px;">Show</label><div class="col-md-8"><ui-select ng-model="limit" lass="form-control" theme="bootstrap" ng-change="changeFilter();refreshTable(limit)" style="width: 73px;"><ui-select-match placeholder="Select">{{$select.selected}}</ui-select-match><ui-select-choices repeat="list in Limits | filter: $select.search"><div ng-bind-html="list | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div></div></div></div></div>');}]);